export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  HoltkampScore: { input: any; output: any; }
  LaunchDarklyUserContext: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AcceptanceDescription = {
  __typename?: 'AcceptanceDescription';
  reference?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type AcceptanceReport = AssignableInterface & DocumentInterface & RemovableInterface & {
  __typename?: 'AcceptanceReport';
  acceptance: Scalars['Boolean']['output'];
  acceptanceDescription?: Maybe<AcceptanceDescription>;
  addedBy: User;
  alias?: Maybe<Scalars['String']['output']>;
  /** Used for attaching defects and does not affect images from image gallery */
  attachImagesToPdf: Scalars['Boolean']['output'];
  attendees: Array<AcceptanceReportAttendee>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientNameComputed?: Maybe<Scalars['String']['output']>;
  clientReference?: Maybe<Scalars['String']['output']>;
  contractor: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  defect?: Maybe<AcceptanceReportDefect>;
  description?: Maybe<Scalars['String']['output']>;
  draftProjectNumber?: Maybe<Scalars['String']['output']>;
  hasDefect: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<AcceptanceReportImageWithLabel>;
  /** Logs of the acceptance report */
  logs?: Maybe<Logs>;
  manualPdfPath?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  no: Scalars['Int']['output'];
  noComputed: Scalars['String']['output'];
  pdfPath: Scalars['String']['output'];
  professions?: Maybe<Array<Scalars['String']['output']>>;
  project: Project;
  projectName: Scalars['String']['output'];
  projectNumberComputed?: Maybe<Scalars['String']['output']>;
  signatures: Array<AcceptanceReportSignature>;
  status: AcceptanceReportStatus;
  updatedAt: Scalars['Date']['output'];
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanAssign: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanRemoveManualPdf: Scalars['Boolean']['output'];
  viewerCanSendExternalLink: Scalars['Boolean']['output'];
  viewerCanSign: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanUploadManualPdf: Scalars['Boolean']['output'];
};


export type AcceptanceReportLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AcceptanceReportArchivedLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'AcceptanceReportArchivedLog';
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export type AcceptanceReportAssignedToProjectLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'AcceptanceReportAssignedToProjectLog';
  /** ID of the acceptanceReport */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportAssignedToProjectLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptanceReport */
  name: Scalars['String']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** name of the project */
  projectName: Scalars['String']['output'];
};

export type AcceptanceReportAttendee = {
  __typename?: 'AcceptanceReportAttendee';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['String']['output']>;
  role: AcceptanceReportAttendeeRole;
};

export enum AcceptanceReportAttendeeRole {
  Client = 'CLIENT',
  HeinrichSchmid = 'HEINRICH_SCHMID',
  Other = 'OTHER'
}

export type AcceptanceReportAttendeeSaveInput = {
  fullName: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  role: AcceptanceReportAttendeeRole;
};

export type AcceptanceReportCreatedLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'AcceptanceReportCreatedLog';
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export type AcceptanceReportDefect = {
  __typename?: 'AcceptanceReportDefect';
  agreed: Scalars['Boolean']['output'];
  correction?: Maybe<AcceptanceReportDefectCorrection>;
  /** @deprecated Use warranty.startDate instead. Will be removed on 01.04.2026 */
  dueDate?: Maybe<Scalars['Date']['output']>;
  metaData?: Maybe<Array<AcceptanceReportDefectMeta>>;
  /** @deprecated Use warranty.note instead. Will be removed on 01.04.2026 */
  note?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  warranty?: Maybe<AcceptanceReportDefectWarranty>;
};

export type AcceptanceReportDefectCorrection = {
  __typename?: 'AcceptanceReportDefectCorrection';
  dueDate: Scalars['Date']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type AcceptanceReportDefectCorrectionSaveInput = {
  dueDate: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptanceReportDefectMeta = {
  __typename?: 'AcceptanceReportDefectMeta';
  agreed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  image?: Maybe<AcceptanceReportImage>;
};

export type AcceptanceReportDefectMetaSaveInput = {
  description: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptanceReportDefectSaveInput = {
  agreed: Scalars['Boolean']['input'];
  correction?: InputMaybe<AcceptanceReportDefectCorrectionSaveInput>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  metaData?: InputMaybe<Array<AcceptanceReportDefectMetaSaveInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  warranty?: InputMaybe<AcceptanceReportDefectWarrantySaveInput>;
};

export type AcceptanceReportDefectWarranty = {
  __typename?: 'AcceptanceReportDefectWarranty';
  note?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type AcceptanceReportDefectWarrantySaveInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type AcceptanceReportDeletedLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'AcceptanceReportDeletedLog';
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export type AcceptanceReportDescriptionSaveInput = {
  reference?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptanceReportEmailSentLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & LogWithEmail & {
  __typename?: 'AcceptanceReportEmailSentLog';
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the acceptance report sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that acceptance report sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the AcceptanceReportEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export type AcceptanceReportExternalEmailSentLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & LogWithEmail & {
  __typename?: 'AcceptanceReportExternalEmailSentLog';
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the acceptance report sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that acceptance report sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the AcceptanceReportExternalEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export type AcceptanceReportExternalLinkExpiredLog = AcceptanceReportLog & Log & LogWithDate & {
  __typename?: 'AcceptanceReportExternalLinkExpiredLog';
  /** ID of the acceptanceReport */
  acceptanceReportId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** Expired date of the acceptance report external link in ISO-8601 format */
  expiredDate: Scalars['Date']['output'];
  /** ID of the AcceptanceReportExternalLinkExpiredLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptanceReport */
  name: Scalars['String']['output'];
};

export type AcceptanceReportExternalSignatureUploadInput = {
  acceptanceReportId: Scalars['ID']['input'];
  fullName: Scalars['String']['input'];
};

export type AcceptanceReportImage = {
  __typename?: 'AcceptanceReportImage';
  id: Scalars['ID']['output'];
  thumbnail: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type AcceptanceReportImageThumbnailArgs = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type AcceptanceReportImageInput = {
  imageId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptanceReportImageWithLabel = {
  __typename?: 'AcceptanceReportImageWithLabel';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  thumbnail: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type AcceptanceReportImageWithLabelThumbnailArgs = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type AcceptanceReportLog = {
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export type AcceptanceReportManuallySignedDocumentDeletedLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'AcceptanceReportManuallySignedDocumentDeletedLog';
  /** ID of the acceptanceReport */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportManuallySignedDocumentDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptanceReport */
  name: Scalars['String']['output'];
};

export type AcceptanceReportManuallySignedLog = AcceptanceReportLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'AcceptanceReportManuallySignedLog';
  /** ID of the acceptanceReport */
  acceptanceReportId: Scalars['ID']['output'];
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportManuallySignedLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptanceReport */
  name: Scalars['String']['output'];
};

export type AcceptanceReportMeta = {
  __typename?: 'AcceptanceReportMeta';
  acceptance: Scalars['Boolean']['output'];
  defect?: Maybe<AcceptanceReportDefectMeta>;
  hasDefect: Scalars['Boolean']['output'];
};

export type AcceptanceReportNotSignedLog = AcceptanceReportLog & Log & LogWithDate & {
  __typename?: 'AcceptanceReportNotSignedLog';
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The day count of that document not signed */
  dayCount?: Maybe<Scalars['Int']['output']>;
  /** ID of the AcceptanceReportNotSignedLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export type AcceptanceReportPdfPath = {
  __typename?: 'AcceptanceReportPdfPath';
  acceptanceReportId: Scalars['ID']['output'];
  manualPdfPath?: Maybe<Scalars['String']['output']>;
  pdfPath?: Maybe<Scalars['String']['output']>;
};

export type AcceptanceReportSaveInput = {
  acceptance: Scalars['Boolean']['input'];
  acceptanceDescription?: InputMaybe<AcceptanceReportDescriptionSaveInput>;
  alias?: InputMaybe<Scalars['String']['input']>;
  attachImagesToPdf: Scalars['Boolean']['input'];
  attendees: Array<AcceptanceReportAttendeeSaveInput>;
  clientName: Scalars['String']['input'];
  clientReference?: InputMaybe<Scalars['String']['input']>;
  contractor: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  defect?: InputMaybe<AcceptanceReportDefectSaveInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  draftProjectNumber?: InputMaybe<Scalars['String']['input']>;
  hasDefect: Scalars['Boolean']['input'];
  images?: InputMaybe<Array<AcceptanceReportImageInput>>;
  professions?: InputMaybe<Array<Scalars['String']['input']>>;
  projectName: Scalars['String']['input'];
};

export type AcceptanceReportSignature = SignatureInterface & {
  __typename?: 'AcceptanceReportSignature';
  acceptanceReport: AcceptanceReport;
  createdAt: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imagePath: Scalars['String']['output'];
  type: AcceptanceReportSignatureType;
};

export enum AcceptanceReportSignatureType {
  Customer = 'CUSTOMER',
  HeinrichSchmid = 'HEINRICH_SCHMID'
}

export type AcceptanceReportSignedByCustomerLog = AcceptanceReportLog & Log & LogWithDate & {
  __typename?: 'AcceptanceReportSignedByCustomerLog';
  /** ID of the acceptance report */
  acceptanceReportId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the AcceptanceReportSignedByCustomerLog */
  id: Scalars['ID']['output'];
  /** Name of the acceptance report */
  name: Scalars['String']['output'];
};

export enum AcceptanceReportStatus {
  Archived = 'ARCHIVED',
  ManuallySigned = 'MANUALLY_SIGNED',
  Open = 'OPEN',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export enum ActivityType {
  FreeText = 'FREE_TEXT',
  Lv = 'LV',
  LvAuto = 'LV_AUTO'
}

export type AddBulkOperationToFolderInput = {
  /** ID of the folder. */
  folder: Scalars['ID']['input'];
  /** IDs of the catalogue operations */
  operations: Array<Scalars['ID']['input']>;
};

export type AddOperationToFolderInput = {
  /** Is this operation's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** Description of the operation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id of the category. */
  folder: Scalars['ID']['input'];
  /** Measurements of operation */
  measurements: Array<CreateMeasurementInput>;
  /** Name of the operation. */
  name: Scalars['String']['input'];
  /** Note for the operation */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Id of the operation. */
  operation?: InputMaybe<Scalars['ID']['input']>;
  /** Is this operation optional */
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  /** Operation payment input. Please send totalPrice flat is true, otherwise please send discount/surcharge value and type. If you do not have any price adjustment please do not send this input at all. */
  payment?: InputMaybe<OperationPaymentInput>;
  /** Price for the operation. */
  price: Scalars['Float']['input'];
  unit: OperationUnit;
};

export type ArchiveDriveBulkJob = DriveBulkJob & {
  __typename?: 'ArchiveDriveBulkJob';
  documents: Array<DriveDocument>;
  id: Scalars['ID']['output'];
  meta: ArchiveDriveBulkJobMeta;
  status: DriveBulkJobStatus;
};

export type ArchiveDriveBulkJobMeta = ArchiveMaxFileSizeExceededErrorMeta | ArchiveQueueMeta;

export type ArchiveDriveBulkJobMetaFailure = {
  __typename?: 'ArchiveDriveBulkJobMetaFailure';
  document: DriveDocument;
  reason: ArchiveDriveBulkJobMetaFailureReason;
  reasonDetail?: Maybe<Scalars['String']['output']>;
};

export enum ArchiveDriveBulkJobMetaFailureReason {
  InvalidCredentials = 'INVALID_CREDENTIALS',
  MaxFileSizeExceed = 'MAX_FILE_SIZE_EXCEED',
  ServerError = 'SERVER_ERROR'
}

export type ArchiveMaxFileSizeExceededErrorMeta = {
  __typename?: 'ArchiveMaxFileSizeExceededErrorMeta';
  actualSize: Scalars['Float']['output'];
  limit: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type ArchiveQueueMeta = {
  __typename?: 'ArchiveQueueMeta';
  failed: Array<ArchiveDriveBulkJobMetaFailure>;
  queue: Array<DriveDocument>;
  succeed: Array<DriveDocument>;
};

export type AssignDocumentToProjectInput = {
  id: Scalars['ID']['input'];
  project: Scalars['ID']['input'];
  type: DocumentType;
};

export type AssignOfferToProjectInput = {
  /** Id of the offer. */
  offer: Scalars['ID']['input'];
  /** Project ID that offer will be assigned to. */
  to: Scalars['ID']['input'];
};

export type AssignableInterface = {
  id: Scalars['ID']['output'];
  project: Project;
  viewerCanAssign: Scalars['Boolean']['output'];
};

export type BaseProject = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectNumber: Scalars['ID']['output'];
};

export type BonusCalculation = {
  __typename?: 'BonusCalculation';
  dobner?: Maybe<BonusCalculationDobner>;
  holtkamp?: Maybe<BonusCalculationHoltkamp>;
};

export type BonusCalculationDobner = {
  __typename?: 'BonusCalculationDobner';
  hourlyBonus?: Maybe<Scalars['Float']['output']>;
  partProjects?: Maybe<Array<Project>>;
  siteManagerRate?: Maybe<Scalars['Float']['output']>;
  siteManagers?: Maybe<Array<SivhsEmployee>>;
  version: Scalars['Int']['output'];
};

export type BonusCalculationDobnerSaveInput = {
  hourlyBonus?: InputMaybe<Scalars['Float']['input']>;
  partProjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
  siteManagerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteManagerRate?: InputMaybe<Scalars['Float']['input']>;
  version: Scalars['Int']['input'];
};

export type BonusCalculationHoltkamp = {
  __typename?: 'BonusCalculationHoltkamp';
  bonusAllowancePerHour?: Maybe<Scalars['Float']['output']>;
  bonusShare?: Maybe<Scalars['Float']['output']>;
  bonusSurplus?: Maybe<Scalars['Float']['output']>;
  employeeScores?: Maybe<Array<Maybe<BonusCalculationHoltkampEmployeeScore>>>;
  partProjects?: Maybe<Array<Project>>;
  siteManagerRate?: Maybe<Scalars['Float']['output']>;
  siteManagers?: Maybe<Array<SivhsEmployee>>;
  version: Scalars['Int']['output'];
};

export type BonusCalculationHoltkampEmployeeScore = {
  __typename?: 'BonusCalculationHoltkampEmployeeScore';
  collaborationScore?: Maybe<Scalars['HoltkampScore']['output']>;
  employeeId: Scalars['ID']['output'];
  engagementScore?: Maybe<Scalars['HoltkampScore']['output']>;
  project: Project;
  qsstScore?: Maybe<Scalars['HoltkampScore']['output']>;
  qualityDefectScore?: Maybe<Scalars['HoltkampScore']['output']>;
};

export type BonusCalculationHoltkampEmployeeScoreInput = {
  collaborationScore?: InputMaybe<Scalars['HoltkampScore']['input']>;
  employeeId: Scalars['ID']['input'];
  engagementScore?: InputMaybe<Scalars['HoltkampScore']['input']>;
  projectId: Scalars['ID']['input'];
  qsstScore?: InputMaybe<Scalars['HoltkampScore']['input']>;
  qualityDefectScore?: InputMaybe<Scalars['HoltkampScore']['input']>;
};

export type BonusCalculationHoltkampSaveInput = {
  bonusAllowancePerHour?: InputMaybe<Scalars['Float']['input']>;
  bonusShare?: InputMaybe<Scalars['Float']['input']>;
  bonusSurplus?: InputMaybe<Scalars['Float']['input']>;
  employeeScores?: InputMaybe<Array<BonusCalculationHoltkampEmployeeScoreInput>>;
  partProjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
  siteManagerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteManagerRate?: InputMaybe<Scalars['Float']['input']>;
  version: Scalars['Int']['input'];
};

/** Catalogue is the operation portfolio of user. */
export type Catalogue = {
  __typename?: 'Catalogue';
  /** All categories of catalogue in flat fashion. It contains all categories and sub categories in a single array. */
  allCategories: Array<Category>;
  /** Categories of the catalogue. */
  categories: Array<Category>;
  /** ID of the catalogue */
  id: Scalars['ID']['output'];
  /** Meta of the catalogue. */
  meta: CatalogueMeta;
  /** Name of the catalogue */
  name: Scalars['String']['output'];
  /** Offers of the catalogue */
  offers: Array<Offer>;
};


/** Catalogue is the operation portfolio of user. */
export type CatalogueOffersArgs = {
  limit?: Scalars['Float']['input'];
};

/** Count of offers that has relationship with this catalogue */
export type CatalogueMeta = {
  __typename?: 'CatalogueMeta';
  /** Count of parent offers */
  offerCount: Scalars['Int']['output'];
};

/** Category for the catalogue. */
export type Category = {
  __typename?: 'Category';
  /** Calculated part no of the category */
  calculatedPartNo: Scalars['String']['output'];
  /** Catalogue of the category. */
  catalogue: Catalogue;
  /** ID of the category */
  id: Scalars['ID']['output'];
  /** Name of the category */
  name?: Maybe<Scalars['String']['output']>;
  /** Operations for the category. */
  operations: Array<Operation>;
  /** Parent of the category. */
  parent?: Maybe<Category>;
  /** Part no of the category */
  partNo: Scalars['String']['output'];
  /** Subcategories the category. */
  subCategories: Array<Category>;
};


/** Category for the catalogue. */
export type CategoryOperationsArgs = {
  catalogue?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type ChildProjectRelations = {
  __typename?: 'ChildProjectRelations';
  mainProject: BaseProject;
  siblingPartProjects: Array<Maybe<BaseProject>>;
  siblingSubProjects: Array<Maybe<BaseProject>>;
};

export enum ChildProjectRelationsType {
  Part = 'PART',
  Sub = 'SUB'
}

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Scalars['String']['output']>;
  hsId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CloneFolderInput = {
  /** Is this folder's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the source. */
  from: Scalars['ID']['input'];
  /** Measurements of clone folder */
  measurements: Array<CreateMeasurementInput>;
  /** Name of the folder. */
  name: Scalars['String']['input'];
  /** Note for the clone folder */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<OperationUnit>;
};

export type CloneOperationInput = {
  /** Is this operation's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the operation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id of the source operation. */
  from: Scalars['ID']['input'];
  /** Measurements of clone operation */
  measurements: Array<CreateMeasurementInput>;
  /** Name of the operation. */
  name: Scalars['String']['input'];
  /** Note for the clone operation */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Is this operation optional */
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  /** Operation payment input. Please send totalPrice flat is true, otherwise please send discount/surcharge value and type. If you do not have any price adjustment please do not send this input at all. */
  payment?: InputMaybe<OperationPaymentInput>;
  /** Price for the operation. */
  price: Scalars['Float']['input'];
  unit: OperationUnit;
};

/** A concern. */
export type Concern = DocumentInterface & {
  __typename?: 'Concern';
  /** The user who is the owner of this concern */
  addedBy: User;
  /** Name of the client for the concern */
  clientName?: Maybe<Scalars['String']['output']>;
  /** contractor of the concern */
  contractor?: Maybe<Contractor>;
  /** Creation date of the concern */
  createdAt: Scalars['Date']['output'];
  /** Date of the concern */
  date?: Maybe<Scalars['Date']['output']>;
  /** End date of concern */
  endDate: Scalars['Date']['output'];
  /** execution of the concern */
  execution?: Maybe<Scalars['String']['output']>;
  /** ID of the concern */
  id: Scalars['ID']['output'];
  /** Images of the concern */
  images: Array<ConcernImage>;
  /** Logs of the concern */
  logs?: Maybe<Logs>;
  /** Name of the document */
  name: Scalars['String']['output'];
  /** Pdf path for the concern if it has been generated before */
  pdfPath?: Maybe<Scalars['String']['output']>;
  /** professions of the concern */
  professions?: Maybe<Array<Scalars['String']['output']>>;
  /** Project of the concern */
  project: Project;
  /** quality of the concern */
  quality?: Maybe<Array<Quality>>;
  /** Signatures of concern */
  signatures: Array<ConcernSignature>;
  /** Status of the concern */
  status: ConcernStatus;
  /** Updated date of the concern */
  updatedAt: Scalars['Date']['output'];
  /** Indicates whether the viewer can archive the concern */
  viewerCanArchive: Scalars['Boolean']['output'];
  /** Indicated whether the concern assignable to a project */
  viewerCanAssign: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can remove the concern */
  viewerCanRemove: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can sign the concern */
  viewerCanSign: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the concern */
  viewerCanUpdate: Scalars['Boolean']['output'];
};


/** A concern. */
export type ConcernLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ConcernArchiveInput = {
  /** Id of the concern. */
  documentId: Scalars['ID']['input'];
  /** SAP password */
  sapPassword: Scalars['String']['input'];
  /** SAP username */
  sapUsername: Scalars['String']['input'];
};

export type ConcernArchivedLog = ConcernLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'ConcernArchivedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the concern */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConcernArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the concern */
  name: Scalars['String']['output'];
};

export type ConcernAssignedToProjectLog = ConcernLog & Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ConcernAssignedToProjectLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the concern */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConcernAssignedToProjectLog */
  id: Scalars['ID']['output'];
  /** Name of the concern */
  name: Scalars['String']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** name of the project */
  projectName: Scalars['String']['output'];
};

export type ConcernCreatedLog = ConcernLog & Log & LogWithActor & LogWithDate & LogWithProjectContractDate & {
  __typename?: 'ConcernCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the concern */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConcernCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the concern */
  name: Scalars['String']['output'];
  /** Contract date of the project in ISO-8601 format */
  projectContractDate?: Maybe<Scalars['Date']['output']>;
};

export type ConcernDeletedLog = ConcernLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'ConcernDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the concern */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConcernDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the concern */
  name: Scalars['String']['output'];
};

export type ConcernDuplicateInput = {
  documentId: Scalars['ID']['input'];
};

export type ConcernEmailSentLog = ConcernLog & Log & LogWithActor & LogWithDate & LogWithEmail & {
  __typename?: 'ConcernEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the concern sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** ID of the concern */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that concern sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the ConcernEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the concern */
  name: Scalars['String']['output'];
};

/** An concern image */
export type ConcernImage = {
  __typename?: 'ConcernImage';
  /** ID of the image */
  id: Scalars['ID']['output'];
  /** Label of the image */
  label?: Maybe<Scalars['String']['output']>;
  /** Thumbnail of the image */
  thumbnail: Scalars['String']['output'];
  /** Full url of the image */
  url: Scalars['String']['output'];
};


/** An concern image */
export type ConcernImageThumbnailArgs = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type ConcernImageInput = {
  /** Id of the image. */
  imageId: Scalars['ID']['input'];
  /** Label for the image. */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ConcernLog = {
  /** ID of the concern */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConcernLog */
  id: Scalars['ID']['output'];
  /** Name of the concern */
  name: Scalars['String']['output'];
};

export type ConcernPdfEmailSendInput = {
  /** Carbon copies of the mail */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content of the email. */
  content: Scalars['String']['input'];
  /** Id of concern */
  documentId: Scalars['ID']['input'];
  /** Recipients of the email. */
  recipients: Array<Scalars['String']['input']>;
  /** Subject of the email. */
  subject: Scalars['String']['input'];
};

export type ConcernSaveInput = {
  /** Clientname of concern */
  clientName: Scalars['String']['input'];
  /** Contractor of concern */
  contractor?: InputMaybe<ContractorSaveInput>;
  /** Date of concern */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Document id for the concern */
  documentId: Scalars['ID']['input'];
  /** End date of concern */
  endDate: Scalars['Date']['input'];
  /** Execution of concern */
  execution?: InputMaybe<Scalars['String']['input']>;
  /** Images for the concern */
  images: Array<ConcernImageInput>;
  /** Professions of concern */
  professions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Quality of concern */
  quality?: InputMaybe<Array<QualitySaveInput>>;
};

export type ConcernSignInput = {
  /** ID of the concern */
  documentId: Scalars['ID']['input'];
  /** Full name of the signatory */
  fullName: Scalars['String']['input'];
  /** Image of the signature */
  image: Scalars['Upload']['input'];
};

export type ConcernSignature = {
  __typename?: 'ConcernSignature';
  /** Creation date of the signature */
  createdAt: Scalars['Date']['output'];
  /** Full name of the signatory */
  fullName: Scalars['String']['output'];
  /** Image path of the signature */
  imagePath: Scalars['String']['output'];
};

export type ConcernSignedLog = ConcernLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'ConcernSignedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the concern */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConcernSignedLog */
  id: Scalars['ID']['output'];
  /** Name of the concern */
  name: Scalars['String']['output'];
};

/** Concern status enum */
export enum ConcernStatus {
  Archived = 'ARCHIVED',
  Open = 'OPEN',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export type ConcernUpdatedLog = ConcernLog & Log & LogWithActor & LogWithDate & LogWithProjectContractDate & {
  __typename?: 'ConcernUpdatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the obstruction */
  concernId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConcernUpdatedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** Contract date of the project in ISO-8601 format */
  projectContractDate?: Maybe<Scalars['Date']['output']>;
};

export type ConstructionNote = AssignableInterface & DocumentInterface & RemovableInterface & {
  __typename?: 'ConstructionNote';
  /** The user who is owner of this construction note */
  addedBy: User;
  /** ID of the construction note */
  id: Scalars['ID']['output'];
  /** Logs of the construction note */
  logs?: Maybe<Logs>;
  /** Name of the construction note */
  name: Scalars['String']['output'];
  /** No of the construction note */
  no: Scalars['Int']['output'];
  /** Path of the asset. For free drawing notes, client needs to download the json file, and construct canvas with upcoming data. For other types, this link can be used directly to show asset */
  path: Scalars['String']['output'];
  /** Project of the construction note */
  project: Project;
  /** Status of construction note */
  status: ConstructionNoteStatus;
  /** Type of the construction note */
  type: ConstructionNoteType;
  /** Last modified date for the offer */
  updatedAt: Scalars['Date']['output'];
  /** Indicates whether the viewer can archive the construction note */
  viewerCanArchive: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can assign the construction note to a project */
  viewerCanAssign: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can remove the construction note */
  viewerCanRemove: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can rename the construction note */
  viewerCanRename: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the construction note */
  viewerCanUpdate: Scalars['Boolean']['output'];
};


export type ConstructionNoteLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ConstructionNoteArchivedLog = ConstructionNoteLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'ConstructionNoteArchivedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the construction note */
  constructionNoteId: Scalars['ID']['output'];
  /** Type of the construction note */
  constructionNoteType?: Maybe<ConstructionNoteType>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConstructionNoteArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the construction note */
  name: Scalars['String']['output'];
};

export type ConstructionNoteAssignedToProjectLog = ConstructionNoteLog & Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ConstructionNoteAssignedToProjectLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the construction note */
  constructionNoteId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConstructionNoteAssignedToProjectLog */
  id: Scalars['ID']['output'];
  /** Name of the construction note */
  name: Scalars['String']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** name of the project */
  projectName: Scalars['String']['output'];
};

export type ConstructionNoteCanvasUpdateInput = {
  /** Document ID of the construction note. */
  documentId: Scalars['ID']['input'];
};

export type ConstructionNoteCreateInput = {
  /** Document ID of the construction note. */
  documentId: Scalars['ID']['input'];
  /** Construction note name. */
  name: Scalars['String']['input'];
};

export type ConstructionNoteCreatedLog = ConstructionNoteLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'ConstructionNoteCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the construction note */
  constructionNoteId: Scalars['ID']['output'];
  /** Type of the construction note */
  constructionNoteType?: Maybe<ConstructionNoteType>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConstructionNoteCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the construction note */
  name: Scalars['String']['output'];
};

export type ConstructionNoteDeletedLog = ConstructionNoteLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'ConstructionNoteDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the construction note */
  constructionNoteId: Scalars['ID']['output'];
  /** Type of the construction note */
  constructionNoteType?: Maybe<ConstructionNoteType>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConstructionNoteDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the construction note */
  name: Scalars['String']['output'];
};

export type ConstructionNoteEmailSentLog = ConstructionNoteLog & Log & LogWithActor & LogWithDate & LogWithEmail & {
  __typename?: 'ConstructionNoteEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the construction note sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** ID of the construction note */
  constructionNoteId: Scalars['ID']['output'];
  /** Type of the construction note */
  constructionNoteType?: Maybe<ConstructionNoteType>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that constructin note sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the ConstructionNoteEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the construction note */
  name: Scalars['String']['output'];
};

export type ConstructionNoteLog = {
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the construction note */
  constructionNoteId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ConstructionNoteLog */
  id: Scalars['ID']['output'];
  /** Name of the construction note */
  name: Scalars['String']['output'];
};

/** Construction note status enum */
export enum ConstructionNoteStatus {
  Archived = 'ARCHIVED',
  Open = 'OPEN',
  Sent = 'SENT'
}

/** Construction note type enum */
export enum ConstructionNoteType {
  FreeDrawing = 'FREE_DRAWING',
  Image = 'IMAGE',
  Pdf = 'PDF'
}

export type ConstructionNoteUpdateInput = {
  /** Document ID of the construction note. */
  documentId: Scalars['ID']['input'];
  /** Construction note name. */
  name: Scalars['String']['input'];
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
  project: Project;
};

export type ContactPersonAddInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId: Scalars['ID']['input'];
};

export type ContactPersonRemoveInput = {
  id: Scalars['ID']['input'];
};

export type ContactPersonUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Contractor = {
  __typename?: 'Contractor';
  /** Description of contractor */
  description: Scalars['String']['output'];
  /** Name of contractor */
  name: Scalars['String']['output'];
};

export type ContractorSaveInput = {
  /** Description of contractor */
  description: Scalars['String']['input'];
  /** Name of contractor */
  name: Scalars['String']['input'];
};

export type CreateFolderForFrameworkInput = {
  /** Is this folder's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the catalogue category. */
  category: Scalars['ID']['input'];
  /** Measurements of folder */
  measurements: Array<CreateMeasurementInput>;
  /** Name of the folder. */
  name: Scalars['String']['input'];
  /** Note for the folder */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Id of the offer. */
  offer: Scalars['ID']['input'];
  /** Id of the parent folder. */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<OperationUnit>;
};

export type CreateFolderForFreeFormInput = {
  /** Is this folder's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Measurements of folder */
  measurements: Array<CreateMeasurementInput>;
  /** Name of the folder. */
  name: Scalars['String']['input'];
  /** Note for the folder */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Id of the offer. */
  offer: Scalars['ID']['input'];
  /** Id of the parent folder. */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<OperationUnit>;
};

export type CreateMeasurementInput = {
  meta: Array<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  /** Offer name. */
  name: Scalars['String']['input'];
  /** Is subtraction enabled */
  subtraction: Scalars['Boolean']['input'];
  /** Total measurement */
  total: Scalars['Float']['input'];
  /** Total measurement meta for the operation. */
  totalMeta: Scalars['String']['input'];
};

export type CreateOperationInput = {
  /** Id of the category. */
  category: Scalars['ID']['input'];
  /** Description of the operation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the operation. */
  name: Scalars['String']['input'];
  /** Price for the operation. */
  price: Scalars['Float']['input'];
  unit: OperationUnit;
};

export type CustomFile = {
  __typename?: 'CustomFile';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Logs of the custom file */
  logs?: Maybe<Logs>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  no: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};


export type CustomFileLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomFileArchivedLog = CustomFileLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'CustomFileArchivedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The folder ID the document */
  folderId?: Maybe<Scalars['ID']['output']>;
  /** The folder Name the document */
  folderName?: Maybe<Scalars['String']['output']>;
  /** ID of the CustomFileArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the custom file */
  name: Scalars['String']['output'];
  /** The project ID the document */
  projectId: Scalars['ID']['output'];
};

export type CustomFileCreatedLog = CustomFileLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'CustomFileCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The folder ID the document */
  folderId?: Maybe<Scalars['ID']['output']>;
  /** The folder Name the document */
  folderName?: Maybe<Scalars['String']['output']>;
  /** ID of the CustomFileCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the custom file */
  name: Scalars['String']['output'];
  /** The project ID the document */
  projectId: Scalars['ID']['output'];
  /** The source of the document */
  source: CustomFileSource;
};

export type CustomFileDeletedLog = CustomFileLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'CustomFileDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The folder ID the document */
  folderId?: Maybe<Scalars['ID']['output']>;
  /** The folder Name the document */
  folderName?: Maybe<Scalars['String']['output']>;
  /** ID of the CustomFileDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the custom file */
  name: Scalars['String']['output'];
  /** The project ID the document */
  projectId: Scalars['ID']['output'];
};

export type CustomFileDuplicatedForManipulationLog = CustomFileLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'CustomFileDuplicatedForManipulationLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** Original custom file's name */
  duplicatedFromName: Scalars['String']['output'];
  /** The folder ID the document */
  folderId: Scalars['ID']['output'];
  /** The folder Name the document */
  folderName: Scalars['String']['output'];
  /** ID of the CustomFileDuplicatedForManipulationLog */
  id: Scalars['ID']['output'];
  /** Name of the custom file */
  name: Scalars['String']['output'];
  /** The project ID the document */
  projectId: Scalars['ID']['output'];
};

export type CustomFileEmailSendInput = {
  /** Carbon copies of the mail */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content of the email. */
  content: Scalars['String']['input'];
  /** Id of the custom file. */
  id: Scalars['ID']['input'];
  /** Recipients of the email. */
  recipients: Array<Scalars['String']['input']>;
  /** Subject of the email. */
  subject: Scalars['String']['input'];
};

export type CustomFileEmailSentLog = CustomFileLog & Log & LogWithActor & LogWithDate & LogWithEmail & {
  __typename?: 'CustomFileEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the custom file sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that customFile sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the CustomFileEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the custom file */
  name: Scalars['String']['output'];
};

export type CustomFileLog = {
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the CustomFileLog */
  id: Scalars['ID']['output'];
  /** Name of the custom file */
  name: Scalars['String']['output'];
};

export type CustomFileManipulatedLog = CustomFileLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'CustomFileManipulatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The folder ID the document */
  folderId: Scalars['ID']['output'];
  /** The folder Name the document */
  folderName: Scalars['String']['output'];
  /** ID of the CustomFileManipulatedLog */
  id: Scalars['ID']['output'];
  /** Name of the custom file */
  name: Scalars['String']['output'];
  /** The project ID the document */
  projectId: Scalars['ID']['output'];
};

export type CustomFileRenamedLog = CustomFileLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'CustomFileRenamedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** ID of the custom file */
  customFileId: Scalars['ID']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The folder ID the document */
  folderId?: Maybe<Scalars['ID']['output']>;
  /** The folder Name the document */
  folderName?: Maybe<Scalars['String']['output']>;
  /** ID of the CustomFileRenamedLog */
  id: Scalars['ID']['output'];
  /** New name of the custom file */
  name: Scalars['String']['output'];
  /** Old name of the custom file */
  oldName: Scalars['String']['output'];
  /** The project ID the document */
  projectId: Scalars['ID']['output'];
};

export enum CustomFileSource {
  Baumappe = 'BAUMAPPE',
  Hspass = 'HSPASS',
  Sap = 'SAP'
}

export type CustomFileUploadInput = {
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};

export type CustomPdfFileFormFieldValuesUpdateInput = {
  documentId: Scalars['ID']['input'];
  formFieldValues: Array<PspdfKitFormField>;
};

export enum DigitalSalaryHistoryAction {
  CommercialApprove = 'COMMERCIAL_APPROVE',
  SapTransmission = 'SAP_TRANSMISSION',
  TechnicalApprove = 'TECHNICAL_APPROVE'
}

export type DigitalSalaryHistoryItem = {
  __typename?: 'DigitalSalaryHistoryItem';
  action: DigitalSalaryHistoryAction;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export enum DigitalSalaryRole {
  CommercialApprover = 'COMMERCIAL_APPROVER',
  SapTransmission = 'SAP_TRANSMISSION',
  TechnicalApprover = 'TECHNICAL_APPROVER'
}

/** Discount or surcharge value enum */
export enum DiscountOrSurchargeValueType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type DocumentInterface = {
  addedBy: User;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
};

export type DocumentLog = {
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the document */
  documentId: Scalars['ID']['output'];
  /** ID of the DocumentLog */
  id: Scalars['ID']['output'];
  /** Name of the document */
  name: Scalars['String']['output'];
};

export enum DocumentManipulator {
  Pspdfkit = 'PSPDFKIT'
}

export type DocumentMetaData = {
  __typename?: 'DocumentMetaData';
  archivable: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  customMeta?: Maybe<DriveDocumentMeta>;
  emailSendable: Scalars['Boolean']['output'];
  emailSent: Scalars['Boolean']['output'];
  externalLinkEmailSendable: Scalars['Boolean']['output'];
  manipulable: Scalars['Boolean']['output'];
  manipulated: Scalars['Boolean']['output'];
  movable: Scalars['Boolean']['output'];
  removable: Scalars['Boolean']['output'];
  renamable: Scalars['Boolean']['output'];
  signable: Scalars['Boolean']['output'];
  signed: Scalars['Boolean']['output'];
  updatable: Scalars['Boolean']['output'];
};

export type DocumentMovedLog = DocumentLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'DocumentMovedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the document log */
  documentId: Scalars['ID']['output'];
  /** ID of the DocumentMovedLog */
  id: Scalars['ID']['output'];
  /** Name of the document log */
  name: Scalars['String']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
  /** The folder of the document before move operation */
  sourceFolder: FolderData;
  /** The folder of the document after move operation */
  targetFolder: FolderData;
};

export enum DocumentType {
  AcceptanceReport = 'ACCEPTANCE_REPORT',
  Concern = 'CONCERN',
  ConstructionNote = 'CONSTRUCTION_NOTE',
  CustomFile = 'CUSTOM_FILE',
  FinancialDocument = 'FINANCIAL_DOCUMENT',
  Obstruction = 'OBSTRUCTION',
  Offer = 'OFFER',
  Overtime = 'OVERTIME',
  Qsst = 'QSST',
  RiskAssessment = 'RISK_ASSESSMENT',
  SivBillingAttachment = 'SIV_BILLING_ATTACHMENT'
}

export type DownloadDriveBulkJob = DriveBulkJob & {
  __typename?: 'DownloadDriveBulkJob';
  documents: Array<DriveDocument>;
  id: Scalars['ID']['output'];
  meta: DownloadDriveBulkJobMeta;
  status: DriveBulkJobStatus;
};

export type DownloadDriveBulkJobLink = {
  __typename?: 'DownloadDriveBulkJobLink';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DownloadDriveBulkJobMeta = DownloadLinkMeta | DownloadMaxFileSizeExceededErrorMeta | DownloadServerErrorMeta;

export enum DownloadDriveBulkJobMetaFailureReason {
  MaxFileSizeExceed = 'MAX_FILE_SIZE_EXCEED',
  ServerError = 'SERVER_ERROR'
}

export type DownloadLinkMeta = {
  __typename?: 'DownloadLinkMeta';
  link?: Maybe<DownloadDriveBulkJobLink>;
};

export type DownloadMaxFileSizeExceededErrorMeta = {
  __typename?: 'DownloadMaxFileSizeExceededErrorMeta';
  actualSize: Scalars['Float']['output'];
  limit: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type DownloadServerErrorMeta = {
  __typename?: 'DownloadServerErrorMeta';
  reason: Scalars['String']['output'];
};

export type Drive = {
  __typename?: 'Drive';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  mimeTypeFolderMap: Array<DriveMimeTypeFolderMapItem>;
  rootFolder: DriveFolder;
  updatedAt: Scalars['Date']['output'];
};

export type DriveApp = {
  __typename?: 'DriveApp';
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DriveBulkJob = {
  documents: Array<DriveDocument>;
  id: Scalars['ID']['output'];
  status: DriveBulkJobStatus;
};

export type DriveBulkJobCancelInput = {
  id: Scalars['ID']['input'];
};

export type DriveBulkJobRemoveInput = {
  id: Scalars['ID']['input'];
};

export type DriveBulkJobRemoveResult = {
  __typename?: 'DriveBulkJobRemoveResult';
  status: Scalars['Boolean']['output'];
};

export enum DriveBulkJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

export type DriveDocument = Notable & Sortable & {
  __typename?: 'DriveDocument';
  addedBy: User;
  createdAt: Scalars['Date']['output'];
  download?: Maybe<DriveDocumentDownload>;
  folder: DriveFolder;
  id: Scalars['ID']['output'];
  lastChangedDate: Scalars['Date']['output'];
  lastUsedDate?: Maybe<Scalars['Date']['output']>;
  logs: Logs;
  manipulable: Scalars['Boolean']['output'];
  manipulated: Scalars['Boolean']['output'];
  manipulator?: Maybe<DocumentManipulator>;
  /** Meta of the document */
  meta?: Maybe<DriveDocumentMeta>;
  metadata?: Maybe<DocumentMetaData>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  no: Scalars['String']['output'];
  note?: Maybe<DriveEntryNote>;
  parentFolders: Array<DriveFolder>;
  preview?: Maybe<DriveDocumentPreview>;
  project: Project;
  size?: Maybe<Scalars['Int']['output']>;
  status: DriveDocumentStatus;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanManipulate: Scalars['Boolean']['output'];
  viewerCanMove: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanRename: Scalars['Boolean']['output'];
  viewerCanSendEmail: Scalars['Boolean']['output'];
  viewerCanSendExternalLinkEmail: Scalars['Boolean']['output'];
  viewerCanSign: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};


export type DriveDocumentLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type DriveDocumentThumbnailArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type DriveDocumentArchiveInput = {
  id: Scalars['ID']['input'];
  sapPassword: Scalars['String']['input'];
  sapUsername: Scalars['String']['input'];
};

export type DriveDocumentBulkArchiveInput = {
  documentIds: Array<Scalars['ID']['input']>;
  sapPassword: Scalars['String']['input'];
  sapUsername: Scalars['String']['input'];
};

export type DriveDocumentBulkDownloadInput = {
  documentIds: Array<Scalars['ID']['input']>;
};

export type DriveDocumentBulkSendEmailInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  documentIds: Array<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type DriveDocumentDownload = {
  __typename?: 'DriveDocumentDownload';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DriveDocumentEmailSendInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type DriveDocumentGenerateIdInput = {
  id: Scalars['ID']['input'];
  mimeType: Scalars['String']['input'];
};

export type DriveDocumentLastUsedUpdateInput = {
  id: Scalars['ID']['input'];
};

export type DriveDocumentMeta = AcceptanceReportMeta | FinancialDocumentMeta | OvertimeMeta;

export type DriveDocumentNoteSaveInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
};

export type DriveDocumentPreview = {
  __typename?: 'DriveDocumentPreview';
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DriveDocumentRemoveInput = {
  id: Scalars['ID']['input'];
};

export type DriveDocumentRemoveResult = {
  __typename?: 'DriveDocumentRemoveResult';
  status: Scalars['Boolean']['output'];
};

export type DriveDocumentRenameInput = {
  id: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
};

export enum DriveDocumentStatus {
  Archived = 'ARCHIVED',
  ManuallySigned = 'MANUALLY_SIGNED',
  Open = 'OPEN',
  Sent = 'SENT',
  Signed = 'SIGNED',
  Unknown = 'UNKNOWN'
}

export type DriveDocumentsExternalLinkEmailSendInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  ids: Array<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type DriveDocumentsMoveInput = {
  ids: Array<Scalars['ID']['input']>;
  targetFolderId: Scalars['ID']['input'];
};

export type DriveDocumentsRemoveInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DriveDocumentsRemoveResult = {
  __typename?: 'DriveDocumentsRemoveResult';
  status: Scalars['Boolean']['output'];
};

export type DriveEntry = DriveDocument | DriveFolder;

export type DriveEntryNote = {
  __typename?: 'DriveEntryNote';
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: User;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<User>;
};

export type DriveEntrySorting = {
  __typename?: 'DriveEntrySorting';
  direction: DriveSortingDirection;
  type: DriveEntrySortingType;
};

export type DriveEntrySortingInput = {
  direction: DriveSortingDirection;
  type: DriveEntrySortingType;
};

export enum DriveEntrySortingType {
  Alphabetical = 'ALPHABETICAL',
  LastChangedDate = 'LAST_CHANGED_DATE',
  LastUsedDate = 'LAST_USED_DATE',
  Status = 'STATUS'
}

export type DriveFolder = Notable & Sortable & {
  __typename?: 'DriveFolder';
  addedBy: User;
  createdAt: Scalars['Date']['output'];
  depth: Scalars['Int']['output'];
  documentCounts: DriveFolderDocumentCounts;
  drive: Drive;
  entries: Array<DriveEntry>;
  id: Scalars['ID']['output'];
  lastChangedDate: Scalars['Date']['output'];
  lastUsedDate?: Maybe<Scalars['Date']['output']>;
  mimeTypes: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<DriveEntryNote>;
  parent?: Maybe<DriveFolder>;
  subtype?: Maybe<DriveFolderSubtype>;
  type: DriveFolderType;
  updatedAt: Scalars['Date']['output'];
  viewerCanCreateCustomFileDocument: Scalars['Boolean']['output'];
  viewerCanCreateFolder: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanRename: Scalars['Boolean']['output'];
};


export type DriveFolderDocumentCountsArgs = {
  excludedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  includedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type DriveFolderEntriesArgs = {
  excludedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  includedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<DriveSorting>;
  sortingv2?: InputMaybe<DriveEntrySortingInput>;
  viewPreferences?: InputMaybe<DriveViewPreferencesInput>;
};

export type DriveFolderCreateAndMoveDocumentsInput = {
  documentIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
};

export type DriveFolderCreateInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
};

export type DriveFolderCreatedLog = DriveFolderLog & Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'DriveFolderCreatedLog';
  actorFirstName: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  actorLastName: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  driveFolderId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
};

export type DriveFolderDeletedLog = DriveFolderLog & Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'DriveFolderDeletedLog';
  actorFirstName: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  actorLastName: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  driveFolderId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
};

export type DriveFolderDocumentCounts = {
  __typename?: 'DriveFolderDocumentCounts';
  bauarchiv: Scalars['Int']['output'];
  baumappe: Scalars['Int']['output'];
};

export type DriveFolderLastUsedUpdateInput = {
  id: Scalars['ID']['input'];
};

export type DriveFolderLog = {
  driveFolderId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DriveFolderNoteSaveInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  folderId: Scalars['ID']['input'];
};

export type DriveFolderRemoveInput = {
  fallbackFolderId?: InputMaybe<Scalars['ID']['input']>;
  folderId: Scalars['ID']['input'];
};

export type DriveFolderRemoveResult = {
  __typename?: 'DriveFolderRemoveResult';
  meta: DriveFolderRemoveResultMeta;
  status: Scalars['Boolean']['output'];
};

export type DriveFolderRemoveResultMeta = {
  __typename?: 'DriveFolderRemoveResultMeta';
  movedDocuments: Array<DriveDocument>;
  movedFolder?: Maybe<DriveFolder>;
};

export type DriveFolderSorting = {
  __typename?: 'DriveFolderSorting';
  direction: DriveSortingDirection;
  type: DriveFolderSortingType;
};

export type DriveFolderSortingInput = {
  direction: DriveSortingDirection;
  type: DriveFolderSortingType;
};

export enum DriveFolderSortingType {
  Alphabetical = 'ALPHABETICAL',
  LastUsedDate = 'LAST_USED_DATE',
  Standard = 'STANDARD'
}

export enum DriveFolderSubtype {
  /** Plaene */
  Blueprint = 'BLUEPRINT',
  /** Abnahmen */
  ConstructionSideAcceptance = 'CONSTRUCTION_SIDE_ACCEPTANCE',
  /** Baustellenbeschrieb */
  ConstructionSideDescription = 'CONSTRUCTION_SIDE_DESCRIPTION',
  /** Baustellendokumentationr */
  ConstructionSideDocumentation = 'CONSTRUCTION_SIDE_DOCUMENTATION',
  /** Bauvertraege */
  Contract = 'CONTRACT',
  /** Korrespondenz */
  Correspondence = 'CORRESPONDENCE',
  /** SUB / Leiher */
  FinancialBorrowers = 'FINANCIAL_BORROWERS',
  /** Rechnung / AZ */
  FinancialInvoices = 'FINANCIAL_INVOICES',
  /** Lieferanten */
  FinancialSuppliers = 'FINANCIAL_SUPPLIERS',
  /** Buergschaften */
  Guarantee = 'GUARANTEE',
  /** Aufmaß */
  Measurement = 'MEASUREMENT',
  /** Angebote */
  Offer = 'OFFER',
  /** Rapporte */
  Overtime = 'OVERTIME',
  /** Nachunternehmer */
  Subcontractor = 'SUBCONTRACTOR',
  /** Nachtraege */
  SupplementaryOffer = 'SUPPLEMENTARY_OFFER'
}

export enum DriveFolderType {
  Custom = 'CUSTOM',
  Root = 'ROOT',
  SystemBauarchiv = 'SYSTEM_BAUARCHIV',
  SystemBaumappe = 'SYSTEM_BAUMAPPE'
}

export type DriveFolderUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type DriveFolderUpdatedLog = DriveFolderLog & Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'DriveFolderUpdatedLog';
  actorFirstName: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  actorLastName: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  driveFolderId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  oldName: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
};

export type DriveMimeTypeFolderMapItem = {
  __typename?: 'DriveMimeTypeFolderMapItem';
  folder: DriveFolder;
  mimeType: Scalars['String']['output'];
};

export type DriveSorting = {
  direction: DriveSortingDirection;
  field: DriveSortingField;
};

/** The sorting direction */
export enum DriveSortingDirection {
  /** Lowest is the first */
  Asc = 'ASC',
  /** Greatest is the first */
  Desc = 'DESC'
}

/** The sorting field for Drive Document */
export enum DriveSortingField {
  AddedBy = 'ADDED_BY',
  Custom = 'CUSTOM',
  Name = 'NAME',
  No = 'NO',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export type DriveViewPreferences = {
  __typename?: 'DriveViewPreferences';
  bauarchiv: Scalars['Boolean']['output'];
  baumappe: Scalars['Boolean']['output'];
};

export type DriveViewPreferencesInput = {
  bauarchiv: Scalars['Boolean']['input'];
  baumappe: Scalars['Boolean']['input'];
};

export type DuplicateAcceptanceReportInput = {
  acceptanceReportId: Scalars['String']['input'];
};

export type DuplicateConstructionNoteInput = {
  /** ID of the construction note. */
  constructionNote: Scalars['String']['input'];
};

export type DuplicateOvertimeInput = {
  overtime: Scalars['String']['input'];
};

export type DuplicateRiskAssessmentInput = {
  riskAssessment: Scalars['String']['input'];
};

export type EditorImage = {
  __typename?: 'EditorImage';
  /** ID of the image */
  id: Scalars['ID']['output'];
  /** Path of the image */
  path: Scalars['String']['output'];
};

export type EmailSendDriveBulkJob = DriveBulkJob & {
  __typename?: 'EmailSendDriveBulkJob';
  documents: Array<DriveDocument>;
  id: Scalars['ID']['output'];
  meta?: Maybe<EmailSendDriveBulkJobMeta>;
  status: DriveBulkJobStatus;
};

export type EmailSendDriveBulkJobMeta = EmailSendMaxFileSizeExceededErrorMeta | EmailSendServerErrorMeta;

export enum EmailSendDriveBulkJobMetaFailureReason {
  MaxFileSizeExceed = 'MAX_FILE_SIZE_EXCEED',
  ServerError = 'SERVER_ERROR'
}

export type EmailSendMaxFileSizeExceededErrorMeta = {
  __typename?: 'EmailSendMaxFileSizeExceededErrorMeta';
  actualSize: Scalars['Float']['output'];
  limit: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type EmailSendServerErrorMeta = {
  __typename?: 'EmailSendServerErrorMeta';
  reason: Scalars['String']['output'];
};

/** Response as status for e-mail sending */
export type EmailSentResponse = {
  __typename?: 'EmailSentResponse';
  /** Status of the operation */
  status: Scalars['Boolean']['output'];
};

export type EmailSuggestion = {
  __typename?: 'EmailSuggestion';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EmailSuggestions = {
  __typename?: 'EmailSuggestions';
  contactPeople: Array<EmailSuggestion>;
  recipients: Array<EmailSuggestion>;
};

export type Employee = {
  __typename?: 'Employee';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profitCenter?: Maybe<ProfitCenter>;
  role: Scalars['String']['output'];
  sapId: Scalars['ID']['output'];
  trainee: Scalars['Boolean']['output'];
  wageHourly?: Maybe<Scalars['Float']['output']>;
};

export type EmployeeSorting = {
  direction: EmployeeSortingDirection;
  type: EmployeeSortingType;
};

export enum EmployeeSortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum EmployeeSortingType {
  Name = 'NAME',
  ProfitCenterId = 'PROFIT_CENTER_ID',
  SapId = 'SAP_ID'
}

export enum EnvironmentMeasurementType {
  ComponentTemperatureCelsius = 'COMPONENT_TEMPERATURE_CELSIUS',
  InsideHumidityRelativePercent = 'INSIDE_HUMIDITY_RELATIVE_PERCENT',
  InsideTemperatureCelsius = 'INSIDE_TEMPERATURE_CELSIUS',
  OutsideHumidityRelativePercent = 'OUTSIDE_HUMIDITY_RELATIVE_PERCENT',
  OutsideTemperatureCelsius = 'OUTSIDE_TEMPERATURE_CELSIUS'
}

export type Equipment = {
  __typename?: 'Equipment';
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  preselected?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sort: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export enum Event {
  AcceptanceReportArchived = 'ACCEPTANCE_REPORT_ARCHIVED',
  AcceptanceReportAssignedToProject = 'ACCEPTANCE_REPORT_ASSIGNED_TO_PROJECT',
  AcceptanceReportCreated = 'ACCEPTANCE_REPORT_CREATED',
  AcceptanceReportDeleted = 'ACCEPTANCE_REPORT_DELETED',
  AcceptanceReportEmailSent = 'ACCEPTANCE_REPORT_EMAIL_SENT',
  AcceptanceReportExternalEmailSent = 'ACCEPTANCE_REPORT_EXTERNAL_EMAIL_SENT',
  AcceptanceReportExternalLinkExpired = 'ACCEPTANCE_REPORT_EXTERNAL_LINK_EXPIRED',
  AcceptanceReportManuallySigned = 'ACCEPTANCE_REPORT_MANUALLY_SIGNED',
  AcceptanceReportManuallySignedDocumentDeleted = 'ACCEPTANCE_REPORT_MANUALLY_SIGNED_DOCUMENT_DELETED',
  AcceptanceReportNotSigned = 'ACCEPTANCE_REPORT_NOT_SIGNED',
  AcceptanceReportSignedByCustomer = 'ACCEPTANCE_REPORT_SIGNED_BY_CUSTOMER',
  AcceptanceReportUpdated = 'ACCEPTANCE_REPORT_UPDATED',
  ConcernArchived = 'CONCERN_ARCHIVED',
  ConcernAssignedToProject = 'CONCERN_ASSIGNED_TO_PROJECT',
  ConcernCreated = 'CONCERN_CREATED',
  ConcernDeleted = 'CONCERN_DELETED',
  ConcernEmailSent = 'CONCERN_EMAIL_SENT',
  ConcernSigned = 'CONCERN_SIGNED',
  ConcernUpdated = 'CONCERN_UPDATED',
  ConstructionNoteArchived = 'CONSTRUCTION_NOTE_ARCHIVED',
  ConstructionNoteAssignedToProject = 'CONSTRUCTION_NOTE_ASSIGNED_TO_PROJECT',
  ConstructionNoteCreated = 'CONSTRUCTION_NOTE_CREATED',
  ConstructionNoteDeleted = 'CONSTRUCTION_NOTE_DELETED',
  ConstructionNoteEmailSent = 'CONSTRUCTION_NOTE_EMAIL_SENT',
  ConstructionNoteUpdated = 'CONSTRUCTION_NOTE_UPDATED',
  CustomFileArchived = 'CUSTOM_FILE_ARCHIVED',
  CustomFileCreated = 'CUSTOM_FILE_CREATED',
  CustomFileDeleted = 'CUSTOM_FILE_DELETED',
  CustomFileDuplicatedForManipulation = 'CUSTOM_FILE_DUPLICATED_FOR_MANIPULATION',
  CustomFileEmailSent = 'CUSTOM_FILE_EMAIL_SENT',
  CustomFileManipulated = 'CUSTOM_FILE_MANIPULATED',
  CustomFileUpdated = 'CUSTOM_FILE_UPDATED',
  DocumentMoved = 'DOCUMENT_MOVED',
  DriveFolderCreated = 'DRIVE_FOLDER_CREATED',
  DriveFolderDeleted = 'DRIVE_FOLDER_DELETED',
  DriveFolderUpdated = 'DRIVE_FOLDER_UPDATED',
  FinancialDocumentEmailSent = 'FINANCIAL_DOCUMENT_EMAIL_SENT',
  FinancialDocumentImported = 'FINANCIAL_DOCUMENT_IMPORTED',
  ObstructionArchived = 'OBSTRUCTION_ARCHIVED',
  ObstructionAssignedToProject = 'OBSTRUCTION_ASSIGNED_TO_PROJECT',
  ObstructionCreated = 'OBSTRUCTION_CREATED',
  ObstructionDeleted = 'OBSTRUCTION_DELETED',
  ObstructionEmailSent = 'OBSTRUCTION_EMAIL_SENT',
  ObstructionSigned = 'OBSTRUCTION_SIGNED',
  ObstructionUpdated = 'OBSTRUCTION_UPDATED',
  OfferCreated = 'OFFER_CREATED',
  OfferDeleted = 'OFFER_DELETED',
  OfferEmailSent = 'OFFER_EMAIL_SENT',
  OvertimeArchived = 'OVERTIME_ARCHIVED',
  OvertimeAssignedToProject = 'OVERTIME_ASSIGNED_TO_PROJECT',
  OvertimeCreated = 'OVERTIME_CREATED',
  OvertimeDeleted = 'OVERTIME_DELETED',
  OvertimeEmailSent = 'OVERTIME_EMAIL_SENT',
  OvertimeExternalEmailSent = 'OVERTIME_EXTERNAL_EMAIL_SENT',
  OvertimeExternalLinkExpired = 'OVERTIME_EXTERNAL_LINK_EXPIRED',
  OvertimeManuallySigned = 'OVERTIME_MANUALLY_SIGNED',
  OvertimeManuallySignedDocumentDeleted = 'OVERTIME_MANUALLY_SIGNED_DOCUMENT_DELETED',
  OvertimeNotSigned = 'OVERTIME_NOT_SIGNED',
  OvertimeRenamed = 'OVERTIME_RENAMED',
  OvertimeSignedByCustomer = 'OVERTIME_SIGNED_BY_CUSTOMER',
  OvertimeUpdated = 'OVERTIME_UPDATED',
  ProjectClientInformationChanged = 'PROJECT_CLIENT_INFORMATION_CHANGED',
  ProjectConstructionInformationChanged = 'PROJECT_CONSTRUCTION_INFORMATION_CHANGED',
  ProjectExternalStatusChanged = 'PROJECT_EXTERNAL_STATUS_CHANGED',
  ProjectImported = 'PROJECT_IMPORTED',
  ProjectNumberChanged = 'PROJECT_NUMBER_CHANGED',
  ProjectProfitCenterChanged = 'PROJECT_PROFIT_CENTER_CHANGED',
  ProjectStatusUpdated = 'PROJECT_STATUS_UPDATED',
  ProjectSynced = 'PROJECT_SYNCED',
  QsstArchived = 'QSST_ARCHIVED',
  QsstAssignedToProject = 'QSST_ASSIGNED_TO_PROJECT',
  QsstCreated = 'QSST_CREATED',
  QsstDeleted = 'QSST_DELETED',
  QsstDownloaded = 'QSST_DOWNLOADED',
  QsstEmailSent = 'QSST_EMAIL_SENT',
  QsstEmailSentWithAttachment = 'QSST_EMAIL_SENT_WITH_ATTACHMENT',
  QsstExternalLinkExpired = 'QSST_EXTERNAL_LINK_EXPIRED',
  QsstNotSigned = 'QSST_NOT_SIGNED',
  QsstSigned = 'QSST_SIGNED',
  QsstSignedOnSide = 'QSST_SIGNED_ON_SIDE',
  QsstUpdated = 'QSST_UPDATED',
  QsstUploaded = 'QSST_UPLOADED',
  QsstUploadedDeleted = 'QSST_UPLOADED_DELETED',
  RiskAssessmentArchived = 'RISK_ASSESSMENT_ARCHIVED',
  RiskAssessmentAssignedToProject = 'RISK_ASSESSMENT_ASSIGNED_TO_PROJECT',
  RiskAssessmentCreated = 'RISK_ASSESSMENT_CREATED',
  RiskAssessmentDeleted = 'RISK_ASSESSMENT_DELETED',
  RiskAssessmentEmailSent = 'RISK_ASSESSMENT_EMAIL_SENT',
  RiskAssessmentManuallySigned = 'RISK_ASSESSMENT_MANUALLY_SIGNED',
  RiskAssessmentManuallySignedDocumentDeleted = 'RISK_ASSESSMENT_MANUALLY_SIGNED_DOCUMENT_DELETED',
  RiskAssessmentSignedByCreator = 'RISK_ASSESSMENT_SIGNED_BY_CREATOR',
  RiskAssessmentSignedByEmployee = 'RISK_ASSESSMENT_SIGNED_BY_EMPLOYEE',
  RiskAssessmentUpdated = 'RISK_ASSESSMENT_UPDATED'
}

export type ExportOfferInput = {
  /** Carbon copies of the mail */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content of the email. */
  content: Scalars['String']['input'];
  /** Id of the offer. */
  id: Scalars['ID']['input'];
  /** Recipients of the email. */
  recipients: Array<Scalars['String']['input']>;
  /** Subject of the email. */
  subject: Scalars['String']['input'];
};

export type ExternalAuthToken = {
  __typename?: 'ExternalAuthToken';
  token: Scalars['String']['output'];
};

export type ExternalOffer = {
  __typename?: 'ExternalOffer';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  no: Scalars['String']['output'];
  source: ExternalOfferSource;
  status: Scalars['String']['output'];
};

export enum ExternalOfferSource {
  Itworun = 'ITWORUN',
  Vendoc = 'VENDOC'
}

export type ExternalProject = {
  __typename?: 'ExternalProject';
  additionalName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isImported: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  profitCenterName: Scalars['String']['output'];
  projectNumber: Scalars['String']['output'];
  sourceSystem: ProjectImportSourceSystem;
  status?: Maybe<ProjectExternalStatus>;
  type: ExternalProjectType;
};

export type ExternalProjectImportError = {
  __typename?: 'ExternalProjectImportError';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectNumber: Scalars['String']['output'];
  reason: ExternalProjectImportErrorReason;
};

export enum ExternalProjectImportErrorReason {
  AddressFetchFailed = 'ADDRESS_FETCH_FAILED',
  AddressNotFound = 'ADDRESS_NOT_FOUND',
  ClientFetchFailed = 'CLIENT_FETCH_FAILED',
  ClientNotFound = 'CLIENT_NOT_FOUND',
  DriveCreationFailed = 'DRIVE_CREATION_FAILED',
  InternalServerError = 'INTERNAL_SERVER_ERROR'
}

export enum ExternalProjectType {
  CostCenter = 'COST_CENTER',
  Main = 'MAIN',
  Part = 'PART',
  Sub = 'SUB'
}

/** Surcharge/Discount for a offer. */
export type ExtraPrice = {
  __typename?: 'ExtraPrice';
  /** name of the extra price */
  name: Scalars['ID']['output'];
  /** Percentage of the  extra price amount */
  percentage: Scalars['Float']['output'];
  /** Type of the extra price */
  type: ExtraPriceType;
  /** Amount of the extra price */
  value: Scalars['Float']['output'];
};

export type ExtraPriceInput = {
  /** Name of the extra price. */
  name: Scalars['String']['input'];
  /** Type of the extra price. */
  type: ExtraPriceType;
  /** Extra price value based on it's type. */
  value: Scalars['Float']['input'];
};

/** Extra price type enum */
export enum ExtraPriceType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type FinancialDocument = {
  __typename?: 'FinancialDocument';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Logs of the financial document */
  logs?: Maybe<Logs>;
  name: Scalars['String']['output'];
  project: Project;
};


export type FinancialDocumentLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type FinancialDocumentEmailSentLog = FinancialDocumentLog & Log & LogWithActor & LogWithDate & LogWithEmail & {
  __typename?: 'FinancialDocumentEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the financial document sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that financial document sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the financial document log */
  financialDocumentId: Scalars['ID']['output'];
  /** ID of the FinancialDocumentEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the financial document log */
  name: Scalars['String']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type FinancialDocumentImportedLog = FinancialDocumentLog & Log & LogWithActor & LogWithDate & {
  __typename?: 'FinancialDocumentImportedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the financial document log */
  financialDocumentId: Scalars['ID']['output'];
  /** The folder ID of the financial document after import operation */
  folderId: Scalars['String']['output'];
  /** The folder name of the financial document after import operation */
  folderName: Scalars['String']['output'];
  /** The folder sub type of the financial document after import operation */
  folderSubType: FinancialFolderSubType;
  /** ID of the FinancialDocumentImportedLog */
  id: Scalars['ID']['output'];
  /** Name of the financial document log */
  name: Scalars['String']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type FinancialDocumentLog = {
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the financial document */
  financialDocumentId: Scalars['ID']['output'];
  /** ID of the FinancialDocumentLog */
  id: Scalars['ID']['output'];
  /** Name of the financial document */
  name: Scalars['String']['output'];
};

/** Meta data of the financial document */
export type FinancialDocumentMeta = {
  __typename?: 'FinancialDocumentMeta';
  /** Bill Number / Also same as Invoice number */
  billNumber?: Maybe<Scalars['String']['output']>;
  /** Name of the Creditor / Also same as Vendor name */
  creditorName?: Maybe<Scalars['String']['output']>;
  /** Creditor Number / Also same as Vendor Number */
  creditorNumber?: Maybe<Scalars['String']['output']>;
  /** Name of the Debitor */
  debitorName?: Maybe<Scalars['String']['output']>;
  /** Debitor number */
  debitorNumber?: Maybe<Scalars['String']['output']>;
  /** Net Price / Also same as Invoice Sum */
  netPrice?: Maybe<Scalars['Float']['output']>;
};

export enum FinancialFolderSubType {
  FinancialBorrowers = 'FINANCIAL_BORROWERS',
  FinancialInvoices = 'FINANCIAL_INVOICES',
  FinancialSuppliers = 'FINANCIAL_SUPPLIERS'
}

/** Folder for a offer. */
export type Folder = {
  __typename?: 'Folder';
  /** Is this calculation of folder is approximate or not */
  approximate: Scalars['Boolean']['output'];
  /** Category of this folder */
  category?: Maybe<Category>;
  /** ID of the folder */
  id: Scalars['ID']['output'];
  /** Measurements of this folder */
  measurements: Array<Measurement>;
  /** Name of the folder */
  name: Scalars['String']['output'];
  /** Note for the folder */
  note?: Maybe<Scalars['String']['output']>;
  /** Offer that this folder belongs to */
  offer: Offer;
  /** Operations of this folder */
  operations: Array<FolderOperation>;
  /** Parent of this folder */
  parent?: Maybe<Folder>;
  /** Part no of the folder */
  partNo: Scalars['String']['output'];
  /** Part no alias of the folder */
  partNoAlias?: Maybe<Scalars['String']['output']>;
  /** Computed part no of the folder */
  partNoComputed: Scalars['String']['output'];
  /** Sort no of the folder */
  sort: Scalars['Int']['output'];
  /** Total measurement of the folder */
  totalMeasurement: Scalars['Float']['output'];
  /** Total optional price of the folder */
  totalOptionalPrice: Scalars['Float']['output'];
  /** Total price of the folder */
  totalPrice: Scalars['Float']['output'];
  /** Unit type of the folder */
  unit?: Maybe<OperationUnit>;
  /** Whether viewer can add operation the current folder or not. */
  viewerCanAddOperation: Scalars['Boolean']['output'];
  /** Whether viewer can add subfolder the current folder or not. */
  viewerCanAddSubfolder: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can change the category of the folder */
  viewerCanChangeCategory: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can clone the folder */
  viewerCanClone: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can give part no alias to folder */
  viewerCanGivePartNoAlias: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can remove the folder */
  viewerCanRemove: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the folder */
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type FolderData = {
  __typename?: 'FolderData';
  /** Id of the folder */
  id: Scalars['String']['output'];
  /** Name of the folder */
  name: Scalars['String']['output'];
};

/** Folder for a offer. */
export type FolderOperation = {
  __typename?: 'FolderOperation';
  /** Is this calculation of operation is approximate or not */
  approximate: Scalars['Boolean']['output'];
  /** Is this operation completed for exporting */
  completed: Scalars['Boolean']['output'];
  /** Description for the operation */
  description?: Maybe<Scalars['String']['output']>;
  /** Folder of this operation */
  folder: Folder;
  /** ID of the operation */
  id: Scalars['ID']['output'];
  /** Measurements of this operation */
  measurements: Array<Measurement>;
  /** Name of the operation */
  name: Scalars['String']['output'];
  /** Note for the operation */
  note?: Maybe<Scalars['String']['output']>;
  /** Is this operation optional */
  optional: Scalars['Boolean']['output'];
  /** Part no of the operation */
  partNo: Scalars['String']['output'];
  /** Part no alias of the operation */
  partNoAlias?: Maybe<Scalars['String']['output']>;
  /** Computed part no of the operation */
  partNoComputed: Scalars['String']['output'];
  /** Payment of this operation */
  payment?: Maybe<OperationPayment>;
  /** Price no of the operation */
  price: Scalars['Float']['output'];
  /** Sort no of the operation */
  sort: Scalars['Int']['output'];
  /** Total measurement of the folder */
  totalMeasurement: Scalars['Float']['output'];
  /** Unit type of the operation */
  unit?: Maybe<OperationUnit>;
  /** Indicates whether the viewer can clone the folder operation */
  viewerCanClone: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can give part no alias to folder */
  viewerCanGivePartNoAlias: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can remove the folder operation */
  viewerCanRemove: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the folder operation */
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type FollowProjectToggleInput = {
  projectId: Scalars['ID']['input'];
};

export type GenerateOfferPdfInput = {
  /** Id of the offer. */
  offer: Scalars['ID']['input'];
};

export type GetPspdfkitAuthTokenInput = {
  documentId: Scalars['ID']['input'];
  requestEdit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetPspdfkitAuthTokenResponse = {
  __typename?: 'GetPspdfkitAuthTokenResponse';
  pspdfkitAuthToken: Scalars['String']['output'];
};

export type HsProject = {
  __typename?: 'HsProject';
  id: Scalars['ID']['output'];
  isImported: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  projectNumber?: Maybe<Scalars['ID']['output']>;
  sourceSystem: ProjectImportSourceSystem;
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type ImportProjectInput = {
  hsId: Scalars['String']['input'];
};

export type InCharge = {
  __typename?: 'InCharge';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role: InChargeRole;
};

export enum InChargeRole {
  FirstAider = 'FIRST_AIDER',
  OperationManager = 'OPERATION_MANAGER',
  RegionSecurityManager = 'REGION_SECURITY_MANAGER',
  SecurityManager = 'SECURITY_MANAGER',
  SideManager = 'SIDE_MANAGER'
}

export enum JobTitleType {
  Craftsman = 'CRAFTSMAN',
  Foreman = 'FOREMAN',
  Helper = 'HELPER',
  Master = 'MASTER',
  Trainee = 'TRAINEE'
}

export type Language = {
  __typename?: 'Language';
  code: LanguageCode;
  name: Scalars['String']['output'];
};

export enum LanguageCode {
  De = 'DE',
  En = 'EN',
  Fr = 'FR'
}

export type Log = {
  /** ID of the Log */
  id: Scalars['ID']['output'];
};

export type LogResetUnreadCountInput = {
  projectId: Scalars['String']['input'];
};

export type LogWithActor = {
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
};

export type LogWithDate = {
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
};

export type LogWithEmail = {
  /** E-mail address that this event taken for */
  emails: Array<Scalars['String']['output']>;
};

export type LogWithProjectContractDate = {
  /** Contract date of the project in ISO-8601 format */
  projectContractDate?: Maybe<Scalars['Date']['output']>;
};

export type Logs = {
  __typename?: 'Logs';
  logs: Array<Log>;
  pagination: Pagination;
};

export type MainProjectRelations = {
  __typename?: 'MainProjectRelations';
  partProjects: Array<Maybe<BaseProject>>;
  subProjects: Array<Maybe<BaseProject>>;
};

/** Measurement for a folder. */
export type Measurement = {
  __typename?: 'Measurement';
  /** ID of the measurement */
  id: Scalars['ID']['output'];
  /** Meta for the measurement */
  meta: Array<Scalars['String']['output']>;
  /** Multiplier for the measurement */
  multiplier: Scalars['Float']['output'];
  /** Name of the measurement */
  name: Scalars['String']['output'];
  /** Is subtraction enabled */
  subtraction: Scalars['Boolean']['output'];
  /** Total measurement */
  total: Scalars['Float']['output'];
  /** Total measurement meta */
  totalMeta: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  ProjectCalendar: ProjCal_Mutations;
  /**
   * Handles signature upload from external users via public access links.
   * This mutation is specifically designed for external parties who access
   * acceptance reports through shared links and need to provide their signature.
   */
  acceptanceReportExternalSignatureUpload: AcceptanceReportSignature;
  /** Creates or updates an acceptance report with provided data. */
  acceptanceReportSave: AcceptanceReport;
  /** It adds bulk operations to folder. */
  addBulkOperationToFolder: Array<FolderOperation>;
  /** It add operation to folder. If category is provided, then operation also saved to the given category. */
  addOperationToFolder: FolderOperation;
  /** It assigns a document to given project */
  assignDocumentToProject: DocumentInterface;
  /**
   * It assigns an offer to given project
   * @deprecated Please use assignDocumentToProject mutation instead of this mutation. It will be removed near feature.
   */
  assignOfferToProject: Offer;
  bonusCalculationDobnerSave?: Maybe<BonusCalculationDobner>;
  bonusCalculationHoltkampSave?: Maybe<BonusCalculationHoltkamp>;
  /** It clones the given folder. */
  cloneFolder: Folder;
  /** It clones the given operation. */
  cloneOperation: FolderOperation;
  /**
   * Creates a duplicate of an existing concern.
   *
   * This mutation creates a new concern based on an existing one, copying all relevant
   * data while generating a new unique identifier.
   */
  concernDuplicate: Concern;
  /**
   * Sends a concern as a PDF document via email.
   *
   * This mutation sends it concern document to specified
   * recipients. It supports multiple recipients, CC lists, custom subject lines,
   * and email content. The concern status may be updated to reflect the email action.
   */
  concernPdfEmailSend: Concern;
  /**
   * Creates a new concern or updates an existing one.
   *
   * This mutation handles both creation and updates of concerns.
   */
  concernSave: Concern;
  /**
   * Adds a digital signature to an existing concern.
   *
   * This mutation allows authorized users to digitally sign a concern by providing
   * their full name and uploading a signature image. The concern status will be
   * updated to reflect the signing action.
   */
  concernSign: Concern;
  /** Updates the canvas data of an existing construction note, including uploading the updated canvas file and its image presentation. */
  constructionNoteCanvasUpdate: ConstructionNote;
  /** Creates a new construction note, including uploading the note file and its image presentation. */
  constructionNoteCreate: ConstructionNote;
  /** Updates an existing construction note's name. */
  constructionNoteUpdate: ConstructionNote;
  contactPersonAdd: ContactPerson;
  contactPersonRemove: RemoveResult;
  contactPersonUpdate: ContactPerson;
  /** It converts custom files to images */
  convertCustomFilesToImages: Array<Image>;
  /** It creates a folder in a framework offer. */
  createFolderForFramework: Folder;
  /** It creates a folder in a free form offer. */
  createFolderForFreeForm: Folder;
  /** It creates a new operation in the catalogue. */
  createOperation: Operation;
  /** It sends an e-mail for custom file */
  customFileEmailSend: EmailSentResponse;
  /** It uploads a new custom file */
  customFileUpload: CustomFile;
  customPdfFileFormFieldValuesUpdate: DriveDocument;
  driveBulkJobCancel: DriveBulkJob;
  driveBulkJobRemove: DriveBulkJobRemoveResult;
  driveDocumentArchive: DriveDocument;
  driveDocumentBulkArchive: DriveBulkJob;
  driveDocumentBulkDownload: DriveBulkJob;
  driveDocumentBulkSendEmail: DriveBulkJob;
  driveDocumentEmailSend: DriveDocument;
  driveDocumentGenerateId: Scalars['String']['output'];
  driveDocumentGenerateIdMulti: Array<Scalars['String']['output']>;
  driveDocumentNoteSave: DriveDocument;
  driveDocumentRemove: DriveDocumentRemoveResult;
  driveDocumentRename: DriveDocument;
  driveDocumentsExternalLinkEmailSend: Array<DriveDocument>;
  driveDocumentsLastUsedUpdate: Array<DriveDocument>;
  driveDocumentsMove: Array<DriveDocument>;
  driveDocumentsRemove: DriveDocumentsRemoveResult;
  driveDocumentsRename: Array<DriveDocument>;
  /** It creates a new drive folder. */
  driveFolderCreate: DriveFolder;
  driveFolderCreateAndMoveDocuments: DriveFolder;
  /** It creates new drive folders. */
  driveFolderCreateMulti: Array<DriveFolder>;
  driveFolderLastUsedUpdate: DriveFolder;
  driveFolderNoteSave: DriveFolder;
  driveFolderRemove: DriveFolderRemoveResult;
  driveFolderUpdate: DriveFolder;
  drivePreferenceUpsert: ViewerDrivePreferences;
  driveProjectPreferenceUpsert: ViewerProjectDrivePreferences;
  /**
   * Creates a duplicate copy of an existing acceptance report.
   * All data from the original report is copied to create a new report, except signatures.
   * The new report will have a new ID.
   */
  duplicateAcceptanceReport: AcceptanceReport;
  /** Creates a duplicate of an existing construction note. */
  duplicateConstructionNote: ConstructionNote;
  duplicateOvertime: Overtime;
  duplicateRiskAssessment: RiskAssessment;
  /** It exports the offer as GAEB x83 and x84 format via e-mail. */
  exportOffer: EmailSentResponse;
  followProjectToggle: Project;
  /** It generates PDF for the given offer. */
  generateOfferPdf: Offer;
  importProject: Project;
  logResetUnreadCount: Scalars['Boolean']['output'];
  obstructionDuplicate: Obstruction;
  /** It sends obstruction email. */
  obstructionEmailSend: Obstruction;
  /** It saves given obstruction. */
  obstructionSave: Obstruction;
  obstructionSign: Obstruction;
  /** It saves given framework offer. */
  offerFrameworkSave: Offer;
  /** It saves given free form offer. */
  offerFreeFormSave: Offer;
  overtimeExternalSignatureUpload: OvertimeSignature;
  overtimeSave: Overtime;
  projectColorsChange: Project;
  projectDateUpdate: Project;
  projectMultiImport: ProjectMultiImportResponse;
  projectSearchDismissAnnouncement: Scalars['Boolean']['output'];
  projectSearchSetViewerExpandedGroupIds: ViewerProjectSearchPreferences;
  projectSearchSetViewerExpandedProfitCenters: ViewerProjectSearchPreferences;
  projectSearchSetViewerFilterPreferences: ViewerProjectSearchPreferences;
  projectSearchSetViewerGroupedByPreferences: ViewerProjectSearchPreferences;
  projectSearchSetViewerProjectColumns: ViewerProjectSearchPreferences;
  projectSearchSetViewerSortingPreferences: ViewerProjectSearchPreferences;
  projectSearchSetViewerTabPreference: ViewerProjectSearchPreferences;
  qsstDeleteUploadedPdf: Qsst;
  qsstExternalSignatureUpload: Qsst;
  qsstLogDownload: Scalars['Boolean']['output'];
  qsstSave: Qsst;
  qsstSendMail: Qsst;
  qsstSign: Qsst;
  qsstUploadPdf: Qsst;
  /** It removes a catalogue. */
  removeCatalogue: RemoveResult;
  /** It removes a folder. */
  removeFolder: RemoveResult;
  /** It removes a folder operation. */
  removeFolderOperation: RemoveResult;
  /**
   * Removes a manually uploaded PDF from an acceptance report.
   * This reverts the acceptance report back to using the system-generated PDF
   * and removes the manually uploaded file from storage.
   *
   * After removal, the system will fall back to the automatically generated PDF
   * based on the acceptance report data and templates.
   */
  removeManuallyUploadedAcceptanceReport: AcceptanceReport;
  removeManuallyUploadedOvertime: Overtime;
  retrieveTokens: RetrieveTokensResult;
  riskAssessmentManuallySignedDocumentRemove: RiskAssessment;
  riskAssessmentManuallySignedDocumentUpload: RiskAssessment;
  riskAssessmentSave: RiskAssessment;
  saveAnnotations: DriveDocument;
  /** Sends an acceptance report via email to specified recipients. */
  sendAcceptanceReportEmail: EmailSentResponse;
  /**
   * Sends an external access link for an acceptance report via email.
   * This creates a secure, time-limited link that allows external parties
   * to view and potentially sign acceptance reports without requiring
   * system access credentials.
   */
  sendAcceptanceReportExternalLinkEmail: EmailSentResponse;
  /** Sends an email with an external link to the construction note to specified recipients. */
  sendConstructionNoteEmail: EmailSentResponse;
  /** It send e-mail for the given offer. */
  sendOfferEmail: EmailSentResponse;
  sendOvertimeEmail: EmailSentResponse;
  sendOvertimeExternalLinkEmail: EmailSentResponse;
  sendRiskAssessmentEmail: EmailSentResponse;
  sivAdditionalOperationCreate: SivOperation;
  sivBillingAttachmentEmailSend: SivBillingAttachment;
  sivBillingAttachmentSave: SivBillingAttachment;
  sivCockpitDisplayPreferencesUpdate: Siv;
  sivDiscountToggle: Siv;
  sivDiscountUpdate: Siv;
  sivEmployeeProductivityToggle: Siv;
  sivGroupCreate: SivGroup;
  sivGroupDuplicate: Array<SivGroup>;
  sivGroupMove: Array<SivGroup>;
  sivGroupRemove: Siv;
  sivGroupSetIsCollapsed: SivGroup;
  sivGroupSortIndexUpdate: Siv;
  /** Transfer SIV Group recording values to planning values */
  sivGroupTransferRecordingValues: SivGroup;
  sivGroupUpdate: SivGroup;
  sivImportFromExternalOffer: Siv;
  sivImportFromOffer: Siv;
  sivIsCollapsedToggle: Siv;
  sivKeyDataSapTransmit: SivKeyDataSapTransmitResult;
  sivLvCopy: Siv;
  sivOperationConvertToRegular: SivOperation;
  sivOperationCreate: SivOperation;
  sivOperationDetach: SivOperation;
  sivOperationDuplicate: Array<SivOperation>;
  sivOperationMove: Array<SivOperation>;
  sivOperationPerformanceRecordingBatchUpdate: Array<SivOperation>;
  sivOperationPinToggle: SivOperation;
  sivOperationPlanningChargePerMinuteUpdate: SivOperation;
  sivOperationPlanningHourUpdate: SivOperation;
  sivOperationPlanningMaterialUpdate: SivOperation;
  sivOperationPlanningPerformanceValueUpdate: SivOperation;
  sivOperationRecordingHourUpdate: SivOperation;
  sivOperationRecordingMaterialUpdate: SivOperation;
  sivOperationRecordingTotalMeasurementUpdate: SivOperation;
  sivOperationRemove: Siv;
  sivOperationSortIndexUpdate: SivGroup;
  sivOperationSplitPreferenceUpdate: Siv;
  sivOperationUnitPriceUpdate: SivOperation;
  sivOperationUpdate: SivOperation;
  sivPlanningCostSectionFinish: Siv;
  sivPlanningEmployeesSet: Siv;
  sivPlanningFlatRateUpdate: Siv;
  sivPlanningFreelanceEmployeesSet: Siv;
  sivPlanningGroupFlatRateUpdate: Siv;
  sivPlanningSubcontractorCreate: SivSubcontractor;
  sivPlanningSubcontractorFromOfferValueCreate: SivSubcontractorFromOfferValue;
  sivPlanningSubcontractorFromOfferValueUpdate: SivSubcontractorFromOfferValue;
  sivPlanningSubcontractorRemove: Siv;
  sivPlanningSubcontractorUpdate: SivSubcontractor;
  sivPlanningUpdate: Siv;
  sivRecordingFlatRateUpdate: Siv;
  sivRecordingGroupFlatRateUpdate: Siv;
  sivRecordingSubcontractorInvoicesSet: SivSubcontractorUnion;
  sivRecordingUpdate: Siv;
  syncProject: Project;
  timeTrackingAdditionalRowAdd: TimeTrackingRow;
  timeTrackingBatchOperation: Array<TimeTrackingBatchOperationResponse>;
  timeTrackingEntryIndicatorMultiSave: Array<TimeTrackingEntry>;
  timeTrackingEntryIndicatorSave: TimeTrackingEntry;
  timeTrackingEntryMultiRemove: Array<TimeTrackingEntry>;
  timeTrackingEntryNoteMultiSave: Array<TimeTrackingEntry>;
  timeTrackingEntryNoteSave: TimeTrackingEntry;
  timeTrackingEntryTimeMultiRemove: Array<TimeTrackingEntry>;
  timeTrackingEntryTimeMultiSave: TimeTrackingEntryTimeSaveResult;
  timeTrackingEntryTimeRemove: TimeTrackingEntry;
  timeTrackingEntryTimeSave: TimeTrackingEntryTimeSaveResult;
  timeTrackingProjectMultiApprove: Array<TimeTrackingApprove>;
  timeTrackingRemoveWeekYearProject: Scalars['Boolean']['output'];
  timeTrackingResponsibleToggle: TimeTrackingWeekRecord;
  timeTrackingRowRemove: Scalars['Boolean']['output'];
  timeTrackingSAPEmployeeWeekRecordAdd: TimeTrackingWeekRecord;
  timeTrackingSAPTransmit: TimeTrackingSapTransmitPayload;
  timeTrackingSwitchMultiSAPEmployee: TimeTrackingWeekYearSapEmployee;
  timeTrackingSwitchProject: TimeTrackingWeekYearProject;
  timeTrackingSwitchSAPEmployee: TimeTrackingWeekRecord;
  timeTrackingUnknownEmployeeUpdate: TimeTrackingWeekRecord;
  timeTrackingUnknownEmployeeWeekRecordAdd: TimeTrackingWeekRecord;
  timeTrackingWeekRecordSwitchProject: TimeTrackingWeekRecord;
  timesheetGeneratePdfByEmployeesInRange: TimesheetGeneratePdfByEmployeesInRangeResult;
  timesheetGeneratePdfByProjectsInRange: TimesheetGeneratePdfByProjectsInRangeResult;
  toggleManualEmailSubscription: Scalars['Boolean']['output'];
  /**
   * This mutation toggles the new project list feature for the user on LaunchDarkly.
   *
   * - Once it's run, The "New Project List" flag will be toggled for the current viewer.
   *
   * - The opt-in change ability can be managed by another flag called the "New Project List Toggle", once this flag is turned off, the user will not be able toggle the feature for themselves. Which means, this mutation will not no longer work.
   *
   * ---
   *
   * See LaunchDarkly:
   *
   * - [New Project List](https://app.launchdarkly.com/projects/default/flags/new-project-list/targeting)
   * - [New Project List Toggle](https://app.launchdarkly.com/projects/default/flags/new-project-list-toggle/targeting)
   *
   * ---
   *
   * See JIRA: [BMMIT-766](https://heinrich-schmid.atlassian.net/browse/BMMIT-766), [BMMIT-642](https://heinrich-schmid.atlassian.net/browse/BMMIT-642)
   */
  toggleNewProjectListForViewer: Scalars['Boolean']['output'];
  toggleShowSubProjectHours: Project;
  /** It updates catalogue. */
  updateCatalogue: Catalogue;
  /** It updates a framework folder. */
  updateFolderForFramework: Folder;
  /** It updates a free form folder. */
  updateFolderForFreeForm: Folder;
  /** It updates a folder operation. */
  updateFolderOperation: FolderOperation;
  /** It updates an offer's calculation. */
  updateOfferCalculation: Offer;
  /** It updates sort for framework folders and framework operations. */
  updateOfferSortingForFramework: UpdateSortingResult;
  /** It updates sort for free form folders and operations. */
  updateOfferSortingForFreeForm: UpdateSortingResult;
  /** It updates a operation. */
  updateOperation: Operation;
  updateProjectStatus: Project;
  /**
   * It updates tax rate for the given offer.
   * @deprecated Please use updateOfferCalculation mutation instead of this mutation. It will be removed near feature.
   */
  updateTaxRate: Offer;
  /**
   * Uploads a digital signature for an acceptance report.
   * This mutation handles signature uploads from authenticated users
   * within the system, supporting both customer and Heinrich Schmid signatures.
   *
   * Signature types:
   * - CUSTOMER: Signatures from client representatives
   * - HEINRICH_SCHMID: Signatures from Heinrich Schmid employees
   *
   * The uploaded signature image is processed and associated with the
   * acceptance report, marking it as signed by the specified party.
   */
  uploadAcceptanceReportSignature: AcceptanceReportSignature;
  /** It uploads to user catalogue. */
  uploadCatalogue: Catalogue;
  /** Uploads an image for editor */
  uploadEditorImage: EditorImage;
  /**  Uploads an image  */
  uploadImage: Image;
  /**
   * Uploads a manually created PDF to replace the system-generated one.
   * This allows users to upload custom PDF versions of acceptance reports
   * when the generated version doesn't meet specific requirements.
   */
  uploadManualPDFToAcceptanceReport: AcceptanceReport;
  uploadManualPDFToOvertime: Overtime;
  uploadOvertimeSignature: OvertimeSignature;
  uploadRiskAssessmentSignature: RiskAssessmentSignature;
  viewerLanguageUpdate: ViewerLanguageUpdateResult;
  viewerSetProjectViewed: Viewer;
  watchEvents: Scalars['Boolean']['output'];
};


export type MutationAcceptanceReportExternalSignatureUploadArgs = {
  file: Scalars['Upload']['input'];
  input: AcceptanceReportExternalSignatureUploadInput;
};


export type MutationAcceptanceReportSaveArgs = {
  input: AcceptanceReportSaveInput;
};


export type MutationAddBulkOperationToFolderArgs = {
  input: AddBulkOperationToFolderInput;
};


export type MutationAddOperationToFolderArgs = {
  input: AddOperationToFolderInput;
};


export type MutationAssignDocumentToProjectArgs = {
  input: AssignDocumentToProjectInput;
};


export type MutationAssignOfferToProjectArgs = {
  input: AssignOfferToProjectInput;
};


export type MutationBonusCalculationDobnerSaveArgs = {
  input: BonusCalculationDobnerSaveInput;
};


export type MutationBonusCalculationHoltkampSaveArgs = {
  input: BonusCalculationHoltkampSaveInput;
};


export type MutationCloneFolderArgs = {
  input: CloneFolderInput;
};


export type MutationCloneOperationArgs = {
  input: CloneOperationInput;
};


export type MutationConcernDuplicateArgs = {
  input: ConcernDuplicateInput;
};


export type MutationConcernPdfEmailSendArgs = {
  input: ConcernPdfEmailSendInput;
};


export type MutationConcernSaveArgs = {
  input: ConcernSaveInput;
};


export type MutationConcernSignArgs = {
  input: ConcernSignInput;
};


export type MutationConstructionNoteCanvasUpdateArgs = {
  file: Scalars['Upload']['input'];
  imagePresentation: Scalars['Upload']['input'];
  input: ConstructionNoteCanvasUpdateInput;
};


export type MutationConstructionNoteCreateArgs = {
  file: Scalars['Upload']['input'];
  imagePresentation: Scalars['Upload']['input'];
  input: ConstructionNoteCreateInput;
};


export type MutationConstructionNoteUpdateArgs = {
  input: ConstructionNoteUpdateInput;
};


export type MutationContactPersonAddArgs = {
  input: ContactPersonAddInput;
};


export type MutationContactPersonRemoveArgs = {
  input: ContactPersonRemoveInput;
};


export type MutationContactPersonUpdateArgs = {
  input: ContactPersonUpdateInput;
};


export type MutationConvertCustomFilesToImagesArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type MutationCreateFolderForFrameworkArgs = {
  input: CreateFolderForFrameworkInput;
};


export type MutationCreateFolderForFreeFormArgs = {
  input: CreateFolderForFreeFormInput;
};


export type MutationCreateOperationArgs = {
  input: CreateOperationInput;
};


export type MutationCustomFileEmailSendArgs = {
  input: CustomFileEmailSendInput;
};


export type MutationCustomFileUploadArgs = {
  input: CustomFileUploadInput;
};


export type MutationCustomPdfFileFormFieldValuesUpdateArgs = {
  input: CustomPdfFileFormFieldValuesUpdateInput;
};


export type MutationDriveBulkJobCancelArgs = {
  input: DriveBulkJobCancelInput;
};


export type MutationDriveBulkJobRemoveArgs = {
  input: DriveBulkJobRemoveInput;
};


export type MutationDriveDocumentArchiveArgs = {
  input: DriveDocumentArchiveInput;
};


export type MutationDriveDocumentBulkArchiveArgs = {
  input: DriveDocumentBulkArchiveInput;
};


export type MutationDriveDocumentBulkDownloadArgs = {
  input: DriveDocumentBulkDownloadInput;
};


export type MutationDriveDocumentBulkSendEmailArgs = {
  input: DriveDocumentBulkSendEmailInput;
};


export type MutationDriveDocumentEmailSendArgs = {
  input: DriveDocumentEmailSendInput;
};


export type MutationDriveDocumentGenerateIdArgs = {
  input: DriveDocumentGenerateIdInput;
};


export type MutationDriveDocumentGenerateIdMultiArgs = {
  input: Array<DriveDocumentGenerateIdInput>;
};


export type MutationDriveDocumentNoteSaveArgs = {
  input: DriveDocumentNoteSaveInput;
};


export type MutationDriveDocumentRemoveArgs = {
  input: DriveDocumentRemoveInput;
};


export type MutationDriveDocumentRenameArgs = {
  input: DriveDocumentRenameInput;
};


export type MutationDriveDocumentsExternalLinkEmailSendArgs = {
  input: DriveDocumentsExternalLinkEmailSendInput;
};


export type MutationDriveDocumentsLastUsedUpdateArgs = {
  input: Array<DriveDocumentLastUsedUpdateInput>;
};


export type MutationDriveDocumentsMoveArgs = {
  input: DriveDocumentsMoveInput;
};


export type MutationDriveDocumentsRemoveArgs = {
  input: DriveDocumentsRemoveInput;
};


export type MutationDriveDocumentsRenameArgs = {
  input: Array<DriveDocumentRenameInput>;
};


export type MutationDriveFolderCreateArgs = {
  input: DriveFolderCreateInput;
};


export type MutationDriveFolderCreateAndMoveDocumentsArgs = {
  input: DriveFolderCreateAndMoveDocumentsInput;
};


export type MutationDriveFolderCreateMultiArgs = {
  input: Array<DriveFolderCreateInput>;
};


export type MutationDriveFolderLastUsedUpdateArgs = {
  input: DriveFolderLastUsedUpdateInput;
};


export type MutationDriveFolderNoteSaveArgs = {
  input: DriveFolderNoteSaveInput;
};


export type MutationDriveFolderRemoveArgs = {
  input: DriveFolderRemoveInput;
};


export type MutationDriveFolderUpdateArgs = {
  input: DriveFolderUpdateInput;
};


export type MutationDrivePreferenceUpsertArgs = {
  input: ViewerDrivePreferencesInput;
};


export type MutationDriveProjectPreferenceUpsertArgs = {
  input: ViewerProjectDrivePreferenceInput;
};


export type MutationDuplicateAcceptanceReportArgs = {
  input: DuplicateAcceptanceReportInput;
};


export type MutationDuplicateConstructionNoteArgs = {
  input: DuplicateConstructionNoteInput;
};


export type MutationDuplicateOvertimeArgs = {
  input: DuplicateOvertimeInput;
};


export type MutationDuplicateRiskAssessmentArgs = {
  input: DuplicateRiskAssessmentInput;
};


export type MutationExportOfferArgs = {
  input: ExportOfferInput;
};


export type MutationFollowProjectToggleArgs = {
  input: FollowProjectToggleInput;
};


export type MutationGenerateOfferPdfArgs = {
  input: GenerateOfferPdfInput;
};


export type MutationImportProjectArgs = {
  input: ImportProjectInput;
};


export type MutationLogResetUnreadCountArgs = {
  input: LogResetUnreadCountInput;
};


export type MutationObstructionDuplicateArgs = {
  input: ObstructionDuplicateInput;
};


export type MutationObstructionEmailSendArgs = {
  input: ObstructionEmailSendInput;
};


export type MutationObstructionSaveArgs = {
  input: ObstructionSaveInput;
};


export type MutationObstructionSignArgs = {
  input: ObstructionSignInput;
};


export type MutationOfferFrameworkSaveArgs = {
  input: OfferFrameworkSaveInput;
};


export type MutationOfferFreeFormSaveArgs = {
  input: OfferFreeFormSaveInput;
};


export type MutationOvertimeExternalSignatureUploadArgs = {
  file: Scalars['Upload']['input'];
  input: OvertimeExternalSignatureUploadInput;
};


export type MutationOvertimeSaveArgs = {
  input: OvertimeSaveInput;
};


export type MutationProjectColorsChangeArgs = {
  input: ProjectColorsChangeInput;
};


export type MutationProjectDateUpdateArgs = {
  input: ProjectDateUpdateInput;
};


export type MutationProjectMultiImportArgs = {
  input: ProjectMultiImportInput;
};


export type MutationProjectSearchDismissAnnouncementArgs = {
  announcementType: ProjectSearchAnnouncementType;
};


export type MutationProjectSearchSetViewerExpandedGroupIdsArgs = {
  input: ProjectSearchSetViewerExpandedGroupIdsPreferencesInput;
};


export type MutationProjectSearchSetViewerExpandedProfitCentersArgs = {
  input: SetViewerExpandedProfitCentersInput;
};


export type MutationProjectSearchSetViewerFilterPreferencesArgs = {
  input: ProjectSearchSetViewerFilterPreferencesInput;
};


export type MutationProjectSearchSetViewerGroupedByPreferencesArgs = {
  input: ProjectSearchSetViewerGroupingPreferencesInput;
};


export type MutationProjectSearchSetViewerProjectColumnsArgs = {
  input: ProjectSearchSetViewerProjectColumnsInput;
};


export type MutationProjectSearchSetViewerSortingPreferencesArgs = {
  input: ProjectSearchSetViewerSortingPreferencesInput;
};


export type MutationProjectSearchSetViewerTabPreferenceArgs = {
  tab: ViewerProjectSearchTabPreference;
};


export type MutationQsstDeleteUploadedPdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationQsstExternalSignatureUploadArgs = {
  input: QsstExternalSignatureUploadInput;
};


export type MutationQsstLogDownloadArgs = {
  input: QsstLogDownloadInput;
};


export type MutationQsstSaveArgs = {
  input: QsstSaveInput;
};


export type MutationQsstSendMailArgs = {
  input: QsstSendMailInput;
};


export type MutationQsstSignArgs = {
  input: QsstSignInput;
};


export type MutationQsstUploadPdfArgs = {
  input: QsstUploadPdfInput;
};


export type MutationRemoveCatalogueArgs = {
  input: RemoveCatalogueInput;
};


export type MutationRemoveFolderArgs = {
  input: RemoveFolderInput;
};


export type MutationRemoveFolderOperationArgs = {
  input: RemoveFolderOperationInput;
};


export type MutationRemoveManuallyUploadedAcceptanceReportArgs = {
  input: RemoveManuallyUploadedAcceptanceReportInput;
};


export type MutationRemoveManuallyUploadedOvertimeArgs = {
  input: RemoveManuallyUploadedOvertimeInput;
};


export type MutationRetrieveTokensArgs = {
  input: RetrieveTokensInput;
};


export type MutationRiskAssessmentManuallySignedDocumentRemoveArgs = {
  input: RiskAssessmentManuallySignedDocumentRemoveInput;
};


export type MutationRiskAssessmentManuallySignedDocumentUploadArgs = {
  input: RiskAssessmentManuallySignedDocumentUploadInput;
};


export type MutationRiskAssessmentSaveArgs = {
  input: RiskAssessmentSaveInput;
};


export type MutationSaveAnnotationsArgs = {
  input: SaveAnnotationsInput;
};


export type MutationSendAcceptanceReportEmailArgs = {
  input: SendAcceptanceReportEmailInput;
};


export type MutationSendAcceptanceReportExternalLinkEmailArgs = {
  input: SendAcceptanceReportExternalLinkEmailInput;
};


export type MutationSendConstructionNoteEmailArgs = {
  file: Scalars['Upload']['input'];
  input: SendConstructionNoteEmailInput;
};


export type MutationSendOfferEmailArgs = {
  input: SendOfferEmailInput;
};


export type MutationSendOvertimeEmailArgs = {
  input: SendOvertimeEmailInput;
};


export type MutationSendOvertimeExternalLinkEmailArgs = {
  input: SendOvertimeExternalLinkEmailInput;
};


export type MutationSendRiskAssessmentEmailArgs = {
  input: SendRiskAssessmentEmailInput;
};


export type MutationSivAdditionalOperationCreateArgs = {
  input: SivAdditionalOperationCreateInput;
};


export type MutationSivBillingAttachmentEmailSendArgs = {
  input: SivBillingAttachmentEmailSendInput;
};


export type MutationSivBillingAttachmentSaveArgs = {
  input: SivBillingAttachmentSaveInput;
};


export type MutationSivCockpitDisplayPreferencesUpdateArgs = {
  input: SivCockpitDisplayPreferencesUpdateInput;
};


export type MutationSivDiscountToggleArgs = {
  input: SivDiscountToggleInput;
};


export type MutationSivDiscountUpdateArgs = {
  input: SivDiscountUpdateInput;
};


export type MutationSivEmployeeProductivityToggleArgs = {
  input: SivEmployeeProductivityToggleInput;
};


export type MutationSivGroupCreateArgs = {
  input: SivGroupCreateInput;
};


export type MutationSivGroupDuplicateArgs = {
  input: SivGroupDuplicateInput;
};


export type MutationSivGroupMoveArgs = {
  input: SivGroupMoveInput;
};


export type MutationSivGroupRemoveArgs = {
  input: SivGroupRemoveInput;
};


export type MutationSivGroupSetIsCollapsedArgs = {
  input: SivGroupSetIsCollapsedInput;
};


export type MutationSivGroupSortIndexUpdateArgs = {
  input: SivGroupSortIndexUpdateInput;
};


export type MutationSivGroupTransferRecordingValuesArgs = {
  input: SivGroupTransferRecordingValuesInput;
};


export type MutationSivGroupUpdateArgs = {
  input: SivGroupUpdateInput;
};


export type MutationSivImportFromExternalOfferArgs = {
  input: SivImportFromExternalOfferInput;
};


export type MutationSivImportFromOfferArgs = {
  input: SivImportFromOfferInput;
};


export type MutationSivIsCollapsedToggleArgs = {
  input: SivCollapseToggleInput;
};


export type MutationSivKeyDataSapTransmitArgs = {
  input: SivKeyDataSapTransmitInput;
};


export type MutationSivLvCopyArgs = {
  input: SivlvCopyInput;
};


export type MutationSivOperationConvertToRegularArgs = {
  input: SivOperationConvertToRegularInput;
};


export type MutationSivOperationCreateArgs = {
  input: SivOperationCreateInput;
};


export type MutationSivOperationDetachArgs = {
  input: SivOperationDetachInput;
};


export type MutationSivOperationDuplicateArgs = {
  input: SivOperationDuplicateInput;
};


export type MutationSivOperationMoveArgs = {
  input: SivOperationMoveInput;
};


export type MutationSivOperationPerformanceRecordingBatchUpdateArgs = {
  input: Array<SivOperationPerformanceRecordingBatchUpdateInput>;
};


export type MutationSivOperationPinToggleArgs = {
  input: SivOperationPinToggleInput;
};


export type MutationSivOperationPlanningChargePerMinuteUpdateArgs = {
  input: SivOperationPlanningChargePerMinuteUpdateInput;
};


export type MutationSivOperationPlanningHourUpdateArgs = {
  input: SivOperationPlanningHourUpdateInput;
};


export type MutationSivOperationPlanningMaterialUpdateArgs = {
  input: SivOperationPlanningMaterialUpdateInput;
};


export type MutationSivOperationPlanningPerformanceValueUpdateArgs = {
  input: SivOperationPlanningPerformanceValueUpdateInput;
};


export type MutationSivOperationRecordingHourUpdateArgs = {
  input: SivOperationRecordingHourUpdateInput;
};


export type MutationSivOperationRecordingMaterialUpdateArgs = {
  input: SivOperationRecordingMaterialUpdateInput;
};


export type MutationSivOperationRecordingTotalMeasurementUpdateArgs = {
  input: SivOperationRecordingTotalMeasurementUpdateInput;
};


export type MutationSivOperationRemoveArgs = {
  input: SivOperationRemoveInput;
};


export type MutationSivOperationSortIndexUpdateArgs = {
  input: SivOperationSortIndexUpdateInput;
};


export type MutationSivOperationSplitPreferenceUpdateArgs = {
  input: SivOperationSplitPreferenceUpdateInput;
};


export type MutationSivOperationUnitPriceUpdateArgs = {
  input: SivOperationUnitPriceUpdateInput;
};


export type MutationSivOperationUpdateArgs = {
  input: SivOperationUpdateInput;
};


export type MutationSivPlanningCostSectionFinishArgs = {
  input: SivPlanningCostSectionFinishInput;
};


export type MutationSivPlanningEmployeesSetArgs = {
  input: SivPlanningEmployeesSetInput;
};


export type MutationSivPlanningFlatRateUpdateArgs = {
  input: SivPlanningFlatRateUpdateInput;
};


export type MutationSivPlanningFreelanceEmployeesSetArgs = {
  input: SivPlanningFreelanceEmployeesSetInput;
};


export type MutationSivPlanningGroupFlatRateUpdateArgs = {
  input: SivPlanningGroupFlatRateUpdateInput;
};


export type MutationSivPlanningSubcontractorCreateArgs = {
  input: SivPlanningSubcontractorCreateInput;
};


export type MutationSivPlanningSubcontractorFromOfferValueCreateArgs = {
  input: SivPlanningSubcontractorFromOfferValueCreateInput;
};


export type MutationSivPlanningSubcontractorFromOfferValueUpdateArgs = {
  input: SivPlanningSubcontractorFromOfferValueUpdateInput;
};


export type MutationSivPlanningSubcontractorRemoveArgs = {
  input: SivPlanningSubcontractorRemoveInput;
};


export type MutationSivPlanningSubcontractorUpdateArgs = {
  input: SivPlanningSubcontractorUpdateInput;
};


export type MutationSivPlanningUpdateArgs = {
  input: SivPlanningUpdateInput;
};


export type MutationSivRecordingFlatRateUpdateArgs = {
  input: SivRecordingFlatRateUpdateInput;
};


export type MutationSivRecordingGroupFlatRateUpdateArgs = {
  input: SivRecordingGroupFlatRateUpdateInput;
};


export type MutationSivRecordingSubcontractorInvoicesSetArgs = {
  input: SivRecordingSubcontractorInvoicesSetInput;
};


export type MutationSivRecordingUpdateArgs = {
  input: SivRecordingUpdateInput;
};


export type MutationSyncProjectArgs = {
  input: SyncProjectInput;
};


export type MutationTimeTrackingAdditionalRowAddArgs = {
  input: TimeTrackingAdditionalRowAddInput;
};


export type MutationTimeTrackingBatchOperationArgs = {
  input: TimeTrackingBatchOperationInput;
};


export type MutationTimeTrackingEntryIndicatorMultiSaveArgs = {
  input: Array<TimeTrackingEntryIndicatorSaveInput>;
};


export type MutationTimeTrackingEntryIndicatorSaveArgs = {
  input: TimeTrackingEntryIndicatorSaveInput;
};


export type MutationTimeTrackingEntryMultiRemoveArgs = {
  input: TimeTrackingEntryMultiRemoveInput;
};


export type MutationTimeTrackingEntryNoteMultiSaveArgs = {
  input: Array<TimeTrackingEntryNoteSaveInput>;
};


export type MutationTimeTrackingEntryNoteSaveArgs = {
  input: TimeTrackingEntryNoteSaveInput;
};


export type MutationTimeTrackingEntryTimeMultiRemoveArgs = {
  input: TimeTrackingEntryTimeMultiRemoveInput;
};


export type MutationTimeTrackingEntryTimeMultiSaveArgs = {
  input: Array<TimeTrackingEntryTimeSaveInput>;
};


export type MutationTimeTrackingEntryTimeRemoveArgs = {
  input: TimeTrackingEntryTimeRemoveInput;
};


export type MutationTimeTrackingEntryTimeSaveArgs = {
  input: TimeTrackingEntryTimeSaveInput;
};


export type MutationTimeTrackingProjectMultiApproveArgs = {
  input: TimeTrackingProjectMultiApproveInput;
};


export type MutationTimeTrackingRemoveWeekYearProjectArgs = {
  input: TimeTrackingRemoveWeekYearProjectInput;
};


export type MutationTimeTrackingResponsibleToggleArgs = {
  input: TimeTrackingResponsibleToggleInput;
};


export type MutationTimeTrackingRowRemoveArgs = {
  input: TimeTrackingRowRemoveInput;
};


export type MutationTimeTrackingSapEmployeeWeekRecordAddArgs = {
  input: TimeTrackingSapEmployeeWeekRecordAddInput;
};


export type MutationTimeTrackingSapTransmitArgs = {
  input: TimeTrackingSapTransmitInput;
};


export type MutationTimeTrackingSwitchMultiSapEmployeeArgs = {
  input: TimeTrackingSwitchMultiSapEmployeeInput;
};


export type MutationTimeTrackingSwitchProjectArgs = {
  input: TimeTrackingSwitchProjectInput;
};


export type MutationTimeTrackingSwitchSapEmployeeArgs = {
  input: TimeTrackingSwitchSapEmployeeInput;
};


export type MutationTimeTrackingUnknownEmployeeUpdateArgs = {
  input: TimeTrackingUnknownEmployeeUpdateInput;
};


export type MutationTimeTrackingUnknownEmployeeWeekRecordAddArgs = {
  input: TimeTrackingUnknownEmployeeWeekRecordAddInput;
};


export type MutationTimeTrackingWeekRecordSwitchProjectArgs = {
  input: TimeTrackingWeekRecordSwitchProjectInput;
};


export type MutationTimesheetGeneratePdfByEmployeesInRangeArgs = {
  input: TimesheetGeneratePdfByEmployeesInRange;
};


export type MutationTimesheetGeneratePdfByProjectsInRangeArgs = {
  input: TimesheetGeneratePdfByProjectsInRange;
};


export type MutationToggleShowSubProjectHoursArgs = {
  input: ToggleShowSubProjectHoursInput;
};


export type MutationUpdateCatalogueArgs = {
  input: UpdateCatalogueInput;
};


export type MutationUpdateFolderForFrameworkArgs = {
  input: UpdateFolderForFrameworkInput;
};


export type MutationUpdateFolderForFreeFormArgs = {
  input: UpdateFolderForFreeFormInput;
};


export type MutationUpdateFolderOperationArgs = {
  input: UpdateFolderOperationInput;
};


export type MutationUpdateOfferCalculationArgs = {
  input: UpdateOfferCalculationInput;
};


export type MutationUpdateOfferSortingForFrameworkArgs = {
  input: UpdateOfferSortingForFrameworkInput;
};


export type MutationUpdateOfferSortingForFreeFormArgs = {
  input: UpdateOfferSortingForFreeFormInput;
};


export type MutationUpdateOperationArgs = {
  input: UpdateOperationInput;
};


export type MutationUpdateProjectStatusArgs = {
  input: UpdateProjectStatusInput;
};


export type MutationUpdateTaxRateArgs = {
  input: UpdateTaxRateInput;
};


export type MutationUploadAcceptanceReportSignatureArgs = {
  file: Scalars['Upload']['input'];
  input: UploadAcceptanceReportSignatureInput;
};


export type MutationUploadCatalogueArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadEditorImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadManualPdfToAcceptanceReportArgs = {
  file: Scalars['Upload']['input'];
  input: UploadManualPdfToAcceptanceReportInput;
};


export type MutationUploadManualPdfToOvertimeArgs = {
  file: Scalars['Upload']['input'];
  input: UploadManualPdfToOvertimeInput;
};


export type MutationUploadOvertimeSignatureArgs = {
  file: Scalars['Upload']['input'];
  input: UploadOvertimeSignatureInput;
};


export type MutationUploadRiskAssessmentSignatureArgs = {
  file: Scalars['Upload']['input'];
  input: UploadRiskAssessmentSignatureInput;
};


export type MutationViewerLanguageUpdateArgs = {
  input: ViewerLanguageUpdateInput;
};


export type MutationViewerSetProjectViewedArgs = {
  input: ViewerSetProjectViewedInput;
};


export type MutationWatchEventsArgs = {
  input: WatchEventsInput;
};

export type Notable = {
  note?: Maybe<DriveEntryNote>;
};

export enum NumerableDocumentType {
  Overtime = 'OVERTIME'
}

export type Obstruction = DocumentInterface & {
  __typename?: 'Obstruction';
  /** The user who is the owner of this obstruction */
  addedBy: User;
  /** Name of the client. */
  clientName: Scalars['String']['output'];
  /** Creation date of the obstruction */
  createdAt: Scalars['Date']['output'];
  /** Date of the obstruction. */
  date?: Maybe<Scalars['Date']['output']>;
  draftProjectNumber?: Maybe<Scalars['String']['output']>;
  /** Facts of the obstruction */
  facts: Array<ObstructionFact>;
  /** Document ID of the obstruction. */
  id: Scalars['ID']['output'];
  /** Images of the obstruction */
  images: Array<ObstructionImage>;
  /** Logs of the obstruction */
  logs?: Maybe<Logs>;
  /** Name of the obstruction. */
  name: Scalars['String']['output'];
  /** Obstruction pdf path */
  pdfPath: Scalars['String']['output'];
  /** Professions of the obstruction. */
  professions: Array<Scalars['String']['output']>;
  /** Project of the obstruction */
  project: Project;
  /** Signature of the obstruction */
  signatures: Array<ObstructionSignature>;
  /** Status of the obstruction */
  status: ObstructionStatus;
  /** Update date of the obstruction */
  updatedAt: Scalars['Date']['output'];
  /** Indicates whether the viewer can archive the obstruction */
  viewerCanArchive: Scalars['Boolean']['output'];
  /** indicates whether the obstruction is assignable to a project */
  viewerCanAssign: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can remove the obstruction */
  viewerCanRemove: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can sign the obstruction */
  viewerCanSign: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the obstruction */
  viewerCanUpdate: Scalars['Boolean']['output'];
};


export type ObstructionLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ObstructionArchiveInput = {
  /** Id of the obstruction. */
  documentId: Scalars['ID']['input'];
  /** SAP password */
  sapPassword: Scalars['String']['input'];
  /** SAP username */
  sapUsername: Scalars['String']['input'];
};

export type ObstructionArchivedLog = Log & LogWithActor & LogWithDate & ObstructionLog & {
  __typename?: 'ObstructionArchivedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ObstructionArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
};

export type ObstructionAssignedToProjectLog = Log & LogWithActor & LogWithDate & ObstructionLog & ProjectLog & {
  __typename?: 'ObstructionAssignedToProjectLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ObstructionAssignedToProjectLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** name of the target project */
  projectName: Scalars['String']['output'];
};

export type ObstructionCreatedLog = Log & LogWithActor & LogWithDate & LogWithProjectContractDate & ObstructionLog & {
  __typename?: 'ObstructionCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ObstructionCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
  /** Contract date of the project in ISO-8601 format */
  projectContractDate?: Maybe<Scalars['Date']['output']>;
};

export type ObstructionDeletedLog = Log & LogWithActor & LogWithDate & ObstructionLog & {
  __typename?: 'ObstructionDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ObstructionDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
};

export type ObstructionDuplicateInput = {
  /** Id of the obstruction */
  documentId: Scalars['ID']['input'];
};

export type ObstructionEmailSendInput = {
  /** Carbon copies of the mail */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content of the email. */
  content: Scalars['String']['input'];
  /** Id of the obstruction. */
  documentId: Scalars['ID']['input'];
  /** Recipients of the email. */
  recipients: Array<Scalars['String']['input']>;
  /** Subject of the email. */
  subject: Scalars['String']['input'];
};

export type ObstructionEmailSentLog = Log & LogWithActor & LogWithDate & LogWithEmail & ObstructionLog & {
  __typename?: 'ObstructionEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the obstruction sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that obstruction sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the ObstructionEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
};

export type ObstructionFact = {
  __typename?: 'ObstructionFact';
  /** Description of the obstruction fact */
  description: Scalars['String']['output'];
  /** Title of the obstruction fact */
  title: Scalars['String']['output'];
};

export type ObstructionFactSaveInput = {
  /** Description of the obstruction fact */
  description: Scalars['String']['input'];
  /** Title of the obstruction fact */
  title: Scalars['String']['input'];
};

/** An obstruction image */
export type ObstructionImage = {
  __typename?: 'ObstructionImage';
  /** ID of the image */
  id: Scalars['ID']['output'];
  /** Label of the image */
  label?: Maybe<Scalars['String']['output']>;
  /** Thumbnail of the image */
  thumbnail: Scalars['String']['output'];
  /** Full url of the image */
  url: Scalars['String']['output'];
};


/** An obstruction image */
export type ObstructionImageThumbnailArgs = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type ObstructionImageInput = {
  /** Id of the image. */
  imageId: Scalars['ID']['input'];
  /** Label for the image. */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ObstructionLog = {
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ObstructionLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
};

export type ObstructionSaveInput = {
  /** Name of the client. */
  clientName: Scalars['String']['input'];
  /** Date of the obstruction. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Document ID of the obstruction. */
  documentId: Scalars['ID']['input'];
  draftProjectNumber?: InputMaybe<Scalars['String']['input']>;
  /** Facts of the obstruction */
  facts: Array<ObstructionFactSaveInput>;
  /** Images for the obstruction */
  images: Array<ObstructionImageInput>;
  /** Contractor of the obstruction. */
  professions: Array<Scalars['String']['input']>;
};

export type ObstructionSignInput = {
  /** ID of the obstruction */
  documentId: Scalars['ID']['input'];
  /** Full name of the signatory */
  fullName: Scalars['String']['input'];
  /** Image of the signature */
  image: Scalars['Upload']['input'];
};

export type ObstructionSignature = {
  __typename?: 'ObstructionSignature';
  /** Creation date of the signature */
  createdAt: Scalars['Date']['output'];
  /** Full name of the signatory */
  fullName: Scalars['String']['output'];
  /** Image path of the signature */
  imagePath: Scalars['String']['output'];
};

export type ObstructionSignedLog = Log & LogWithActor & LogWithDate & ObstructionLog & {
  __typename?: 'ObstructionSignedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ObstructionSignedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
};

/** Obstruction status enum */
export enum ObstructionStatus {
  Archived = 'ARCHIVED',
  Open = 'OPEN',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export type ObstructionUpdatedLog = Log & LogWithActor & LogWithDate & LogWithProjectContractDate & ObstructionLog & {
  __typename?: 'ObstructionUpdatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ObstructionUpdatedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  obstructionId: Scalars['ID']['output'];
  /** Contract date of the project in ISO-8601 format */
  projectContractDate?: Maybe<Scalars['Date']['output']>;
};

/** Offer is the type for offer. */
export type Offer = AssignableInterface & DocumentInterface & RemovableInterface & {
  __typename?: 'Offer';
  /** The user who is owner of this offer */
  addedBy: User;
  /** Catalogue of the offer if it is a framework offer. */
  catalogue?: Maybe<Catalogue>;
  /** It returns all folders and subfolder in this offer */
  folders: Array<Folder>;
  /** ID of the offer */
  id: Scalars['ID']['output'];
  /** Logs of the offer */
  logs?: Maybe<Logs>;
  /** Meta data for offer. */
  meta?: Maybe<OfferMeta>;
  /** Mode of the offer */
  mode: OfferMode;
  /** Name of the offer */
  name: Scalars['String']['output'];
  /** Special Offer ID of the offer */
  offerId: Scalars['ID']['output'];
  /** Pdf path for the offer if it has been generated before. */
  pdfPath?: Maybe<Scalars['String']['output']>;
  /** Project of the offer */
  project: Project;
  /** Status of the offer */
  status: OfferStatus;
  /** Price summary of the offer */
  summary: OfferSummary;
  /** Type of the offer */
  type: OfferType;
  /** Last modified date for the offer */
  updatedAt: Scalars['Date']['output'];
  /** Indicates whether the viewer can assign the offer to a project */
  viewerCanAssign: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can export the offer */
  viewerCanExport: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can remove the offer */
  viewerCanRemove: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the offer */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the offer tax rate */
  viewerCanUpdateTaxRate: Scalars['Boolean']['output'];
};


/** Offer is the type for offer. */
export type OfferLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferCreatedLog = Log & LogWithActor & LogWithDate & OfferLog & {
  __typename?: 'OfferCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OfferCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the offer */
  name: Scalars['String']['output'];
  /** ID of the offer */
  offerId: Scalars['ID']['output'];
};

export type OfferDeletedLog = Log & LogWithActor & LogWithDate & OfferLog & {
  __typename?: 'OfferDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OfferDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the offer */
  name: Scalars['String']['output'];
  /** ID of the offer */
  offerId: Scalars['ID']['output'];
};

/** OfferDraftClientMetaData is the type for offer draft client meta data. */
export type OfferDraftClientMetaData = {
  __typename?: 'OfferDraftClientMetaData';
  /** Address of the draft client. */
  address?: Maybe<Scalars['String']['output']>;
  /** City of the draft client. */
  city?: Maybe<Scalars['String']['output']>;
  /** Name of the draft client. */
  name?: Maybe<Scalars['String']['output']>;
  /** Zip code of the draft client. */
  zip?: Maybe<Scalars['String']['output']>;
};

export type OfferDraftClientMetaDataInput = {
  /** Address of the draft client. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** City of the draft client. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Name of the draft client. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Zip code of the draft client. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** OfferDraftClientMetaData is the type for offer draft client meta data. */
export type OfferDraftConstructionSiteMetaData = {
  __typename?: 'OfferDraftConstructionSiteMetaData';
  /** Address of the draft client. */
  address?: Maybe<Scalars['String']['output']>;
  /** City of the draft client. */
  city?: Maybe<Scalars['String']['output']>;
  /** Name of the draft client. */
  name?: Maybe<Scalars['String']['output']>;
  /** Zip code of the draft client. */
  zip?: Maybe<Scalars['String']['output']>;
};

export type OfferEmailSentLog = Log & LogWithActor & LogWithDate & LogWithEmail & OfferLog & {
  __typename?: 'OfferEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** Email addresses of the offer email */
  emails: Array<Scalars['String']['output']>;
  /** ID of the OfferEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the offer */
  name: Scalars['String']['output'];
  /** ID of the offer */
  offerId: Scalars['ID']['output'];
};

export type OfferExportedToBotLog = Log & LogWithActor & LogWithDate & OfferLog & {
  __typename?: 'OfferExportedToBotLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OfferExportedToBotLog */
  id: Scalars['ID']['output'];
  /** Name of the offer */
  name: Scalars['String']['output'];
  /** ID of the offer */
  offerId: Scalars['ID']['output'];
};

export type OfferFrameworkSaveInput = {
  /** Catalogue ID of the offer. */
  catalogueId: Scalars['String']['input'];
  /** Document ID of the offer. */
  documentId: Scalars['ID']['input'];
  /** Meta data for offer. */
  meta?: InputMaybe<OfferMetaInput>;
  mode: OfferMode;
  /** Offer name. */
  name: Scalars['String']['input'];
};

export type OfferFreeFormSaveInput = {
  /** Document ID of the offer. */
  documentId: Scalars['ID']['input'];
  /** Meta data for offer. */
  meta?: InputMaybe<OfferMetaInput>;
  mode: OfferMode;
  /** Offer name. */
  name: Scalars['String']['input'];
};

export type OfferLog = {
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OfferLog */
  id: Scalars['ID']['output'];
  /** Name of the offer */
  name: Scalars['String']['output'];
  /** ID of the offer */
  offerId: Scalars['ID']['output'];
};

/** OfferMeta is the type for offer meta. */
export type OfferMeta = {
  __typename?: 'OfferMeta';
  /** Draft client meta data. */
  draftClient?: Maybe<OfferDraftClientMetaData>;
  /** Draft construction site meta data. */
  draftConstructionSite?: Maybe<OfferDraftConstructionSiteMetaData>;
};

export type OfferMetaInput = {
  /** Draft client meta data. */
  draftClient?: InputMaybe<OfferDraftClientMetaDataInput>;
  /** Draft construction site meta data. */
  draftConstructionSite?: InputMaybe<OfferDraftClientMetaDataInput>;
};

/** Offer mode enum */
export enum OfferMode {
  AliasNumber = 'ALIAS_NUMBER',
  SystemNumber = 'SYSTEM_NUMBER'
}

/** Offer Sortable type enum */
export enum OfferSortableType {
  Folder = 'FOLDER',
  FolderOperation = 'FOLDER_OPERATION'
}

/** Offer status enum */
export enum OfferStatus {
  Archived = 'ARCHIVED',
  Open = 'OPEN'
}

/** Price summary of the offer */
export type OfferSummary = {
  __typename?: 'OfferSummary';
  /** Extra prices of the offer */
  extraPrices: Array<ExtraPrice>;
  /** Gross price of the offer */
  grossPrice: Scalars['Float']['output'];
  /** Tax price of the offer */
  taxPrice: Scalars['Float']['output'];
  /** Tax rate */
  taxRate: Scalars['Float']['output'];
  /** Total optional price of the offer */
  totalOptionalPrice: Scalars['Float']['output'];
  /** Total price of the offer */
  totalPrice: Scalars['Float']['output'];
};

/** Offer type enum */
export enum OfferType {
  Framework = 'FRAMEWORK',
  FreeForm = 'FREE_FORM'
}

/** Operation from a catalogue. */
export type Operation = {
  __typename?: 'Operation';
  /** Calculated part no of the operation */
  calculatedPartNo: Scalars['String']['output'];
  /** Category of the offer. */
  category: Category;
  /** Description for the operation */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the operation has any missing field or not */
  hasMissingFields: Scalars['Boolean']['output'];
  /** ID of the operation */
  id: Scalars['ID']['output'];
  /** Name of the operation */
  name?: Maybe<Scalars['String']['output']>;
  /** Part no of the operation */
  partNo: Scalars['String']['output'];
  /** Price no of the operation */
  price?: Maybe<Scalars['Float']['output']>;
  /** Unit of the operation */
  unit?: Maybe<OperationUnit>;
  /** Whether the operation can select as multiple operations or not */
  viewerCanSelectAsMultiple: Scalars['Boolean']['output'];
};

export type OperationFilter = {
  excludedTypes?: InputMaybe<Array<SivOperationType>>;
  includedTypes?: InputMaybe<Array<SivOperationType>>;
};

/** Operation Payment from a folder operation. */
export type OperationPayment = {
  __typename?: 'OperationPayment';
  /** Base price of the operation */
  basePrice?: Maybe<Scalars['Float']['output']>;
  /** Value of the the discount or surcharge. */
  discountOrSurchargeValue?: Maybe<Scalars['Float']['output']>;
  /** Type of the discount or surcharge value. */
  discountOrSurchargeValueType?: Maybe<DiscountOrSurchargeValueType>;
  /** Is total price flat */
  flat: Scalars['Boolean']['output'];
  /** Total price of the operation */
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type OperationPaymentInput = {
  /** Value of the the discount or surcharge. */
  discountOrSurchargeValue?: InputMaybe<Scalars['Float']['input']>;
  /** Type of the discount or surcharge value. */
  discountOrSurchargeValueType?: InputMaybe<DiscountOrSurchargeValueType>;
  /** Is total price flat */
  flat: Scalars['Boolean']['input'];
  /** Total price of the operation. */
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
};

/** Unit for the catalogue operation. */
export enum OperationUnit {
  CubicMeter = 'CUBIC_METER',
  Day = 'DAY',
  FlatRate = 'FLAT_RATE',
  Hour = 'HOUR',
  Kilogram = 'KILOGRAM',
  Liter = 'LITER',
  Meter = 'METER',
  Quantity = 'QUANTITY',
  SquareMeter = 'SQUARE_METER'
}

export type Overtime = AssignableInterface & DocumentInterface & RemovableInterface & {
  __typename?: 'Overtime';
  addedBy: User;
  alias?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientNameComputed?: Maybe<Scalars['String']['output']>;
  clientReference?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionComputed?: Maybe<Scalars['String']['output']>;
  draftProjectNumber?: Maybe<Scalars['String']['output']>;
  employees: Array<OvertimeEmployee>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  images: Array<OvertimeImage>;
  /** Logs of the overtime */
  logs?: Maybe<Logs>;
  manualPdfPath?: Maybe<Scalars['String']['output']>;
  meta: OvertimeMeta;
  name: Scalars['String']['output'];
  no: Scalars['Int']['output'];
  noComputed: Scalars['String']['output'];
  orderDate: Scalars['Date']['output'];
  pdfPath: Scalars['String']['output'];
  professions?: Maybe<Array<Scalars['String']['output']>>;
  project: Project;
  projectNumberComputed?: Maybe<Scalars['String']['output']>;
  signatures: Array<OvertimeSignature>;
  status: OvertimeStatus;
  updatedAt: Scalars['Date']['output'];
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanAssign: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanRemoveManualPdf: Scalars['Boolean']['output'];
  viewerCanSendExternalLink: Scalars['Boolean']['output'];
  viewerCanSign: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanUploadManualPdf: Scalars['Boolean']['output'];
  workDescription: Scalars['String']['output'];
  workName: Scalars['String']['output'];
};


export type OvertimeLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OvertimeArchivedLog = Log & LogWithActor & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeArchivedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeAssignedToProjectLog = Log & LogWithActor & LogWithDate & OvertimeLog & ProjectLog & {
  __typename?: 'OvertimeAssignedToProjectLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeAssignedToProjectLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** name of the project */
  projectName: Scalars['String']['output'];
};

export type OvertimeCreatedLog = Log & LogWithActor & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeCustomEmployee = OvertimeEmployee & {
  __typename?: 'OvertimeCustomEmployee';
  extraHours?: Maybe<Scalars['Float']['output']>;
  fullName: Scalars['String']['output'];
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated machinesUsage will be used instead. This field will be removed on 01.04.2026. */
  machinesHours?: Maybe<Scalars['Float']['output']>;
  machinesUsage?: Maybe<Scalars['String']['output']>;
  materialSurcharge?: Maybe<Scalars['String']['output']>;
  role: WorkerRole;
};

export type OvertimeCustomEmployeeSaveInput = {
  extraHours?: InputMaybe<Scalars['Float']['input']>;
  fullName: Scalars['String']['input'];
  hours?: InputMaybe<Scalars['Float']['input']>;
  machinesHours?: InputMaybe<Scalars['Float']['input']>;
  machinesUsage?: InputMaybe<Scalars['String']['input']>;
  materialSurcharge?: InputMaybe<Scalars['String']['input']>;
  role: WorkerRole;
};

export type OvertimeDeletedLog = Log & LogWithActor & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeDeletedSapEmployee = OvertimeEmployee & {
  __typename?: 'OvertimeDeletedSAPEmployee';
  employeeId: Scalars['ID']['output'];
  extraHours?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated machinesUsage will be used instead. This field will be removed on 01.04.2026. */
  machinesHours?: Maybe<Scalars['Float']['output']>;
  machinesUsage?: Maybe<Scalars['String']['output']>;
  materialSurcharge?: Maybe<Scalars['String']['output']>;
};

export type OvertimeEmailSentLog = Log & LogWithActor & LogWithDate & LogWithEmail & OvertimeLog & {
  __typename?: 'OvertimeEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the overtime sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that overtime sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the OvertimeEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeEmployee = {
  extraHours?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated machinesUsage will be used instead. This field will be removed on 01.04.2026. */
  machinesHours?: Maybe<Scalars['Float']['output']>;
  machinesUsage?: Maybe<Scalars['String']['output']>;
  materialSurcharge?: Maybe<Scalars['String']['output']>;
};

export type OvertimeEmployeeSaveInput = {
  customEmployee?: InputMaybe<OvertimeCustomEmployeeSaveInput>;
  sapEmployee?: InputMaybe<OvertimeSapEmployeeSaveInput>;
};

export type OvertimeExternalEmailSentLog = Log & LogWithActor & LogWithDate & LogWithEmail & OvertimeLog & {
  __typename?: 'OvertimeExternalEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the overtime sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that overtime sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the OvertimeExternalEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeExternalLinkExpiredLog = Log & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeExternalLinkExpiredLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** Expired date of the overtime external link in ISO-8601 format */
  expiredDate: Scalars['Date']['output'];
  /** ID of the OvertimeExternalLinkExpiredLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeExternalSignatureUploadInput = {
  fullName: Scalars['String']['input'];
  overtimeId: Scalars['ID']['input'];
};

export type OvertimeImage = {
  __typename?: 'OvertimeImage';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  thumbnail: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type OvertimeImageThumbnailArgs = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type OvertimeImageInput = {
  imageId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type OvertimeLog = {
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeManuallySignedDocumentDeletedLog = Log & LogWithActor & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeManuallySignedDocumentDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeManuallySignedDocumentDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeManuallySignedLog = Log & LogWithActor & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeManuallySignedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeManuallySignedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeMeta = {
  __typename?: 'OvertimeMeta';
  totalHours: Scalars['Float']['output'];
};

export type OvertimeNotSignedLog = Log & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeNotSignedLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The day count of that document not signed */
  dayCount?: Maybe<Scalars['Int']['output']>;
  /** ID of the OvertimeNotSignedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimePdfPath = {
  __typename?: 'OvertimePdfPath';
  manualPdfPath?: Maybe<Scalars['String']['output']>;
  overtimeId: Scalars['ID']['output'];
  pdfPath?: Maybe<Scalars['String']['output']>;
};

export type OvertimeRenamedLog = Log & LogWithActor & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeRenamedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeRenamedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** Name of the overtime */
  oldName: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type OvertimeSapEmployee = OvertimeEmployee & {
  __typename?: 'OvertimeSAPEmployee';
  automaticRole: Scalars['Boolean']['output'];
  employee: Employee;
  extraHours?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated machinesUsage will be used instead. This field will be removed on 01.04.2026. */
  machinesHours?: Maybe<Scalars['Float']['output']>;
  machinesUsage?: Maybe<Scalars['String']['output']>;
  materialSurcharge?: Maybe<Scalars['String']['output']>;
  role?: Maybe<WorkerRole>;
};

export type OvertimeSapEmployeeSaveInput = {
  automaticRole: Scalars['Boolean']['input'];
  employeeId: Scalars['ID']['input'];
  extraHours?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  machinesHours?: InputMaybe<Scalars['Float']['input']>;
  machinesUsage?: InputMaybe<Scalars['String']['input']>;
  materialSurcharge?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<WorkerRole>;
};

export type OvertimeSaveInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The client reference is the client's transaction number / order number.
   * It is usually used for major clients or clients with several projects at HS having an internal operational process which has unique IDs.
   */
  clientReference?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  draftProjectNumber?: InputMaybe<Scalars['String']['input']>;
  employees: Array<OvertimeEmployeeSaveInput>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  images: Array<OvertimeImageInput>;
  orderDate: Scalars['Date']['input'];
  /**
   * Also known as "trades"
   *
   * Professions are different specializations in the craft sector.
   * Examples include painting, drywall construction, scaffolding, plumbing and electrical work.
   */
  professions?: InputMaybe<Array<Scalars['String']['input']>>;
  workDescription: Scalars['String']['input'];
  workName: Scalars['String']['input'];
};

export type OvertimeSignature = SignatureInterface & {
  __typename?: 'OvertimeSignature';
  createdAt: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imagePath: Scalars['String']['output'];
  overtime: Overtime;
  type: SignatureType;
};

export type OvertimeSignedByCustomerLog = Log & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeSignedByCustomerLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeSignedByCustomerLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export enum OvertimeStatus {
  Archived = 'ARCHIVED',
  ManuallySigned = 'MANUALLY_SIGNED',
  Open = 'OPEN',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export type OvertimeUpdatedLog = Log & LogWithActor & LogWithDate & OvertimeLog & {
  __typename?: 'OvertimeUpdatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the OvertimeUpdatedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** ID of the overtime */
  overtimeId: Scalars['ID']['output'];
};

export type PspdfKitFormField = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Pagination = {
  __typename?: 'Pagination';
  current: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
};

export type Precaution = PrecautionInterface & {
  __typename?: 'Precaution';
  equipments: Array<Equipment>;
  id: Scalars['ID']['output'];
  precautionCategory: PrecautionCategory;
  sort: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrecautionCategory = {
  __typename?: 'PrecautionCategory';
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  precautions: Array<Precaution>;
  sort: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrecautionInterface = {
  id: Scalars['ID']['output'];
  precautionCategory: PrecautionCategory;
  title: Scalars['String']['output'];
};

export enum PresenceType {
  Auto = 'AUTO',
  ByJobTitle = 'BY_JOB_TITLE',
  ByName = 'BY_NAME'
}

export type ProfitCenter = {
  __typename?: 'ProfitCenter';
  address?: Maybe<ProfitCenterAddress>;
  hsExternalId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ProfitCenter>;
  projectCount: Scalars['Int']['output'];
};

export type ProfitCenterAddress = {
  __typename?: 'ProfitCenterAddress';
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/** Comprehensive daily documentation of construction site activities, conditions, and personnel. Serves as an official record capturing work performed, environmental conditions, personnel presence, and special events for a specific project on a given date. */
export type ProjCal_DailyReport = {
  __typename?: 'ProjCal_DailyReport';
  activities?: Maybe<Array<ProjCal_DailyReportActivity>>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['String']['output'];
  documentId?: Maybe<Scalars['ID']['output']>;
  environment?: Maybe<ProjCal_DailyReportEnvironmentalInfluences>;
  id: Scalars['ID']['output'];
  presence?: Maybe<ProjCal_DailyReportPresence>;
  projectId: Scalars['String']['output'];
  specialEvents?: Maybe<ProjCal_DailyReportSpecialEvents>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Work activities performed on the construction site. Activities can be entered as free text, selected from the Performance Register (Leistungsverzeichnis - LV) for linkage to planned operations, or automatically imported from the Performance Register. */
export type ProjCal_DailyReportActivity = {
  comment?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
};

/** An activity selected from the Performance Register (Leistungsverzeichnis - LV) list. Links the reported activity to a specific operation in the project plan, providing ordinal number and operation ID for precise reference to planned work items. */
export type ProjCal_DailyReportActivityFromLv = ProjCal_DailyReportActivity & {
  __typename?: 'ProjCal_DailyReportActivityFromLv';
  comment?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  lvOperationId?: Maybe<Scalars['String']['output']>;
  ordinalNumber?: Maybe<Scalars['String']['output']>;
};

/** An activity automatically imported from the Performance Register (Leistungsverzeichnis - LV). These activities are generated by the system based on project planning data, inheriting LV operation references without manual selection. */
export type ProjCal_DailyReportActivityFromLvAuto = ProjCal_DailyReportActivity & {
  __typename?: 'ProjCal_DailyReportActivityFromLvAuto';
  comment?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  lvOperationId?: Maybe<Scalars['String']['output']>;
  ordinalNumber?: Maybe<Scalars['String']['output']>;
};

/** Input for recording work activities performed on site. Activities can be entered as free text, selected from the Performance Register (Leistungsverzeichnis - LV) list, or automatically imported from the Performance Register. Type determines which fields are required. */
export type ProjCal_DailyReportActivityInput = {
  /** Additional notes, observations, or clarifications about this activity. Use for context that doesn't fit in the description. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Description of the work performed, such as "Concrete pouring" or "Steel reinforcement installation". Be clear and specific. */
  description: Scalars['String']['input'];
  /** Unique identifier of the Performance Register (Leistungsverzeichnis - LV) operation. Used to link activity to specific planned work item. Required when type is LV or LV_AUTO. */
  lvOperationId?: InputMaybe<Scalars['String']['input']>;
  /** Ordinal number from the Performance Register (Leistungsverzeichnis - LV), e.g., "01.02.03". Required when type is LV or LV_AUTO. */
  ordinalNumber?: InputMaybe<Scalars['String']['input']>;
  /** Type of activity: FREE_TEXT for manual entries, LV for activities selected from the Performance Register (Leistungsverzeichnis) list, LV_AUTO for activities automatically imported from the Performance Register. */
  type: ActivityType;
};

/** A manually entered activity with custom description, allowing flexible documentation of work performed that may not be linked to specific service specification items. */
export type ProjCal_DailyReportActivityWithFreeText = ProjCal_DailyReportActivity & {
  __typename?: 'ProjCal_DailyReportActivityWithFreeText';
  comment?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
};

/** Input for clearing an existing daily report. Requires the report ID and current updatedAt timestamp for optimistic locking. Must match the current value in the database. */
export type ProjCal_DailyReportClearInput = {
  id: Scalars['ID']['input'];
  /** Last update timestamp of the report being cleared. Used for optimistic locking to prevent concurrent clear conflicts. Must match the current value in the database. */
  updatedAt: Scalars['DateTime']['input'];
};

/** Input for creating a new daily report for a specific project and date. Project ID must be a valid UUID, and date must be unique per project. All data sections are optional at creation time. */
export type ProjCal_DailyReportCreationInput = {
  /** New data for activities section. Setting this to `null` will delete data for this section */
  activities?: InputMaybe<Array<ProjCal_DailyReportActivityInput>>;
  /** ISO date, e.g. `2025-08-15` */
  date: Scalars['String']['input'];
  /** New data for environmental influences section. Setting this to `null` will delete data for this section */
  environment?: InputMaybe<ProjCal_DailyReportEnvironmentalInfluencesInput>;
  /** New data for presence section. Setting this to `null` will delete data for this section */
  presence?: InputMaybe<ProjCal_DailyReportPresenceInput>;
  /** The uuid of the project the report relates to */
  projectId: Scalars['String']['input'];
  /** New data for special events section. Setting this to `null` will delete data for this section */
  specialEvents?: InputMaybe<ProjCal_DailyReportSpecialEventInput>;
};

export enum ProjCal_DailyReportDocumentGenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** A single environmental measurement recorded at a specific time, including temperature, humidity, or other environmental conditions on the construction site. */
export type ProjCal_DailyReportEnvironmentMeasurement = {
  __typename?: 'ProjCal_DailyReportEnvironmentMeasurement';
  comment?: Maybe<Scalars['String']['output']>;
  localTime: Scalars['String']['output'];
  type: EnvironmentMeasurementType;
  value: Scalars['Float']['output'];
};

/** Input for recording a single environmental measurement at a specific time. Used to track temperature, humidity, or other environmental conditions throughout the workday. */
export type ProjCal_DailyReportEnvironmentMeasurementInput = {
  /** Up to 50 characters of comment text */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** ISO time, e.g. `12:00` */
  localTime: Scalars['String']['input'];
  /** Type of measurement being recorded: temperature (inside/outside/component) or humidity (inside/outside). Determines validation rules for the value field. */
  type: EnvironmentMeasurementType;
  /** Value of the measurement, e.g. 20.5 for temperature, 65 for humidity. Does not allow decimal places for humidity. Does not allow negative or values greater than 100 for humidity */
  value: Scalars['Float']['input'];
};

/** Environmental conditions and influences affecting the construction site, including weather conditions, site-specific descriptions, and detailed environmental measurements throughout the day. */
export type ProjCal_DailyReportEnvironmentalInfluences = {
  __typename?: 'ProjCal_DailyReportEnvironmentalInfluences';
  description?: Maybe<Scalars['String']['output']>;
  measurements?: Maybe<Array<ProjCal_DailyReportEnvironmentMeasurement>>;
  weather?: Maybe<WeatherType>;
};

/** Input for documenting environmental conditions affecting the construction site. Includes weather classification, descriptive notes, and detailed measurements. Can be set to null to remove all environmental data from a report. */
export type ProjCal_DailyReportEnvironmentalInfluencesInput = {
  /** Free-text description of environmental conditions, site-specific observations, or other relevant notes. Maximum 250 characters. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detailed environmental measurements recorded throughout the day. Maximum 5 measurements per type. Useful for quality assurance and compliance documentation. */
  measurements?: InputMaybe<Array<ProjCal_DailyReportEnvironmentMeasurementInput>>;
  /** General weather classification for the day. Set to null if not applicable or if only using the description field. */
  weather?: InputMaybe<WeatherType>;
};

/** Input needed to trigger the generation of a PDF document for a daily report. Carries the form sections (environment, specialEvents, activities, presence) so the latest data is atomically persisted before the Service Bus command is published. The updatedAt field is required for optimistic locking when an existing report is being overwritten; omit it when no report exists yet for this day. */
export type ProjCal_DailyReportPdfGenerationInput = {
  /** New data for activities section. Setting this to `null` will delete data for this section */
  activities?: InputMaybe<Array<ProjCal_DailyReportActivityInput>>;
  /** The date of the daily report for which the PDF should be generated. Should be provided in ISO 8601 format (YYYY-MM-DD). */
  date: Scalars['String']['input'];
  /** New data for environmental influences section. Setting this to `null` will delete data for this section */
  environment?: InputMaybe<ProjCal_DailyReportEnvironmentalInfluencesInput>;
  /** New data for presence section. Setting this to `null` will delete data for this section */
  presence?: InputMaybe<ProjCal_DailyReportPresenceInput>;
  /** The unique identifier of the project the daily report belongs to. Should be provided in UUID format. */
  projectId: Scalars['ID']['input'];
  /** New data for special events section. Setting this to `null` will delete data for this section */
  specialEvents?: InputMaybe<ProjCal_DailyReportSpecialEventInput>;
  /** Last update timestamp of the report being modified. Required for optimistic locking when a report already exists for this day. Omit when generating a PDF for a day with no saved report yet. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Personnel presence documentation on the construction site, capturing who was present and when. Supports different tracking methods: by job title (counts), by individual names, or automatically from integrated systems. */
export type ProjCal_DailyReportPresence = {
  maxEndTime?: Maybe<Scalars['String']['output']>;
  minStartTime?: Maybe<Scalars['String']['output']>;
};

/** Automatically captured personnel presence data from integrated time tracking or access control systems, providing reliable, system-generated records with unique worker identifiers and precise time tracking. */
export type ProjCal_DailyReportPresenceAuto = ProjCal_DailyReportPresence & {
  __typename?: 'ProjCal_DailyReportPresenceAuto';
  entries?: Maybe<Array<ProjCal_DailyReportPresenceEntryAuto>>;
  maxEndTime?: Maybe<Scalars['String']['output']>;
  minStartTime?: Maybe<Scalars['String']['output']>;
};

/** Aggregate personnel presence tracking by job role, useful for documenting workforce composition without individual worker identification, including overall earliest start and latest end times. */
export type ProjCal_DailyReportPresenceByJobTitle = ProjCal_DailyReportPresence & {
  __typename?: 'ProjCal_DailyReportPresenceByJobTitle';
  entries?: Maybe<Array<ProjCal_DailyReportPresenceEntryByJobTitle>>;
  maxEndTime?: Maybe<Scalars['String']['output']>;
  minStartTime?: Maybe<Scalars['String']['output']>;
};

/** Detailed personnel presence tracking with individual worker names, enabling precise documentation of who was present on site and their working hours, including overall time range. */
export type ProjCal_DailyReportPresenceByName = ProjCal_DailyReportPresence & {
  __typename?: 'ProjCal_DailyReportPresenceByName';
  entries?: Maybe<Array<ProjCal_DailyReportPresenceEntryByName>>;
  maxEndTime?: Maybe<Scalars['String']['output']>;
  minStartTime?: Maybe<Scalars['String']['output']>;
};

/** Automatically tracked personnel presence record with unique identifier, typically integrated from time tracking systems or access control, including worker name, job title, and precise working hours. */
export type ProjCal_DailyReportPresenceEntryAuto = {
  __typename?: 'ProjCal_DailyReportPresenceEntryAuto';
  endTime?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  jobTitle: JobTitleType;
  name: Scalars['String']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
};

/** Personnel presence record grouped by job title, documenting the number of workers per role and their working hours without individual name tracking. */
export type ProjCal_DailyReportPresenceEntryByJobTitle = {
  __typename?: 'ProjCal_DailyReportPresenceEntryByJobTitle';
  count: Scalars['Int']['output'];
  endTime?: Maybe<Scalars['String']['output']>;
  jobTitle: JobTitleType;
  startTime?: Maybe<Scalars['String']['output']>;
};

/** Personnel presence record with individual worker identification, tracking specific persons by name along with their job title and working hours. */
export type ProjCal_DailyReportPresenceEntryByName = {
  __typename?: 'ProjCal_DailyReportPresenceEntryByName';
  endTime?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  jobTitle: JobTitleType;
  name: Scalars['String']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
};

/** Input for recording personnel presence on site. Fields required depend on the presence type: BY_JOB_TITLE requires count, BY_NAME requires name, AUTO requires both name and identifier. Times are optional for flexible tracking. */
export type ProjCal_DailyReportPresenceEntryInput = {
  /** Worker count based on the job title */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** ISO time, e.g. `12:00` */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the worker (required for BY_NAME and AUTO types) */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Job title of the worker */
  jobTitle: JobTitleType;
  /** Name of the worker (required for BY_NAME and AUTO types) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ISO time, e.g. `12:00` */
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/** Input for documenting personnel presence on the construction site. Type determines the tracking method: BY_JOB_TITLE for aggregate counts, BY_NAME for individual tracking, or AUTO for system-integrated records. */
export type ProjCal_DailyReportPresenceInput = {
  /** List of presence records. Each entry represents one or more workers depending on the type. Can be null to indicate no personnel present. */
  entries?: InputMaybe<Array<ProjCal_DailyReportPresenceEntryInput>>;
  /** Tracking method: BY_JOB_TITLE for headcount per role, BY_NAME for individual worker records, AUTO for system-integrated time tracking. */
  type: PresenceType;
};

export enum ProjCal_DailyReportPresenceRecordingType {
  ByJobTitle = 'BY_JOB_TITLE',
  ByName = 'BY_NAME'
}

/** The attendance recording method (by name or by title) that will be used for new daily reports. */
export type ProjCal_DailyReportPresenceSettings = {
  __typename?: 'ProjCal_DailyReportPresenceSettings';
  /** The active method that must be used to record worker presence in new daily reports */
  recordingType: ProjCal_DailyReportPresenceRecordingType;
};

/** Set the new method for how worker presence and attendance will be recorded in daily site reports. */
export type ProjCal_DailyReportPresenceSettingsInput = {
  /** Choose the new presence recording method. Determines how worker attendance will be tracked and validated on site (with name or just job title). */
  recordingType: ProjCal_DailyReportPresenceRecordingType;
};

/** Configuration settings for daily reports in a project. Controls how daily reports are structured and recorded. */
export type ProjCal_DailyReportSettings = {
  __typename?: 'ProjCal_DailyReportSettings';
  /** Presence-related settings for daily reports. Includes configuration for attendance and worker presence tracking. */
  presence: ProjCal_DailyReportPresenceSettings;
};

/** Define how daily construction reports are structured and executed. */
export type ProjCal_DailyReportSettingsInput = {
  /** Attendance and presence tracking configuration for daily site reports. */
  presence: ProjCal_DailyReportPresenceSettingsInput;
};

/** Input for documenting notable events or unusual circumstances on the construction site, such as holidays, inspections, incidents, or other significant occurrences that should be formally recorded. */
export type ProjCal_DailyReportSpecialEventInput = {
  /** Description of the special event, such as "Public Holiday", "Site Inspection", "Safety Incident", or "Weather Stoppage". Be specific and concise. */
  description: Scalars['String']['input'];
};

/** Notable events or circumstances on the construction site that deviate from normal operations, such as holidays, site inspections, safety incidents, or other significant occurrences worth documenting. */
export type ProjCal_DailyReportSpecialEvents = {
  __typename?: 'ProjCal_DailyReportSpecialEvents';
  description: Scalars['String']['output'];
};

/** Input for updating an existing daily report. Requires the report ID and current updatedAt timestamp for optimistic locking. Only provided sections will be updated; omitted sections remain unchanged. Set sections to null to delete their data. */
export type ProjCal_DailyReportUpdateInput = {
  /** New data for activities section. Setting this to `null` will delete data for this section */
  activities?: InputMaybe<Array<ProjCal_DailyReportActivityInput>>;
  /** New data for environmental influences section. Setting this to `null` will delete data for this section */
  environment?: InputMaybe<ProjCal_DailyReportEnvironmentalInfluencesInput>;
  id: Scalars['ID']['input'];
  /** New data for presence section. Setting this to `null` will delete data for this section */
  presence?: InputMaybe<ProjCal_DailyReportPresenceInput>;
  /** New data for special events section. Setting this to `null` will delete data for this section */
  specialEvents?: InputMaybe<ProjCal_DailyReportSpecialEventInput>;
  /** Last update timestamp of the report being modified. Used for optimistic locking to prevent concurrent update conflicts. Must match the current value in the database. */
  updatedAt: Scalars['DateTime']['input'];
};

/** Response returned after deleting the daily report of one project and date. Every generation job for that day is removed. If the day had an unsigned generated PDF, that document record is removed too and the stored file is removed asynchronously. What happened to the day itself is carried by `dailyReport` — read its description before using this payload. */
export type ProjCal_DeleteDailyReportPayload = {
  __typename?: 'ProjCal_DeleteDailyReportPayload';
  /** The day restored from the latest signed document. Null when no signed document existed for this day, in which case the day’s report was deleted. A non-null value means the day was overwritten from the signed snapshot and any later edits were discarded — tell the user. */
  dailyReport?: Maybe<ProjCal_DailyReport>;
  /** The day of the deleted daily report, YYYY-MM-DD, decoded from the internal numeric representation. */
  date: Scalars['String']['output'];
  /** The stable unique identifier (UUID) of the unsigned document that was deleted. Null when the day had no generated document, in which case only the daily report was deleted. */
  documentId?: Maybe<Scalars['ID']['output']>;
  /** The Baumappe project the deleted daily report belonged to. */
  projectId: Scalars['ID']['output'];
};

/** An employee associated with a construction project. */
export type ProjCal_Employee = {
  __typename?: 'ProjCal_Employee';
  /** The unique identifier of the employee from the source system */
  employeeId: Scalars['String']['output'];
  /** Job title of the employee mapped out of SAP roles. Null if the role is not supported or not provided. */
  jobTitle?: Maybe<JobTitleType>;
  /** Full name of the employee */
  name: Scalars['String']['output'];
  /** The project ID this employee is associated with */
  projectId: Scalars['String']['output'];
};

/** Response returned after triggering the asynchronous generation of a PDF for a daily report. Contains documentId (stable across versions), correlationId (unique per generation attempt — used by the frontend to poll the status of THIS attempt), documentVersionNumber, and the saved dailyReport entity. */
export type ProjCal_GenerateDailyReportPdfPayload = {
  __typename?: 'ProjCal_GenerateDailyReportPdfPayload';
  /** Unique identifier (UUID) of this specific generation attempt. Use this with getDailyReportPdfStatusByCorrelationId to poll the status of the attempt. */
  correlationId: Scalars['ID']['output'];
  /** The daily report entity that was saved (created or updated) as part of this generate request. Always present on a successful response (the mutation throws on failure). Used by the client to seed local state. */
  dailyReport: ProjCal_DailyReport;
  /** The stable unique identifier (UUID) of the document. Reused across re-generations of the same daily report. */
  documentId: Scalars['ID']['output'];
  /** The version number assigned to this generation attempt. Starts at 1, increments per re-generation. */
  documentVersionNumber: Scalars['Int']['output'];
};

/** Metadata of a daily report PDF document, looked up by its stable documentId. */
export type ProjCal_GetDailyReportDocumentByDocumentIdPayload = {
  __typename?: 'ProjCal_GetDailyReportDocumentByDocumentIdPayload';
  createdAt: Scalars['String']['output'];
  /** YYYY-MM-DD decoded from internal numeric representation. */
  date: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  documentVersionNumber: Scalars['Int']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  /** ISO timestamp of when the document was signed. Null for unsigned (active) documents. */
  signedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

/** Status of a generation attempt identified by its correlationId. The initial signed URL is valid only for 2 hours. */
export type ProjCal_GetDailyReportPdfStatusPayload = {
  __typename?: 'ProjCal_GetDailyReportPdfStatusPayload';
  correlationId: Scalars['ID']['output'];
  documentId: Scalars['ID']['output'];
  documentVersionNumber: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  initialSignedUrl?: Maybe<Scalars['String']['output']>;
  status: ProjCal_DailyReportDocumentGenerationStatus;
};

/** Mutations for managing project calendar data. Provides operations to create and update daily reports and project calendar settings. */
export type ProjCal_Mutations = {
  __typename?: 'ProjCal_Mutations';
  /** Clears all data sections (environment, activities, presence, specialEvents) of an existing daily report, effectively resetting it while keeping the report entry with its projectId and date. If the report is already empty, this operation is a no-op and `updatedAt` is preserved. Otherwise returns the cleared report with a new updatedAt timestamp. */
  clearDailyReport: ProjCal_DailyReport;
  /** Create a new daily report. Returns the created daily report with all details. */
  createDailyReport: ProjCal_DailyReport;
  /** Deletes the daily report of one project and date. Refuses a day that has only signed documents, and refuses while a generation is in flight for that day. Every generation job for the day is removed. If the day has an unsigned generated PDF, that document record is removed too and the stored file is removed asynchronously; `documentId` is null when there was no such document. If a signed document exists for the same day, the day is restored from that document’s snapshot and returned in `dailyReport`; otherwise the day’s report is deleted and `dailyReport` is null. */
  deleteDailyReport: ProjCal_DeleteDailyReportPayload;
  /** Triggers a PDF document generation for a specific daily report. Returns a document ID that can be used to track the document generation job. */
  generateDailyReportPdf: ProjCal_GenerateDailyReportPdfPayload;
  /** Update an existing daily report. Returns the updated daily report with all details. */
  updateDailyReport: ProjCal_DailyReport;
  /** Update project-level settings for the construction diary. Requires the Baumappe project ID (UUID format). Provide only the settings you want to change. Returns the complete updated settings. */
  updateProjectSettings: ProjCal_Settings;
};


/** Mutations for managing project calendar data. Provides operations to create and update daily reports and project calendar settings. */
export type ProjCal_MutationsClearDailyReportArgs = {
  reportClearData: ProjCal_DailyReportClearInput;
};


/** Mutations for managing project calendar data. Provides operations to create and update daily reports and project calendar settings. */
export type ProjCal_MutationsCreateDailyReportArgs = {
  reportCreationData: ProjCal_DailyReportCreationInput;
};


/** Mutations for managing project calendar data. Provides operations to create and update daily reports and project calendar settings. */
export type ProjCal_MutationsDeleteDailyReportArgs = {
  date: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


/** Mutations for managing project calendar data. Provides operations to create and update daily reports and project calendar settings. */
export type ProjCal_MutationsGenerateDailyReportPdfArgs = {
  reportGenerationData: ProjCal_DailyReportPdfGenerationInput;
};


/** Mutations for managing project calendar data. Provides operations to create and update daily reports and project calendar settings. */
export type ProjCal_MutationsUpdateDailyReportArgs = {
  reportUpdateData: ProjCal_DailyReportUpdateInput;
};


/** Mutations for managing project calendar data. Provides operations to create and update daily reports and project calendar settings. */
export type ProjCal_MutationsUpdateProjectSettingsArgs = {
  id: Scalars['ID']['input'];
  settings: ProjCal_SettingsUpdateInput;
};

/** Queries for retrieving project calendar related data. */
export type ProjCal_Queries = {
  __typename?: 'ProjCal_Queries';
  /** Retrieve the daily report for a specific project on a given date. Requires the Baumappe project ID (UUID format). */
  getDailyReportByDateAndProjectId?: Maybe<ProjCal_DailyReport>;
  /** Retrieve a specific daily report by its unique ID. This is mostly useful to poll updates of a previously opened daily report. */
  getDailyReportById?: Maybe<ProjCal_DailyReport>;
  /** Retrieves metadata of a daily report PDF document by its stable documentId. Null if no document with that ID exists. */
  getDailyReportDocumentByDocumentId?: Maybe<ProjCal_GetDailyReportDocumentByDocumentIdPayload>;
  /** Retrieves the status of a specific generation attempt by its correlationId. Initial signed URL is valid only for 2 hours. */
  getDailyReportPdfStatusByCorrelationId: ProjCal_GetDailyReportPdfStatusPayload;
  /** Retrieves all daily reports for a specific project within an inclusive date range (startDate to endDate). The range must not exceed 9 months. */
  getDailyReportsByDateRangeAndProjectId: Array<ProjCal_DailyReport>;
  /** Retrieve all active employees for a specific project on a given date. An employee is considered active if they have not quit or their quitting date is after the specified date. Returns an empty array if no employees are found. */
  getEmployeesByDateAndProjectId: Array<ProjCal_Employee>;
  /** Returns the latest generation attempt for a (projectId, date) pair. Use this for frontend recovery when the in-flight correlationId was lost. */
  getLatestDailyReportPdfJobByProjectAndDate?: Maybe<ProjCal_GetDailyReportPdfStatusPayload>;
  /** Retrieve the latest daily report of a project before a given date. Use it to take over data from a previous day. Requires the Baumappe project ID (UUID format). */
  getPreviousDailyReportByDateAndProjectId?: Maybe<ProjCal_DailyReport>;
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetDailyReportByDateAndProjectIdArgs = {
  date: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetDailyReportByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetDailyReportDocumentByDocumentIdArgs = {
  documentId: Scalars['ID']['input'];
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetDailyReportPdfStatusByCorrelationIdArgs = {
  correlationId: Scalars['ID']['input'];
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetDailyReportsByDateRangeAndProjectIdArgs = {
  endDate: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetEmployeesByDateAndProjectIdArgs = {
  date: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetLatestDailyReportPdfJobByProjectAndDateArgs = {
  date: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


/** Queries for retrieving project calendar related data. */
export type ProjCal_QueriesGetPreviousDailyReportByDateAndProjectIdArgs = {
  date: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};

/** Project-level settings for project calendar. Contains all configuration options that control calendar component and daily report behavior. */
export type ProjCal_Settings = {
  __typename?: 'ProjCal_Settings';
  /** Controls how daily reports are configured. */
  dailyReport: ProjCal_DailyReportSettings;
};

/** Update project-specific configuration for the construction diary. */
export type ProjCal_SettingsUpdateInput = {
  /** Daily report configuration to be applied to the project calendar. */
  dailyReport: ProjCal_DailyReportSettingsInput;
};

/** Project for stitching */
export type Project = BaseProject & {
  __typename?: 'Project';
  addedBy: User;
  additionalName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field deprecated. You should use addressLine field instead of address field. */
  address?: Maybe<Scalars['String']['output']>;
  addressLine?: Maybe<Scalars['String']['output']>;
  bonusCalculation?: Maybe<BonusCalculation>;
  calendarSettings: ProjCal_Settings;
  city?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  colors: Array<ProjectColor>;
  contactPeople: Array<ContactPerson>;
  contentUpdatedAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  draft: Scalars['Boolean']['output'];
  drive: Drive;
  hsId?: Maybe<Scalars['String']['output']>;
  hsProjectNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCostCenter: Scalars['Boolean']['output'];
  isMainProject: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logs: Logs;
  name: Scalars['String']['output'];
  /** It returns all offers of the project */
  offers: Array<Offer>;
  ordered: Scalars['Boolean']['output'];
  partProjects: Array<PublicPartProject>;
  postCode?: Maybe<Scalars['String']['output']>;
  profitCenter?: Maybe<ProfitCenter>;
  projectNumber: Scalars['ID']['output'];
  relations?: Maybe<ProjectRelations>;
  riskAssessmentRegulation: RiskAssessmentRegulation;
  showSubProjectHours: Scalars['Boolean']['output'];
  siv?: Maybe<Siv>;
  sourceSystem: ProjectImportSourceSystem;
  status: ProjectStatus;
  street?: Maybe<Scalars['String']['output']>;
  syncable: Scalars['Boolean']['output'];
  timeTracking: ProjectTimeTracking;
  updatedAt: Scalars['Date']['output'];
  viewerCanUpdateStatus: Scalars['Boolean']['output'];
  viewerFollowsProject: Scalars['Boolean']['output'];
  viewerLogUnreadCount: Scalars['Int']['output'];
};


/** Project for stitching */
export type ProjectLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectAddressChangedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectAddressChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** Address of the project */
  address: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectAddressChangedLog */
  id: Scalars['ID']['output'];
  /** Old address of the project */
  oldAddress?: Maybe<Scalars['String']['output']>;
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectClientAddressChangedLog = Log & LogWithDate & ProjectLog & {
  __typename?: 'ProjectClientAddressChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** Client address of the project */
  clientAddress?: Maybe<Scalars['String']['output']>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectClientAddressChangedLog */
  id: Scalars['ID']['output'];
  /** Old client address of the project */
  oldClientAddress?: Maybe<Scalars['String']['output']>;
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectClientNameChangedLog = Log & LogWithDate & ProjectLog & {
  __typename?: 'ProjectClientNameChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** Client name of the project */
  clientName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectClientNameChangedLog */
  id: Scalars['ID']['output'];
  /** Old client name of the project */
  oldClientName?: Maybe<Scalars['String']['output']>;
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export enum ProjectColor {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type ProjectColorsChangeInput = {
  colors: Array<ProjectColor>;
  id: Scalars['ID']['input'];
};

export type ProjectContractDateChangedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectContractDateChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** Contract date of the project in ISO-8601 format */
  contractDate: Scalars['Date']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectContractDateChangedLog */
  id: Scalars['ID']['output'];
  /** Old contract date of the project in ISO-8601 format */
  oldContractDate?: Maybe<Scalars['Date']['output']>;
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectContractDateRemovedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectContractDateRemovedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectContractDateRemovedLog */
  id: Scalars['ID']['output'];
  /** Old contract date of the project in ISO-8601 format */
  oldContractDate: Scalars['Date']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectDateUpdateInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};

export enum ProjectExternalStatus {
  ActiveConstruction = 'ACTIVE_CONSTRUCTION',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Created = 'CREATED',
  Offered = 'OFFERED',
  Open = 'OPEN',
  Ordered = 'ORDERED',
  OrderNotReceived = 'ORDER_NOT_RECEIVED',
  Rejected = 'REJECTED',
  TerminatedWithoutInvoice = 'TERMINATED_WITHOUT_INVOICE'
}

export type ProjectExternalStatusChangedLog = Log & LogWithDate & ProjectLog & {
  __typename?: 'ProjectExternalStatusChangedLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** New status */
  externalStatus: ProjectExternalStatus;
  /** ID of the ProjectExternalStatusChangedLog */
  id: Scalars['ID']['output'];
  /** Old status */
  oldExternalStatus?: Maybe<ProjectExternalStatus>;
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** Project's import source */
  projectImportSourceSystem: ProjectImportSourceSystem;
  /** Project is ordered */
  projectIsOrdered: Scalars['Boolean']['output'];
};

export type ProjectImportError = ExternalProjectImportError | UnknownProjectImportError;

export enum ProjectImportSourceSystem {
  Dds = 'DDS',
  Itworun = 'ITWORUN',
  Vendoc = 'VENDOC'
}

export type ProjectImportedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectImportedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectImportedLog */
  id: Scalars['ID']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** Name of the project */
  projectName: Scalars['String']['output'];
  /** Number of the project */
  projectNumber: Scalars['ID']['output'];
  /** Source system which project imported from */
  sourceSystem: ProjectImportSourceSystem;
};

export type ProjectLog = {
  /** ID of the ProjectLog */
  id: Scalars['ID']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectMultiImportInput = {
  ids: Array<Scalars['String']['input']>;
};

export type ProjectMultiImportResponse = {
  __typename?: 'ProjectMultiImportResponse';
  faileds: Array<ProjectImportError>;
  succeeds: Array<Project>;
};

export type ProjectNameChangedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectNameChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectNameChangedLog */
  id: Scalars['ID']['output'];
  /** Name of the project */
  name: Scalars['String']['output'];
  /** Previous name of the project */
  oldName: Scalars['String']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectOfferNumberChangedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectOfferNumberChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectOfferNumberChangedLog */
  id: Scalars['ID']['output'];
  /** Offer number of the project */
  offerNumber: Scalars['String']['output'];
  /** Old offer number of the project */
  oldOfferNumber: Scalars['String']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectOrderNumberChangedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectOrderNumberChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectOrderNumberChangedLog */
  id: Scalars['ID']['output'];
  /** Offer number of the project */
  offerNumber: Scalars['String']['output'];
  /** Order number of the project */
  orderNumber: Scalars['String']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectProfitCenterChangedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectProfitCenterChangedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectProfitCenterChangedLog */
  id: Scalars['ID']['output'];
  /** Profit center id of the project */
  profitCenterId: Scalars['String']['output'];
  /** Profit center name of the project */
  profitCenterName: Scalars['String']['output'];
  /** ID of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectRelations = ChildProjectRelations | MainProjectRelations;

export enum ProjectSearchAnnouncementType {
  NewProjectListAnnouncement = 'NEW_PROJECT_LIST_ANNOUNCEMENT',
  NewProjectListOnboarding = 'NEW_PROJECT_LIST_ONBOARDING'
}

export type ProjectSearchByProjectDependenciesHit = ProjectSearchHit | ProjectSearchProjectDependencyGroupHit;

export type ProjectSearchByProjectDependenciesResponse = {
  __typename?: 'ProjectSearchByProjectDependenciesResponse';
  hits: Array<ProjectSearchByProjectDependenciesHit>;
  paginationMeta: ProjectSearchPaginationMeta;
};

export enum ProjectSearchColumn {
  Costs = 'COSTS',
  Hours = 'HOURS',
  LastUpdatedAt = 'LAST_UPDATED_AT',
  PerformanceLevel = 'PERFORMANCE_LEVEL',
  PlusMinusHours = 'PLUS_MINUS_HOURS',
  Profit = 'PROFIT',
  TotalHoursToBeDistributed = 'TOTAL_HOURS_TO_BE_DISTRIBUTED'
}

export type ProjectSearchExternalFilter = {
  status?: InputMaybe<Array<ProjectExternalStatus>>;
  type?: InputMaybe<Array<ExternalProjectType>>;
};

export type ProjectSearchExternalPaginationMeta = {
  __typename?: 'ProjectSearchExternalPaginationMeta';
  continuationToken?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ProjectSearchExternalResponse = {
  __typename?: 'ProjectSearchExternalResponse';
  paginationMeta: ProjectSearchExternalPaginationMeta;
  projects: Array<ExternalProject>;
};

export type ProjectSearchExternalSorting = {
  direction: ProjectSearchExternalSortingDirection;
  field: ProjectSearchExternalSortingField;
};

export enum ProjectSearchExternalSortingDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum ProjectSearchExternalSortingField {
  ProjectNumber = 'PROJECT_NUMBER',
  ProjectProfitCenter = 'PROJECT_PROFIT_CENTER',
  ProjectStatus = 'PROJECT_STATUS'
}

export type ProjectSearchFilter = {
  onlySubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  profitCenter?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectColor?: InputMaybe<Array<ProjectColor>>;
  projectStatus?: InputMaybe<Array<ProjectStatus>>;
  projectType?: InputMaybe<Array<ProjectType>>;
};

export type ProjectSearchFilterSet = {
  count: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type ProjectSearchFilterSetProfitCenterType = ProjectSearchFilterSet & {
  __typename?: 'ProjectSearchFilterSetProfitCenterType';
  count: Scalars['Int']['output'];
  profitCenter: ProfitCenter;
  selected: Scalars['Boolean']['output'];
};

export type ProjectSearchFilterSetProjectColor = ProjectSearchFilterSet & {
  __typename?: 'ProjectSearchFilterSetProjectColor';
  color: ProjectColor;
  count: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type ProjectSearchFilterSetProjectStatus = ProjectSearchFilterSet & {
  __typename?: 'ProjectSearchFilterSetProjectStatus';
  count: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
  status: ProjectStatus;
};

export type ProjectSearchFilterSetProjectType = ProjectSearchFilterSet & {
  __typename?: 'ProjectSearchFilterSetProjectType';
  count: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
  type: ProjectType;
};

export type ProjectSearchFilterSets = {
  __typename?: 'ProjectSearchFilterSets';
  profitCenter: Array<ProjectSearchFilterSetProfitCenterType>;
  projectColor: Array<ProjectSearchFilterSetProjectColor>;
  projectStatus: Array<ProjectSearchFilterSetProjectStatus>;
  projectType: Array<ProjectSearchFilterSetProjectType>;
};

export type ProjectSearchHighlight = {
  __typename?: 'ProjectSearchHighlight';
  field: ProjectSearchHighlightField;
  hits: Array<Scalars['String']['output']>;
};

export enum ProjectSearchHighlightField {
  AdditionalName = 'ADDITIONAL_NAME',
  Name = 'NAME',
  ProfitCenterName = 'PROFIT_CENTER_NAME',
  ProjectNumber = 'PROJECT_NUMBER',
  UpdatedAt = 'UPDATED_AT'
}

export type ProjectSearchHit = SearchHit & {
  __typename?: 'ProjectSearchHit';
  highlights: Array<ProjectSearchHighlight>;
  project: Project;
};

export type ProjectSearchPaginationMeta = {
  __typename?: 'ProjectSearchPaginationMeta';
  continuationToken?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ProjectSearchProfitCenterMeta = {
  __typename?: 'ProjectSearchProfitCenterMeta';
  profitCenter: ProfitCenter;
  projectCount: Scalars['Int']['output'];
};

export type ProjectSearchProfitCentersMetaResponse = {
  __typename?: 'ProjectSearchProfitCentersMetaResponse';
  meta: Array<ProjectSearchProfitCenterMeta>;
  totalProjectCount: Scalars['Int']['output'];
};

export type ProjectSearchProjectDependencyGroupHit = SearchHit & {
  __typename?: 'ProjectSearchProjectDependencyGroupHit';
  dependants: Array<ProjectSearchHit>;
  highlights: Array<ProjectSearchHighlight>;
  project: Project;
};

export type ProjectSearchResponse = {
  __typename?: 'ProjectSearchResponse';
  filterSet: ProjectSearchFilterSets;
  hits: Array<ProjectSearchHit>;
  paginationMeta: ProjectSearchPaginationMeta;
};


export type ProjectSearchResponseFilterSetArgs = {
  onlySelected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectSearchSetViewerExpandedGroupIdsPreferencesInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProjectSearchSetViewerFilterPreferencesInput = {
  profitCenter?: InputMaybe<Array<ProjectSearchSetViewerFilterPreferencesProfitCenterInput>>;
  projectColor?: InputMaybe<Array<ProjectSearchSetViewerFilterPreferencesProjectColorInput>>;
  projectStatus?: InputMaybe<Array<ProjectSearchSetViewerFilterPreferencesProjectStatusInput>>;
  projectType?: InputMaybe<Array<ProjectSearchSetViewerFilterPreferencesProjectTypeInput>>;
};

export type ProjectSearchSetViewerFilterPreferencesProfitCenterInput = {
  action: ViewerProjectSearchFilterPreferencesAction;
  profitCenterId: Scalars['ID']['input'];
};

export type ProjectSearchSetViewerFilterPreferencesProjectColorInput = {
  action: ViewerProjectSearchFilterPreferencesAction;
  projectColor: ProjectColor;
};

export type ProjectSearchSetViewerFilterPreferencesProjectStatusInput = {
  action: ViewerProjectSearchFilterPreferencesAction;
  projectStatus: ProjectStatus;
};

export type ProjectSearchSetViewerFilterPreferencesProjectTypeInput = {
  action: ViewerProjectSearchFilterPreferencesAction;
  projectType: ProjectType;
};

export type ProjectSearchSetViewerGroupingPreferencesInput = {
  groupedBy?: InputMaybe<ViewerProjectSearchGroupByPreference>;
};

export type ProjectSearchSetViewerProjectColumnsInput = {
  projectColumns: Array<ProjectSearchColumn>;
};

export type ProjectSearchSetViewerSortingPreferencesInput = {
  direction: SortingDirection;
  field: ProjectSearchSortingField;
};

export type ProjectSearchSorting = {
  direction: SortingDirection;
  field: ProjectSearchSortingField;
};

export enum ProjectSearchSortingField {
  HsProjectNumber = 'HS_PROJECT_NUMBER',
  ProjectProfitCenter = 'PROJECT_PROFIT_CENTER',
  ProjectStatus = 'PROJECT_STATUS'
}

export type ProjectSorting = {
  direction: SortingDirection;
  field: ProjectSortingField;
};

export enum ProjectSortingField {
  HsProjectNumber = 'HS_PROJECT_NUMBER',
  Name = 'NAME',
  ProfitCenter = 'PROFIT_CENTER',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export enum ProjectStatus {
  ActiveConstruction = 'ACTIVE_CONSTRUCTION',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Offered = 'OFFERED',
  Ordered = 'ORDERED',
  Registered = 'REGISTERED'
}

export type ProjectStatusUpdatedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectStatusUpdatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** Old status */
  from: ProjectStatus;
  /** ID of the ProjectStatusUpdatedLog */
  id: Scalars['ID']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** New status */
  to: ProjectStatus;
};

export type ProjectSyncedLog = Log & LogWithActor & LogWithDate & ProjectLog & {
  __typename?: 'ProjectSyncedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the ProjectSyncedLog */
  id: Scalars['ID']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
};

export type ProjectTimeTracking = {
  __typename?: 'ProjectTimeTracking';
  totalEmployees: Scalars['Int']['output'];
  totalHours: Scalars['Float']['output'];
};


export type ProjectTimeTrackingTotalEmployeesArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type ProjectTimeTrackingTotalHoursArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export enum ProjectType {
  CostCenterProject = 'COST_CENTER_PROJECT',
  MainProject = 'MAIN_PROJECT',
  PartProject = 'PART_PROJECT',
  SubProject = 'SUB_PROJECT'
}

export type Projects = {
  __typename?: 'Projects';
  meta: ProjectsMeta;
  pagination: Pagination;
  projects: Array<Project>;
};

export type ProjectsColorFilterMeta = {
  __typename?: 'ProjectsColorFilterMeta';
  color: ProjectColor;
  count: Scalars['Int']['output'];
};

export type ProjectsMeta = {
  __typename?: 'ProjectsMeta';
  selectedFilters: ProjectsSelectedFiltersMeta;
  totalCount: Scalars['Int']['output'];
};

export type ProjectsProfitCenterFilterMeta = {
  __typename?: 'ProjectsProfitCenterFilterMeta';
  count: Scalars['Int']['output'];
  profitCenter: ProfitCenter;
};

export type ProjectsSelectedFiltersMeta = {
  __typename?: 'ProjectsSelectedFiltersMeta';
  profitCenter: Array<ProjectsProfitCenterFilterMeta>;
  status: Array<ProjectsStatusFilterMeta>;
};

export type ProjectsStatusFilterMeta = {
  __typename?: 'ProjectsStatusFilterMeta';
  count: Scalars['Int']['output'];
  status: ProjectStatus;
};

export type PublicAcceptanceReport = {
  __typename?: 'PublicAcceptanceReport';
  accessDueDate: Scalars['Date']['output'];
  addedBy: User;
  alias?: Maybe<Scalars['String']['output']>;
  contactPersonEmail: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  defect?: Maybe<AcceptanceReportDefect>;
  documentCanBeSigned: Scalars['Boolean']['output'];
  hasDefect: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  no: Scalars['Int']['output'];
  noComputed: Scalars['String']['output'];
  projectLogo?: Maybe<Scalars['String']['output']>;
  signedByCustomer: Scalars['Boolean']['output'];
  status: AcceptanceReportStatus;
};

export type PublicOvertime = {
  __typename?: 'PublicOvertime';
  accessDueDate: Scalars['Date']['output'];
  addedBy: User;
  alias?: Maybe<Scalars['String']['output']>;
  contactPersonEmail: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  documentCanBeSigned: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  no: Scalars['Int']['output'];
  noComputed: Scalars['String']['output'];
  projectLogo?: Maybe<Scalars['String']['output']>;
  signedByCustomer: Scalars['Boolean']['output'];
  status: OvertimeStatus;
};

export type PublicPartProject = {
  __typename?: 'PublicPartProject';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectNumber: Scalars['ID']['output'];
  siv?: Maybe<PublicPartProjectSiv>;
};

export type PublicPartProjectSiv = {
  __typename?: 'PublicPartProjectSIV';
  cockpit: SivCockpit;
  id: Scalars['ID']['output'];
  recording: PublicPartProjectSivRecordingMeta;
};

export type PublicPartProjectSivRecordingMeta = {
  __typename?: 'PublicPartProjectSIVRecordingMeta';
  totalHourOfEmployees: Scalars['Float']['output'];
  totalHoursToBeDistributed: Scalars['Float']['output'];
};

export type PublicProject = BaseProject & {
  __typename?: 'PublicProject';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectNumber: Scalars['ID']['output'];
};

export type Qsst = DocumentInterface & {
  __typename?: 'Qsst';
  addedBy: User;
  clientComments?: Maybe<Scalars['String']['output']>;
  clientName: Scalars['String']['output'];
  clientSignature?: Maybe<QsstClientSignature>;
  contractDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  draftProjectNumber?: Maybe<Scalars['String']['output']>;
  hsContactInfo: QsstHsContactInfo;
  id: Scalars['ID']['output'];
  /** Logs of the qsst */
  logs?: Maybe<Logs>;
  manuallySignedPdfInfo?: Maybe<QsstPdfInfo>;
  name: Scalars['String']['output'];
  onsideEmployee: QsstOnsideEmployee;
  pdfInfo: QsstPdfInfo;
  project: Project;
  recommendationScore?: Maybe<Scalars['Int']['output']>;
  signedAt?: Maybe<Scalars['Date']['output']>;
  specificScore?: Maybe<QsstSpecificScore>;
  status: QsstStatus;
  updatedAt: Scalars['Date']['output'];
  updatedBy: User;
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanAssign: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanRemoveUpload: Scalars['Boolean']['output'];
  viewerCanSign: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanUpload: Scalars['Boolean']['output'];
};


export type QsstLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QsstArchivedLog = Log & LogWithActor & LogWithDate & QsstLog & {
  __typename?: 'QsstArchivedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstAssignedToProjectLog = Log & LogWithActor & LogWithDate & ProjectLog & QsstLog & {
  __typename?: 'QsstAssignedToProjectLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstAssignedToProjectLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** name of the project */
  projectName: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstClientContact = {
  __typename?: 'QsstClientContact';
  city?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  streetName?: Maybe<Scalars['String']['output']>;
  streetNo?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type QsstClientSignature = {
  __typename?: 'QsstClientSignature';
  createdAt: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
};

export type QsstCreatedLog = Log & LogWithActor & LogWithDate & LogWithProjectContractDate & QsstLog & {
  __typename?: 'QsstCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** Contract date of the project in ISO-8601 format */
  projectContractDate?: Maybe<Scalars['Date']['output']>;
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstDeletedLog = Log & LogWithActor & LogWithDate & QsstLog & {
  __typename?: 'QsstDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstDownloadedLog = Log & LogWithDate & QsstLog & {
  __typename?: 'QsstDownloadedLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstDownloadedLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstEmailSentLog = Log & LogWithActor & LogWithDate & LogWithEmail & QsstLog & {
  __typename?: 'QsstEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the qsst sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that qsst sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the QsstEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstEmailSentWithAttachmentLog = Log & LogWithActor & LogWithDate & LogWithEmail & QsstLog & {
  __typename?: 'QsstEmailSentWithAttachmentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the qsst sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that qsst sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the QsstEmailSentWithAttachmentLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstExternalLinkExpiredLog = Log & LogWithDate & QsstLog & {
  __typename?: 'QsstExternalLinkExpiredLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** Expired date of the qsst external link in ISO-8601 format */
  expiredDate: Scalars['Date']['output'];
  /** ID of the QsstExternalLinkExpiredLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstExternalSignatureUploadInput = {
  clientComments: Scalars['String']['input'];
  clientSignatureFullName: Scalars['String']['input'];
  clientSignatureUpload: Scalars['Upload']['input'];
  externalAuthToken: Scalars['String']['input'];
  qsstId: Scalars['ID']['input'];
  recommendationScore: Scalars['Int']['input'];
  specificScore: QsstSaveInputSpecificScore;
};

export type QsstForExternal = {
  __typename?: 'QsstForExternal';
  accessDueDate?: Maybe<Scalars['Date']['output']>;
  clientName: Scalars['String']['output'];
  hsContactInfo: QsstHsContactInfo;
  hsProjectNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pdfInfo?: Maybe<QsstPdfInfo>;
  projectAdditionalName?: Maybe<Scalars['String']['output']>;
  projectLogo?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['Date']['output']>;
};

export type QsstForExternalInput = {
  externalAuthToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/**
 * additional contact info of the hsEmployee
 * will be the info of the user that updated
 * the document the last time
 */
export type QsstHsContactInfo = {
  __typename?: 'QsstHSContactInfo';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type QsstLog = {
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstLogDownloadInput = {
  externalAuthToken?: InputMaybe<Scalars['String']['input']>;
  /** documentId */
  id: Scalars['ID']['input'];
};

export type QsstNotSignedLog = Log & LogWithDate & QsstLog & {
  __typename?: 'QsstNotSignedLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** The day count of that document not signed */
  dayCount?: Maybe<Scalars['Int']['output']>;
  /** ID of the QsstNotSignedLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstOnsideEmployee = {
  __typename?: 'QsstOnsideEmployee';
  email?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  phoneNo?: Maybe<Scalars['String']['output']>;
};

export type QsstPdfInfo = {
  __typename?: 'QsstPDFInfo';
  path?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  versionedUrl?: Maybe<Scalars['String']['output']>;
};

export type QsstSaveInput = {
  clientName: Scalars['String']['input'];
  contractDate?: InputMaybe<Scalars['Date']['input']>;
  draftProjectNumber?: InputMaybe<Scalars['String']['input']>;
  /** documentId */
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  onsideEmployee: QsstSaveInputOnsideEmployee;
};

export type QsstSaveInputClientContact = {
  city?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNo?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type QsstSaveInputOnsideEmployee = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
};

export type QsstSaveInputSpecificScore = {
  cleanliness?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
  timeliness?: InputMaybe<Scalars['Int']['input']>;
};

export type QsstSendMailInput = {
  attachDocument?: InputMaybe<Scalars['Boolean']['input']>;
  body: Scalars['String']['input'];
  /** Carbon copies of the mail */
  ccs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** documentId */
  id: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type QsstSignInput = {
  clientComments: Scalars['String']['input'];
  clientSignatureFullName: Scalars['String']['input'];
  clientSignatureUpload: Scalars['Upload']['input'];
  /** documentId */
  id: Scalars['ID']['input'];
  recommendationScore: Scalars['Int']['input'];
  specificScore: QsstSaveInputSpecificScore;
};

export type QsstSignedLog = Log & LogWithDate & QsstLog & {
  __typename?: 'QsstSignedLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstSignedLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstSignedOnSideLog = Log & LogWithDate & QsstLog & {
  __typename?: 'QsstSignedOnSideLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstSignedOnSideLog */
  id: Scalars['ID']['output'];
  /** Name of the qsst */
  name: Scalars['String']['output'];
  /** ID of the qsst */
  qsstId: Scalars['ID']['output'];
};

export type QsstSpecificScore = {
  __typename?: 'QsstSpecificScore';
  cleanliness?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<Scalars['Int']['output']>;
  timeliness?: Maybe<Scalars['Int']['output']>;
};

export enum QsstStatus {
  Archived = 'ARCHIVED',
  ManuallySigned = 'MANUALLY_SIGNED',
  Open = 'OPEN',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export type QsstUpdatedLog = Log & LogWithActor & LogWithDate & LogWithProjectContractDate & QsstLog & {
  __typename?: 'QsstUpdatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstUpdatedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** Contract date of the project in ISO-8601 format */
  projectContractDate?: Maybe<Scalars['Date']['output']>;
  /** ID of the obstruction */
  qsstId: Scalars['ID']['output'];
};

export type QsstUploadPdfInput = {
  /** documentId */
  id: Scalars['ID']['input'];
  pdf: Scalars['Upload']['input'];
};

export type QsstUploadedDeletedLog = Log & LogWithActor & LogWithDate & QsstLog & {
  __typename?: 'QsstUploadedDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstUploadedDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  qsstId: Scalars['ID']['output'];
};

export type QsstUploadedLog = Log & LogWithActor & LogWithDate & QsstLog & {
  __typename?: 'QsstUploadedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the QsstUploadedLog */
  id: Scalars['ID']['output'];
  /** Name of the obstruction */
  name: Scalars['String']['output'];
  /** ID of the obstruction */
  qsstId: Scalars['ID']['output'];
};

export type Quality = {
  __typename?: 'Quality';
  /** Description of quality */
  description: Scalars['String']['output'];
  /** Name of quality */
  name: Scalars['String']['output'];
};

export type QualitySaveInput = {
  /** Description of quality */
  description: Scalars['String']['input'];
  /** Name of quality */
  name: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  ProjectCalendar: ProjCal_Queries;
  /** Retrieves a single acceptance report by its unique identifier. */
  acceptanceReport: AcceptanceReport;
  /**
   * Retrieves the file paths for both generated and manually uploaded PDFs
   * associated with an acceptance report.
   */
  acceptanceReportPdfPath: AcceptanceReportPdfPath;
  /** Retrieves multiple acceptance reports by their IDs. */
  acceptanceReports: Array<AcceptanceReport>;
  /** It returns the catalogue for the current user */
  catalogue?: Maybe<Catalogue>;
  /** It returns the all catalogues for user in name ascending format. */
  catalogues: Array<Catalogue>;
  /** It returns the given category detail. */
  category: Category;
  /**
   * Retrieves a single concern by its unique identifier.
   *
   * Returns the concern object with all its properties.
   */
  concern?: Maybe<Concern>;
  /**
   * Retrieves multiple concerns by their unique identifiers.
   *
   * Allows batch fetching of concerns for improved performance when multiple concerns
   * are needed simultaneously.
   */
  concerns: Array<Concern>;
  /**
   * Retrieves a single construction note by its unique identifier.
   * Returns the construction note object with all its properties.
   */
  constructionNote: ConstructionNote;
  /**
   * Retrieves multiple construction notes by their unique identifiers.
   * Allows batch fetching of construction notes for improved performance when multiple construction notes
   * are needed simultaneously.
   */
  constructionNotes: Array<ConstructionNote>;
  contactPeople: Array<ContactPerson>;
  contactPerson?: Maybe<ContactPerson>;
  customFile?: Maybe<CustomFile>;
  /** It returns the apps */
  driveApps: Array<DriveApp>;
  driveBulkJob?: Maybe<DriveBulkJob>;
  driveBulkJobs: Array<DriveBulkJob>;
  /** It returns document */
  driveDocument?: Maybe<DriveDocument>;
  /** It returns documents */
  driveDocuments: Array<DriveDocument>;
  /** It returns the given folder detail. */
  driveFolder?: Maybe<DriveFolder>;
  /** It returns flattened tree of folders */
  driveFolders: Array<DriveFolder>;
  emailSuggestions: EmailSuggestions;
  employeesForProfitCenter: Array<Employee>;
  employeesForProject: Array<Employee>;
  equipments: Array<Equipment>;
  externalOffers: Array<ExternalOffer>;
  financialDocument: FinancialDocument;
  financialDocuments: Array<FinancialDocument>;
  /** It returns the given folder detail. */
  folder: Folder;
  /** It returns the folders for the given offer. */
  folders: Array<Folder>;
  getPspdfkitAuthToken: GetPspdfkitAuthTokenResponse;
  heartbeat: Scalars['String']['output'];
  languages: Array<Language>;
  /** It returns the available categories for given folder and offer. */
  listAvailableCategoriesForFolderCreation: Array<Category>;
  /** Get logs for given project */
  logs: Logs;
  /** It returns the given obstruction detail. */
  obstruction?: Maybe<Obstruction>;
  /** Returns obstructions that are accessible to viewer. */
  obstructions: Array<Obstruction>;
  /** It returns the given offer detail. */
  offer: Offer;
  /** It returns the given operation detail. */
  operation: Operation;
  overtime: Overtime;
  overtimeNextSuggestedNumber: Scalars['Int']['output'];
  overtimePdfPath: OvertimePdfPath;
  overtimes: Array<Overtime>;
  precautionCategories: Array<PrecautionCategory>;
  professions: Array<Scalars['String']['output']>;
  project: Project;
  projectByHsProjectNumber: Project;
  projectSearch: ProjectSearchResponse;
  projectSearchByProjectDependencies: ProjectSearchByProjectDependenciesResponse;
  projectSearchExternal: ProjectSearchExternalResponse;
  projectSearchProfitCentersMeta: ProjectSearchProfitCentersMetaResponse;
  projects: Projects;
  /** Retrieves a public view of an acceptance report for external access. */
  publicAcceptanceReport?: Maybe<PublicAcceptanceReport>;
  publicOvertime?: Maybe<PublicOvertime>;
  qsst?: Maybe<Qsst>;
  qsstForExternal?: Maybe<QsstForExternal>;
  qsstGenerateExternalAuthToken: ExternalAuthToken;
  qssts: Array<Qsst>;
  regionalSecurityManagers: Array<RegionalSecurityManager>;
  riskAssessment: RiskAssessment;
  riskAssessments: Array<RiskAssessment>;
  sapTransmissionProjects: SapTransmissionProjects;
  searchHsProjects: SearchHsProjectsResult;
  siv?: Maybe<Siv>;
  sivBillingAttachment?: Maybe<SivBillingAttachment>;
  sivBillingAttachments: Array<SivBillingAttachment>;
  sivEmployees: Array<SivhsEmployee>;
  sivExternalOfferDiff: SivExternalOfferDiff;
  sivGroup?: Maybe<SivGroup>;
  sivOperation?: Maybe<SivOperation>;
  sivOperationSplitOperations: Array<SivOperation>;
  sivOperationSplitSystemTemplates: Array<SivOperationSplitSystemTemplate>;
  sivSubcontractor?: Maybe<SivSubcontractorUnion>;
  timeTrackingCountsForProfitCenter: Array<TimeTrackingCount>;
  timeTrackingCountsForProject: Array<TimeTrackingCount>;
  timeTrackingEntries: Array<TimeTrackingEntry>;
  timeTrackingIndicators: Array<TimeTrackingIndicatorWithDescription>;
  timeTrackingProject: TimeTrackingWeekYearProject;
  timeTrackingProjectsInRange: Array<TimeTrackingWeekYearProject>;
  timeTrackingSAPEmployees: Array<TimeTrackingWeekYearSapEmployee>;
  timesheetEmployeesInRange: Array<TimesheetSapEmployee>;
  timesheetProjectsInRange: Array<TimesheetProject>;
  timesheetSelectionProjects: Array<Project>;
  timesheetSelectionSAPEmployees: Array<TimesheetSapEmployee>;
  user: User;
  viewer: Viewer;
};


export type QueryAcceptanceReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAcceptanceReportPdfPathArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAcceptanceReportsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCatalogueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConcernArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConcernsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryConstructionNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConstructionNotesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryContactPeopleArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryContactPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDriveBulkJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDriveDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDriveDocumentsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDriveFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDriveFoldersArgs = {
  projectId: Scalars['ID']['input'];
  sorting?: InputMaybe<DriveFolderSortingInput>;
  viewPreferences?: InputMaybe<DriveViewPreferencesInput>;
};


export type QueryEmailSuggestionsArgs = {
  project: Scalars['ID']['input'];
};


export type QueryEmployeesForProfitCenterArgs = {
  includeChildProfitCenters: Scalars['Boolean']['input'];
  includeQuittedEmployeesAfter?: InputMaybe<Scalars['Date']['input']>;
  profitCenterId: Scalars['ID']['input'];
  sorting?: InputMaybe<EmployeeSorting>;
};


export type QueryEmployeesForProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEquipmentsArgs = {
  precautions?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryExternalOffersArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryFinancialDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFinancialDocumentsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFoldersArgs = {
  offer: Scalars['ID']['input'];
};


export type QueryGetPspdfkitAuthTokenArgs = {
  input: GetPspdfkitAuthTokenInput;
};


export type QueryListAvailableCategoriesForFolderCreationArgs = {
  offer: Scalars['ID']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryObstructionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryObstructionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOperationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOvertimeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOvertimeNextSuggestedNumberArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryOvertimePdfPathArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOvertimesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectByHsProjectNumberArgs = {
  hsProjectNumber: Scalars['ID']['input'];
};


export type QueryProjectSearchArgs = {
  continuationToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProjectSearchFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<ProjectSearchSorting>;
};


export type QueryProjectSearchByProjectDependenciesArgs = {
  continuationToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProjectSearchFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<ProjectSearchSorting>;
};


export type QueryProjectSearchExternalArgs = {
  continuationToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProjectSearchExternalFilter>;
  query: Scalars['String']['input'];
  sorting?: InputMaybe<ProjectSearchExternalSorting>;
};


export type QueryProjectSearchProfitCentersMetaArgs = {
  filter?: InputMaybe<ProjectSearchFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectsArgs = {
  excludeDraft?: InputMaybe<Scalars['Boolean']['input']>;
  excludeStatus?: InputMaybe<Array<ProjectStatus>>;
  includeStatus?: InputMaybe<Array<ProjectStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  profitCenters?: InputMaybe<Array<Scalars['ID']['input']>>;
  sorting?: InputMaybe<ProjectSorting>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicAcceptanceReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicOvertimeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQsstArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQsstForExternalArgs = {
  input: QsstForExternalInput;
};


export type QueryQsstGenerateExternalAuthTokenArgs = {
  qsstIds: Array<Scalars['ID']['input']>;
};


export type QueryQsstsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryRiskAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRiskAssessmentsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySapTransmissionProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  profitCenters?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectColors?: InputMaybe<Array<ProjectColor>>;
  projectTypes?: InputMaybe<Array<SapTransmissionProjectType>>;
  sorting?: InputMaybe<SapTransmissionProjectsSorting>;
  statuses?: InputMaybe<Array<ProjectStatus>>;
};


export type QuerySearchHsProjectsArgs = {
  continuationToken?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QuerySivArgs = {
  sivId: Scalars['ID']['input'];
};


export type QuerySivBillingAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySivBillingAttachmentsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QuerySivEmployeesArgs = {
  sivId: Scalars['ID']['input'];
};


export type QuerySivExternalOfferDiffArgs = {
  externalOfferId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QuerySivGroupArgs = {
  groupId: Scalars['ID']['input'];
};


export type QuerySivOperationArgs = {
  operationId: Scalars['ID']['input'];
};


export type QuerySivOperationSplitOperationsArgs = {
  operationId: Scalars['ID']['input'];
};


export type QuerySivSubcontractorArgs = {
  subcontractorId: Scalars['ID']['input'];
};


export type QueryTimeTrackingCountsForProfitCenterArgs = {
  endDate: Scalars['Date']['input'];
  profitCenterId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryTimeTrackingCountsForProjectArgs = {
  endDate: Scalars['Date']['input'];
  projectId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryTimeTrackingEntriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryTimeTrackingProjectArgs = {
  projectId: Scalars['ID']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryTimeTrackingProjectsInRangeArgs = {
  endWeek: TimeTrackingWeekRangeInput;
  projectId: Scalars['ID']['input'];
  startWeek: TimeTrackingWeekRangeInput;
};


export type QueryTimeTrackingSapEmployeesArgs = {
  profitCenterId: Scalars['ID']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryTimesheetEmployeesInRangeArgs = {
  employeeIds: Array<Scalars['ID']['input']>;
};


export type QueryTimesheetProjectsInRangeArgs = {
  projectIds: Array<Scalars['ID']['input']>;
};


export type QueryTimesheetSelectionProjectsArgs = {
  endDate: Scalars['Date']['input'];
  profitCenterId: Scalars['ID']['input'];
  sorting?: InputMaybe<TimesheetProjectSorting>;
  startDate: Scalars['Date']['input'];
};


export type QueryTimesheetSelectionSapEmployeesArgs = {
  endDate: Scalars['Date']['input'];
  profitCenterId: Scalars['ID']['input'];
  sorting?: InputMaybe<TimesheetSelectionSapEmployeesSorting>;
  startDate: Scalars['Date']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type RegionalSecurityManager = {
  __typename?: 'RegionalSecurityManager';
  fullName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type RemovableInterface = {
  id: Scalars['ID']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
};

export type RemoveCatalogueInput = {
  /** Id of the catalogue. */
  id: Scalars['ID']['input'];
};

export type RemoveFolderInput = {
  /** Id of the folder. */
  id: Scalars['ID']['input'];
};

export type RemoveFolderOperationInput = {
  /** Id of the folder. */
  id: Scalars['ID']['input'];
};

export type RemoveManuallyUploadedAcceptanceReportInput = {
  acceptanceReportId: Scalars['ID']['input'];
};

export type RemoveManuallyUploadedOvertimeInput = {
  overtime: Scalars['ID']['input'];
};

/** Response for a remove action. */
export type RemoveResult = {
  __typename?: 'RemoveResult';
  /** Status of the action. */
  status: Scalars['Boolean']['output'];
};

export type RetrieveTokensInput = {
  refreshToken: Scalars['String']['input'];
};

export type RetrieveTokensResult = {
  __typename?: 'RetrieveTokensResult';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  viewer: Viewer;
};

export type RiskAssessment = AssignableInterface & DocumentInterface & RemovableInterface & {
  __typename?: 'RiskAssessment';
  addedBy: User;
  clientName?: Maybe<Scalars['String']['output']>;
  clientNameComputed?: Maybe<Scalars['String']['output']>;
  clientReference?: Maybe<Scalars['String']['output']>;
  constructionSitePersonCount: RiskAssessmentConstructionSitePersonCount;
  contractor?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  draftProjectNumber?: Maybe<Scalars['String']['output']>;
  equipments: Array<Equipment>;
  id: Scalars['ID']['output'];
  inCharges: Array<InCharge>;
  /** Logs of the risk assessment */
  logs?: Maybe<Logs>;
  manuallySignedDocumentPath?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  no: Scalars['Int']['output'];
  /** @deprecated This field deprecated. You should use date field instead of orderDate field. */
  orderDate?: Maybe<Scalars['Date']['output']>;
  pdfPath?: Maybe<Scalars['String']['output']>;
  precautions: Array<Precaution>;
  professions?: Maybe<Array<Scalars['String']['output']>>;
  project: Project;
  projectNumberComputed?: Maybe<Scalars['String']['output']>;
  projectRemark?: Maybe<Scalars['String']['output']>;
  projectRemarkComputed?: Maybe<Scalars['String']['output']>;
  signatures: Array<RiskAssessmentSignature>;
  specialPrecautions: Array<SpecialPrecaution>;
  status: RiskAssessmentStatus;
  updatedAt: Scalars['Date']['output'];
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanAssign: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanRemoveManuallySignedDocument: Scalars['Boolean']['output'];
  viewerCanSendRiskAssessmentPDFEmail: Scalars['Boolean']['output'];
  viewerCanSign: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanUploadManuallySignedDocument: Scalars['Boolean']['output'];
};


export type RiskAssessmentLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RiskAssessmentArchivedLog = Log & LogWithActor & LogWithDate & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentArchivedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentArchivedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentAssignedToProjectLog = Log & LogWithActor & LogWithDate & ProjectLog & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentAssignedToProjectLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentAssignedToProjectLog */
  id: Scalars['ID']['output'];
  /** Name of the risk assessment */
  name: Scalars['String']['output'];
  /** Id of the project */
  projectId: Scalars['ID']['output'];
  /** name of the project */
  projectName: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export enum RiskAssessmentConstructionSitePersonCount {
  Multi = 'MULTI',
  Single = 'SINGLE'
}

export type RiskAssessmentCreatedLog = Log & LogWithActor & LogWithDate & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentCreatedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentCreatedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentDeletedLog = Log & LogWithActor & LogWithDate & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentEmailSentLog = Log & LogWithActor & LogWithDate & LogWithEmail & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentEmailSentLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** CC email addresses of the risk assessment sent email */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** E-mails that overtime sent */
  emails: Array<Scalars['String']['output']>;
  /** ID of the RiskAssessmentEmailSentLog */
  id: Scalars['ID']['output'];
  /** Name of the risk assessment */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentInChargeSaveInput = {
  fullName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: InChargeRole;
};

export type RiskAssessmentLog = {
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentLog */
  id: Scalars['ID']['output'];
  /** Name of the risk assessment */
  name: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentManuallySignedDocumentDeletedLog = Log & LogWithActor & LogWithDate & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentManuallySignedDocumentDeletedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentManuallySignedDocumentDeletedLog */
  id: Scalars['ID']['output'];
  /** Name of the risk assessment */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentManuallySignedDocumentRemoveInput = {
  riskAssessmentId: Scalars['ID']['input'];
};

export type RiskAssessmentManuallySignedDocumentUploadInput = {
  file: Scalars['Upload']['input'];
  riskAssessmentId: Scalars['ID']['input'];
};

export type RiskAssessmentManuallySignedLog = Log & LogWithActor & LogWithDate & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentManuallySignedLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentManuallySignedLog */
  id: Scalars['ID']['output'];
  /** Name of the risk assessment */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentRegulation = {
  __typename?: 'RiskAssessmentRegulation';
  project: Project;
  riskAssessmentsWithMissingSignatures: Array<RiskAssessment>;
  status: RiskAssessmentRegulationStatus;
};

export enum RiskAssessmentRegulationStatus {
  Completed = 'COMPLETED',
  MissingSignature = 'MISSING_SIGNATURE',
  Neutral = 'NEUTRAL',
  NoRiskAssessment = 'NO_RISK_ASSESSMENT',
  RiskAssessmentNotRequired = 'RISK_ASSESSMENT_NOT_REQUIRED',
  Unknown = 'UNKNOWN'
}

export type RiskAssessmentSaveInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The client reference is the client's transaction number / order number.
   * It is usually used for major clients or clients with several projects at HS having an internal operational process which has unique IDs.
   */
  clientReference?: InputMaybe<Scalars['String']['input']>;
  constructionSitePersonCount?: InputMaybe<RiskAssessmentConstructionSitePersonCount>;
  contractor?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  draftProjectNumber?: InputMaybe<Scalars['String']['input']>;
  equipmentIds: Array<Scalars['String']['input']>;
  inCharges: Array<RiskAssessmentInChargeSaveInput>;
  /**
   * Also known as "trades"
   *
   * Professions are different specializations in the craft sector.
   * Examples include painting, drywall construction, scaffolding, plumbing and electrical work.
   */
  professions?: InputMaybe<Array<Scalars['String']['input']>>;
  projectRemark?: InputMaybe<Scalars['String']['input']>;
  selectedPrecautions: Array<Scalars['String']['input']>;
  specialPrecautions: Array<RiskAssessmentSpecialPrecautionSaveInput>;
};

export type RiskAssessmentSignature = SignatureInterface & {
  __typename?: 'RiskAssessmentSignature';
  createdAt: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imagePath: Scalars['String']['output'];
  riskAssessment: RiskAssessment;
  type: RiskAssessmentSignatureType;
};

export enum RiskAssessmentSignatureType {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type RiskAssessmentSignedByCreatorLog = Log & LogWithActor & LogWithDate & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentSignedByCreatorLog';
  /** First name of the actor who did this action */
  actorFirstName: Scalars['String']['output'];
  /** ID of the actor who did this action */
  actorId: Scalars['String']['output'];
  /** Last name of the actor who did this action */
  actorLastName: Scalars['String']['output'];
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** ID of the RiskAssessmentSignedByCreatorLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentSignedByEmployeeLog = Log & LogWithDate & RiskAssessmentLog & {
  __typename?: 'RiskAssessmentSignedByEmployeeLog';
  /** The date this event has been happened in ISO-8601 format */
  date: Scalars['Date']['output'];
  /** Name of the signee of the risk assessment */
  employeeName: Scalars['String']['output'];
  /** ID of the RiskAssessmentSignedByEmployeeLog */
  id: Scalars['ID']['output'];
  /** Name of the overtime */
  name: Scalars['String']['output'];
  /** No of the risk assessment */
  no: Scalars['String']['output'];
  /** ID of the risk assessment */
  riskAssessmentId: Scalars['ID']['output'];
};

export type RiskAssessmentSpecialPrecautionSaveInput = {
  precautionCategoryId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export enum RiskAssessmentStatus {
  Archived = 'ARCHIVED',
  ManuallySigned = 'MANUALLY_SIGNED',
  Open = 'OPEN',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export type Siv = {
  __typename?: 'SIV';
  cockpit: SivCockpit;
  createdAt: Scalars['Date']['output'];
  discount: SivDiscount;
  groups: Array<SivGroup>;
  hasBillableOperations: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated This field is deprecated. You should use cockpit.displayPreferences.collapsed field instead of isCollapsed field. */
  isCollapsed: Scalars['Boolean']['output'];
  operationSplitPreference: SivOperationSplitPreference;
  planning: SivPlanningMeta;
  project: Project;
  recording: SivRecordingMeta;
  totalHourForecast: Scalars['Float']['output'];
  traineeProductivity: Scalars['Boolean']['output'];
  trainees: Array<SivhsTraineeEmployee>;
  updatedAt: Scalars['Date']['output'];
  viewerCanCreateGroup: Scalars['Boolean']['output'];
  viewerCanImport: Scalars['Boolean']['output'];
};

export type SivAdditionalOperationCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  no: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  sivId: Scalars['ID']['input'];
  unit?: InputMaybe<SivOperationUnit>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type SivBillingAttachment = DocumentInterface & RemovableInterface & {
  __typename?: 'SIVBillingAttachment';
  addedBy: User;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pdfPath: Scalars['String']['output'];
  project: Project;
  status: SivBillingAttachmentStatus;
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type SivBillingAttachmentEmailSendInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SivBillingAttachmentOperationInput = {
  id: Scalars['ID']['input'];
  recordedMeasurement: Scalars['Float']['input'];
};

export type SivBillingAttachmentSaveInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  documentId: Scalars['ID']['input'];
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  operations: Array<SivBillingAttachmentOperationInput>;
};

export enum SivBillingAttachmentStatus {
  Archived = 'ARCHIVED',
  Open = 'OPEN',
  Sent = 'SENT'
}

export type SivCockpit = {
  __typename?: 'SIVCockpit';
  /** Values are inside the cockpit based on this selection */
  displayPreferences: SivCockpitDisplayPreferences;
  /**
   * Calculated by:
   *   total of planned performance discounted – total of planned costs
   */
  plannedProfit: SivCockpitProfit;
  /**
   * Calculated by:
   *   total of recorded hours – (recorded mass / LW planned)
   */
  plusMinusHours: Scalars['Float']['output'];
  /**
   * Calculated by:
   *   total of recorded performance discounted – total of recorded costs
   */
  recordedProfit: SivCockpitProfit;
  totalCost: SivCockpitTotalCost;
  /**
   * Total recorded employee costs calculated by:
   *   total recorded hours * (hourly wage * (1 + overhead rate) + hourly surcharge)
   *
   * Total planned employee costs calculated by:
   *   (average hourly cost + hourly surcharge) * total planned hours
   */
  totalEmployeeCost: SivCockpitTotalCost;
  /**
   * Calculated by:
   *   (planningTotalMeasurement - recordingTotalMeasurement) / recordingPerformanceValue + recordingHour
   */
  totalHourForecast: Scalars['Float']['output'];
  totalHourOfEmployees: Scalars['Float']['output'];
  /**
   * Total of recorded hours, that have not yet been assigned to any performance
   * Calculated by:
   *   totalHourOfEmployees - totalUnproductiveHours - recordingTotalHour
   */
  totalHoursToBeDistributed: Scalars['Float']['output'];
  totalMaterialCost: SivCockpitTotalCost;
  /**
   * Calculated by:
   *   operationTotalCost += totalMeasurement * operation.unitPrice
   *   operationTotal * discount
   */
  totalPerformanceCost: SivCockpitPerformanceTotalCost;
  totalPlannedHours: Scalars['Float']['output'];
  totalSubcontractorCost: SivCockpitTotalCost;
};

export type SivCockpitDisplayPreferences = {
  __typename?: 'SIVCockpitDisplayPreferences';
  collapsed: Scalars['Boolean']['output'];
  unit: SivCockpitDisplayUnit;
};

export type SivCockpitDisplayPreferencesUpdateInput = {
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  sivId: Scalars['ID']['input'];
  unit?: InputMaybe<SivCockpitDisplayUnit>;
};

export enum SivCockpitDisplayUnit {
  Eur = 'EUR',
  Percentage = 'PERCENTAGE'
}

export type SivCockpitPerformanceTotalCost = {
  __typename?: 'SIVCockpitPerformanceTotalCost';
  percentage: Scalars['Float']['output'];
  /** planned value with discount applied */
  planned: Scalars['Float']['output'];
  plannedRaw: Scalars['Float']['output'];
  recorded: Scalars['Float']['output'];
};

export type SivCockpitProfit = {
  __typename?: 'SIVCockpitProfit';
  monetary: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type SivCockpitTotalCost = {
  __typename?: 'SIVCockpitTotalCost';
  percentage: Scalars['Float']['output'];
  planned: Scalars['Float']['output'];
  recorded: Scalars['Float']['output'];
};

export type SivCollapseToggleInput = {
  sivId: Scalars['ID']['input'];
};

export type SivDiscount = {
  __typename?: 'SIVDiscount';
  active: Scalars['Boolean']['output'];
  /** Discount percentage for SIV */
  amount?: Maybe<Scalars['Float']['output']>;
};

export type SivDiscountToggleInput = {
  sivId: Scalars['ID']['input'];
};

export type SivDiscountUpdateInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivEmployee = {
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  hour?: Maybe<Scalars['Float']['output']>;
  /**
   * If the employee has experience level, we'll use that along with the id.
   * @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use.
   */
  id: Scalars['ID']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  name: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  role: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  sapId: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  wage?: Maybe<Scalars['Float']['output']>;
};

export enum SivEmployeeExperienceLevel {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3'
}

export type SivEmployeeProductivityToggleInput = {
  sivId: Scalars['ID']['input'];
};

export type SivEmployees = {
  __typename?: 'SIVEmployees';
  freelanceEmployees: Array<SivFreelanceEmployee>;
  hsEmployees: Array<SivhsEmployee>;
};

export type SivExternalOfferDiff = {
  __typename?: 'SIVExternalOfferDiff';
  alreadyImported: Scalars['Boolean']['output'];
  externalOfferId: Scalars['ID']['output'];
  groupDiffs: Array<SivExternalOfferGroupDiff>;
  offerName: Scalars['String']['output'];
  operationDiffs: Array<SivExternalOfferOperationDiff>;
  sivId: Scalars['ID']['output'];
};

export type SivExternalOfferGroupDiff = {
  __typename?: 'SIVExternalOfferGroupDiff';
  externalOfferGroupId: Scalars['ID']['output'];
  fieldDiffs: Array<SivExternalOfferGroupFieldDiff>;
  groupId?: Maybe<Scalars['ID']['output']>;
  hasSplitOperations: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  no: Scalars['String']['output'];
  type: SivExternalOfferGroupDiffType;
};

export enum SivExternalOfferGroupDiffType {
  Added = 'ADDED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export enum SivExternalOfferGroupField {
  Name = 'NAME',
  No = 'NO'
}

export type SivExternalOfferGroupFieldDiff = {
  __typename?: 'SIVExternalOfferGroupFieldDiff';
  field: SivExternalOfferGroupField;
  oldValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SivExternalOfferOperationDiff = {
  __typename?: 'SIVExternalOfferOperationDiff';
  externalOfferOperationId: Scalars['ID']['output'];
  fieldDiffs: Array<SivExternalOfferOperationFieldDiff>;
  hasRecordingData: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  no: Scalars['String']['output'];
  operationId?: Maybe<Scalars['ID']['output']>;
  split: Scalars['Boolean']['output'];
  type: SivExternalOfferOperationDiffType;
};

export enum SivExternalOfferOperationDiffType {
  Added = 'ADDED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export enum SivExternalOfferOperationField {
  ChargePerMinute = 'CHARGE_PER_MINUTE',
  Description = 'DESCRIPTION',
  Material = 'MATERIAL',
  Name = 'NAME',
  No = 'NO',
  PerformanceValue = 'PERFORMANCE_VALUE',
  PlanningTotalMeasurement = 'PLANNING_TOTAL_MEASUREMENT',
  UnitPrice = 'UNIT_PRICE'
}

export type SivExternalOfferOperationFieldDiff = {
  __typename?: 'SIVExternalOfferOperationFieldDiff';
  field: SivExternalOfferOperationField;
  oldValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SivFieldHistoryRecord = {
  __typename?: 'SIVFieldHistoryRecord';
  actor: User;
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SivFreelanceEmployee = {
  __typename?: 'SIVFreelanceEmployee';
  hour?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type SivFreelanceEmployeeInput = {
  name: Scalars['String']['input'];
};

export type SivGroup = {
  __typename?: 'SIVGroup';
  /** @deprecated This field is deprecated. You should use no field instead of computedNo field. */
  computedNo: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  depth: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isCollapsed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** After free numbering changes, this field will treat as computedNo */
  no: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  operations: Array<SivOperation>;
  parentGroup?: Maybe<SivGroup>;
  planning: SivGroupPlanningMeta;
  recording: SivGroupRecordingMeta;
  siv: Siv;
  sortIndex: Scalars['Int']['output'];
  type: SivGroupType;
  updatedAt: Scalars['Date']['output'];
  viewerCanCreateGroup: Scalars['Boolean']['output'];
  viewerCanCreateOperation: Scalars['Boolean']['output'];
  viewerCanDuplicate: Scalars['Boolean']['output'];
  viewerCanMove: Scalars['Boolean']['output'];
  viewerCanRemoveGroup: Scalars['Boolean']['output'];
};


export type SivGroupOperationsArgs = {
  filter?: InputMaybe<OperationFilter>;
};

export type SivGroupCreateInput = {
  name: Scalars['String']['input'];
  no: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  parentGroupId?: InputMaybe<Scalars['ID']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivGroupDuplicateInput = {
  groupIds: Array<Scalars['ID']['input']>;
};

export type SivGroupMoveInput = {
  groupIds: Array<Scalars['ID']['input']>;
  targetGroupId: Scalars['ID']['input'];
};

export type SivGroupPlanningMeta = {
  __typename?: 'SIVGroupPlanningMeta';
  calculatedFlatRate?: Maybe<Scalars['Float']['output']>;
  flatRate?: Maybe<Scalars['Float']['output']>;
  totalCostByMeasurement: Scalars['Float']['output'];
  totalHour: Scalars['Float']['output'];
  totalMaterial: Scalars['Float']['output'];
  totalMaterialCost: Scalars['Float']['output'];
};

export type SivGroupRecordingMeta = {
  __typename?: 'SIVGroupRecordingMeta';
  calculatedFlatRate?: Maybe<Scalars['Float']['output']>;
  flatRate?: Maybe<Scalars['Float']['output']>;
  totalCostByMeasurement?: Maybe<Scalars['Float']['output']>;
  totalHour: Scalars['Float']['output'];
  totalMaterial: Scalars['Float']['output'];
  totalMaterialCost: Scalars['Float']['output'];
};

export type SivGroupRemoveInput = {
  groupIds: Array<Scalars['ID']['input']>;
};

export type SivGroupSetIsCollapsedInput = {
  groupId: Scalars['ID']['input'];
  isCollapsed: Scalars['Boolean']['input'];
};

export type SivGroupSortIndexUpdateInput = {
  groupIds: Array<Scalars['ID']['input']>;
  targetSortIndex: Scalars['Int']['input'];
};

export type SivGroupTransferRecordingValuesInput = {
  groupId: Scalars['ID']['input'];
};

export enum SivGroupType {
  Additional = 'ADDITIONAL',
  Regular = 'REGULAR'
}

export type SivGroupUpdateInput = {
  groupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  no: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type SivhsEmployee = SivEmployee & {
  __typename?: 'SIVHSEmployee';
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  hour?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  name: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  role: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  sapId: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  wage?: Maybe<Scalars['Float']['output']>;
};

export type SivhsTraineeEmployee = SivEmployee & {
  __typename?: 'SIVHSTraineeEmployee';
  experienceLevel?: Maybe<SivEmployeeExperienceLevel>;
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  hour?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  id: Scalars['ID']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  name: Scalars['String']['output'];
  productiveHours?: Maybe<Scalars['Float']['output']>;
  productivityRatio?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  role: Scalars['String']['output'];
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  sapId: Scalars['String']['output'];
  unproductiveHours?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Will be removed soon. Please avoid using unless absolutely necessary and consult maintainer before use or if currently in use. */
  wage?: Maybe<Scalars['Float']['output']>;
};

export type SivImportFromExternalOfferInput = {
  externalOfferId: Scalars['ID']['input'];
  ignorePerformanceValueAndChargePerMinute: Scalars['Boolean']['input'];
  projectId: Scalars['String']['input'];
};

export type SivImportFromOfferInput = {
  offerId: Scalars['ID']['input'];
};

export type SivKeyDataSapTransmitInput = {
  projectIds: Array<Scalars['ID']['input']>;
  sapPassword: Scalars['String']['input'];
  sapUsername: Scalars['String']['input'];
};

export type SivKeyDataSapTransmitResult = {
  __typename?: 'SIVKeyDataSapTransmitResult';
  completedTransmissions: Array<Project>;
  failedTransmissions: Array<Project>;
  status: SivKeyDataSapTransmitStatus;
};

export enum SivKeyDataSapTransmitStatus {
  Failed = 'FAILED',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Success = 'SUCCESS'
}

export type SivlvCopyInput = {
  fromProjectId: Scalars['ID']['input'];
  toProjectId: Scalars['ID']['input'];
};

export type SivOperation = {
  __typename?: 'SIVOperation';
  alternatives: Array<SivOperation>;
  /** @deprecated This field is deprecated. You should use no field instead of computedNo field. */
  computedNo: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  depth: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  group: SivGroup;
  id: Scalars['ID']['output'];
  main?: Maybe<SivOperation>;
  measurements: Array<SivOperationMeasurement>;
  name?: Maybe<Scalars['String']['output']>;
  /** After free numbering changes, this field will treat as computedNo */
  no: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pinned: Scalars['Boolean']['output'];
  planning: SivOperationPlanningMeta;
  recording: SivOperationRecordingMeta;
  sortIndex: Scalars['Int']['output'];
  split: Scalars['Boolean']['output'];
  splitOrigin?: Maybe<SivOperation>;
  type: SivOperationType;
  unit?: Maybe<SivOperationUnit>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  viewerCanDuplicate: Scalars['Boolean']['output'];
  viewerCanMove: Scalars['Boolean']['output'];
  viewerCanRemoveOperation: Scalars['Boolean']['output'];
};

export type SivOperationConvertToRegularInput = {
  operationId: Scalars['ID']['input'];
};

export type SivOperationCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  measurements: Array<SivOperationMeasurementInput>;
  name: Scalars['String']['input'];
  no: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  totalMeasurementMeta?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<SivOperationUnit>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type SivOperationDeleteInput = {
  id: Scalars['ID']['input'];
};

export type SivOperationDetachInput = {
  operationId: Scalars['ID']['input'];
};

export type SivOperationDuplicateInput = {
  operationIds: Array<Scalars['ID']['input']>;
};

export type SivOperationMeasurement = {
  __typename?: 'SIVOperationMeasurement';
  meta: Array<Scalars['String']['output']>;
  multiplier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  operation: SivOperation;
  subtraction: Scalars['Boolean']['output'];
  totalMeta?: Maybe<Scalars['String']['output']>;
};

export type SivOperationMeasurementInput = {
  meta: Array<Scalars['String']['input']>;
  multiplier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subtraction: Scalars['Boolean']['input'];
  totalMeta?: InputMaybe<Scalars['String']['input']>;
};

export type SivOperationMoveInput = {
  operationIds: Array<Scalars['ID']['input']>;
  targetGroupId: Scalars['ID']['input'];
};

export type SivOperationPerformanceRecordingBatchUpdateHourInput = {
  hour?: InputMaybe<Scalars['Float']['input']>;
  /** Please use commas for decimals. */
  hourMeta?: InputMaybe<Scalars['String']['input']>;
};

export type SivOperationPerformanceRecordingBatchUpdateInput = {
  hour?: InputMaybe<SivOperationPerformanceRecordingBatchUpdateHourInput>;
  operationId: Scalars['ID']['input'];
  totalMeasurement?: InputMaybe<SivOperationPerformanceRecordingBatchUpdateTotalMeasurementInput>;
};

export type SivOperationPerformanceRecordingBatchUpdateTotalMeasurementInput = {
  totalMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Please use commas for decimals. */
  totalMeasurementMeta?: InputMaybe<Scalars['String']['input']>;
};

export type SivOperationPinToggleInput = {
  operationId: Scalars['ID']['input'];
};

export type SivOperationPlanningChargePerMinuteUpdateInput = {
  chargePerMinute?: InputMaybe<Scalars['Float']['input']>;
  operationId: Scalars['ID']['input'];
};

export type SivOperationPlanningHourUpdateInput = {
  hour?: InputMaybe<Scalars['Float']['input']>;
  operationId: Scalars['ID']['input'];
};

export type SivOperationPlanningMaterialUpdateInput = {
  material?: InputMaybe<Scalars['Float']['input']>;
  operationId: Scalars['ID']['input'];
};

export type SivOperationPlanningMeta = {
  __typename?: 'SIVOperationPlanningMeta';
  calculatedMaterial?: Maybe<Scalars['Float']['output']>;
  chargePerMinute?: Maybe<Scalars['Float']['output']>;
  hour?: Maybe<Scalars['Float']['output']>;
  material?: Maybe<Scalars['Float']['output']>;
  performanceValue?: Maybe<Scalars['Float']['output']>;
  totalMeasurement?: Maybe<Scalars['Float']['output']>;
  totalMeasurementMeta?: Maybe<Scalars['String']['output']>;
};

export type SivOperationPlanningPerformanceValueUpdateInput = {
  operationId: Scalars['ID']['input'];
  performanceValue?: InputMaybe<Scalars['Float']['input']>;
};

export type SivOperationRecordingHourUpdateInput = {
  hour?: InputMaybe<Scalars['Float']['input']>;
  /** Please use commas for decimals. */
  hourMeta?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
};

export type SivOperationRecordingMaterialUpdateInput = {
  material?: InputMaybe<Scalars['Float']['input']>;
  operationId: Scalars['ID']['input'];
};

export type SivOperationRecordingMeta = {
  __typename?: 'SIVOperationRecordingMeta';
  calculatedMaterial?: Maybe<Scalars['Float']['output']>;
  chargePerMinute?: Maybe<Scalars['Float']['output']>;
  hour?: Maybe<Scalars['Float']['output']>;
  hourHistory: Array<SivFieldHistoryRecord>;
  material?: Maybe<Scalars['Float']['output']>;
  materialCost: Scalars['Float']['output'];
  performanceValue?: Maybe<Scalars['Float']['output']>;
  totalMeasurement?: Maybe<Scalars['Float']['output']>;
  totalMeasurementHistory: Array<SivFieldHistoryRecord>;
};

export type SivOperationRecordingTotalMeasurementUpdateInput = {
  operationId: Scalars['ID']['input'];
  totalMeasurement?: InputMaybe<Scalars['Float']['input']>;
  /** Please use commas for decimals. */
  totalMeasurementMeta?: InputMaybe<Scalars['String']['input']>;
};

export type SivOperationRemoveInput = {
  operationIds: Array<Scalars['ID']['input']>;
};

export type SivOperationSortIndexUpdateInput = {
  operationIds: Array<Scalars['ID']['input']>;
  targetSortIndex: Scalars['Int']['input'];
};

export type SivOperationSplitField = {
  __typename?: 'SIVOperationSplitField';
  percentage?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SivOperationSplitInsertInput = {
  chargePerMinute?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  no: Scalars['String']['input'];
  totalMeasurement?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export enum SivOperationSplitPreference {
  Custom = 'CUSTOM',
  Template = 'TEMPLATE'
}

export type SivOperationSplitPreferenceUpdateInput = {
  operationSplitPreference: SivOperationSplitPreference;
  sivId: Scalars['ID']['input'];
};

export type SivOperationSplitSystemTemplate = SivOperationSplitTemplate & {
  __typename?: 'SIVOperationSplitSystemTemplate';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  splits: Array<SivOperationSplitTemplateValues>;
  templateNo: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SivOperationSplitTemplate = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  splits: Array<SivOperationSplitTemplateValues>;
  templateNo: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SivOperationSplitTemplateValues = {
  __typename?: 'SIVOperationSplitTemplateValues';
  chargePerMinute: SivOperationSplitField;
  name: Scalars['String']['output'];
  unitPrice: SivOperationSplitField;
};

export type SivOperationSplitUpdateInput = {
  chargePerMinute?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  no?: InputMaybe<Scalars['String']['input']>;
  totalMeasurement?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type SivOperationSplitsInput = {
  deletes: Array<SivOperationDeleteInput>;
  inserts: Array<SivOperationSplitInsertInput>;
  restored: Scalars['Boolean']['input'];
  saveAsTemplate: Scalars['Boolean']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
  updates: Array<SivOperationSplitUpdateInput>;
};

export enum SivOperationType {
  Additional = 'ADDITIONAL',
  Alternative = 'ALTERNATIVE',
  Main = 'MAIN',
  Optional = 'OPTIONAL',
  Regular = 'REGULAR'
}

export enum SivOperationUnit {
  Centimeter = 'CENTIMETER',
  CubicCentimeter = 'CUBIC_CENTIMETER',
  CubicMeter = 'CUBIC_METER',
  Day = 'DAY',
  Decimeter = 'DECIMETER',
  Eur = 'EUR',
  Fixed = 'FIXED',
  FlatRate = 'FLAT_RATE',
  Gram = 'GRAM',
  Hour = 'HOUR',
  Kilogram = 'KILOGRAM',
  Kilometer = 'KILOMETER',
  KilowattHour = 'KILOWATT_HOUR',
  Liter = 'LITER',
  Meter = 'METER',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Quantity = 'QUANTITY',
  SquareCentimeter = 'SQUARE_CENTIMETER',
  SquareDecimeter = 'SQUARE_DECIMETER',
  SquareMeter = 'SQUARE_METER',
  SquareMeterWeek = 'SQUARE_METER_WEEK',
  Ton = 'TON',
  UnitOfAccount = 'UNIT_OF_ACCOUNT',
  Unknown = 'UNKNOWN',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type SivOperationUnitPriceUpdateInput = {
  operationId: Scalars['ID']['input'];
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type SivOperationUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  measurements: Array<SivOperationMeasurementInput>;
  name: Scalars['String']['input'];
  no: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  splits: SivOperationSplitsInput;
  totalMeasurementMeta?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<SivOperationUnit>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type SivPlanningCostSectionFinishInput = {
  sivId: Scalars['ID']['input'];
};

export type SivPlanningEmployeesSetInput = {
  employeeHSIds: Array<Scalars['ID']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivPlanningFlatRateUpdateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivPlanningFreelanceEmployeesSetInput = {
  employees: Array<SivFreelanceEmployeeInput>;
  sivId: Scalars['ID']['input'];
};

export type SivPlanningGroupFlatRateUpdateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  groupId: Scalars['ID']['input'];
};

export type SivPlanningMeta = {
  __typename?: 'SIVPlanningMeta';
  averageWage?: Maybe<Scalars['Float']['output']>;
  employees: SivEmployees;
  flatRate?: Maybe<Scalars['Float']['output']>;
  hourlyRateTemporaryWorker?: Maybe<Scalars['Float']['output']>;
  hourlySurcharge?: Maybe<Scalars['Float']['output']>;
  isCostSectionFinished: Scalars['Boolean']['output'];
  overheadRateTimeWorker?: Maybe<Scalars['Float']['output']>;
  overheadRateTrainee?: Maybe<Scalars['Float']['output']>;
  overheadRateWage?: Maybe<Scalars['Float']['output']>;
  subcontractors: Array<SivSubcontractorUnion>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalCostByMeasurement: Scalars['Float']['output'];
  totalHour: Scalars['Float']['output'];
  totalMaterial: Scalars['Float']['output'];
  totalMaterialCost: Scalars['Float']['output'];
};

export type SivPlanningSubcontractorCreateInput = {
  cashback?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  overhead?: InputMaybe<Scalars['Float']['input']>;
  sivId: Scalars['ID']['input'];
  totalOrderShare: Scalars['Float']['input'];
};

export type SivPlanningSubcontractorFromOfferValueCreateInput = {
  name: Scalars['String']['input'];
  offerValue: Scalars['Float']['input'];
  overhead?: InputMaybe<Scalars['Float']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivPlanningSubcontractorFromOfferValueUpdateInput = {
  name: Scalars['String']['input'];
  offerValue: Scalars['Float']['input'];
  overhead?: InputMaybe<Scalars['Float']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type SivPlanningSubcontractorRemoveInput = {
  subcontractorId: Scalars['ID']['input'];
};

export type SivPlanningSubcontractorUpdateInput = {
  cashback?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  overhead?: InputMaybe<Scalars['Float']['input']>;
  subcontractorId: Scalars['ID']['input'];
  totalOrderShare: Scalars['Float']['input'];
};

export type SivPlanningUpdateInput = {
  averageWage?: InputMaybe<Scalars['Float']['input']>;
  hourlyRateTemporaryWorker?: InputMaybe<Scalars['Float']['input']>;
  hourlySurcharge?: InputMaybe<Scalars['Float']['input']>;
  overheadRateTimeWorker?: InputMaybe<Scalars['Float']['input']>;
  overheadRateTrainee?: InputMaybe<Scalars['Float']['input']>;
  overheadRateWage?: InputMaybe<Scalars['Float']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivRecordingEmployeesSetInput = {
  employeeHSIds: Array<Scalars['ID']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivRecordingFlatRateUpdateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivRecordingFreelanceEmployeesSetInput = {
  employees: Array<SivFreelanceEmployeeInput>;
  sivId: Scalars['ID']['input'];
};

export type SivRecordingGroupFlatRateUpdateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  groupId: Scalars['ID']['input'];
};

export type SivRecordingMeta = {
  __typename?: 'SIVRecordingMeta';
  averageWage?: Maybe<Scalars['Float']['output']>;
  employees: SivEmployees;
  flatRate?: Maybe<Scalars['Float']['output']>;
  hourlyRateTemporaryWorker?: Maybe<Scalars['Float']['output']>;
  hourlySurcharge?: Maybe<Scalars['Float']['output']>;
  overheadRateTimeWorker?: Maybe<Scalars['Float']['output']>;
  overheadRateTrainee?: Maybe<Scalars['Float']['output']>;
  overheadRateWage?: Maybe<Scalars['Float']['output']>;
  subcontractors: Array<SivSubcontractorUnion>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalCostByMeasurement: Scalars['Float']['output'];
  totalHour: Scalars['Float']['output'];
  totalHourOfEmployees: Scalars['Float']['output'];
  totalHoursToBeDistributed: Scalars['Float']['output'];
  totalMaterial: Scalars['Float']['output'];
  totalMaterialCost: Scalars['Float']['output'];
};

export type SivRecordingSubcontractorInvoiceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SivRecordingSubcontractorInvoicesSetInput = {
  invoices: Array<SivRecordingSubcontractorInvoiceInput>;
  subcontractorId: Scalars['ID']['input'];
};

export type SivRecordingUpdateInput = {
  averageWage?: InputMaybe<Scalars['Float']['input']>;
  hourlyRateTemporaryWorker?: InputMaybe<Scalars['Float']['input']>;
  hourlySurcharge?: InputMaybe<Scalars['Float']['input']>;
  overheadRateTimeWorker?: InputMaybe<Scalars['Float']['input']>;
  overheadRateTrainee?: InputMaybe<Scalars['Float']['input']>;
  overheadRateWage?: InputMaybe<Scalars['Float']['input']>;
  sivId: Scalars['ID']['input'];
};

export type SivSubcontractor = SivSubcontractorInterface & {
  __typename?: 'SIVSubcontractor';
  cashPrice: Scalars['Float']['output'];
  cashback?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoices: Array<SivSubcontractorInvoice>;
  maximumInvoiceAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  overhead?: Maybe<Scalars['Float']['output']>;
  siv: Siv;
  totalOrderShare: Scalars['Float']['output'];
};

export type SivSubcontractorFromOfferValue = SivSubcontractorInterface & {
  __typename?: 'SIVSubcontractorFromOfferValue';
  id: Scalars['ID']['output'];
  invoices: Array<SivSubcontractorInvoice>;
  maximumOfferValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  offerValue: Scalars['Float']['output'];
  overhead?: Maybe<Scalars['Float']['output']>;
  siv: Siv;
};

export type SivSubcontractorInterface = {
  id: Scalars['ID']['output'];
  invoices: Array<SivSubcontractorInvoice>;
  name: Scalars['String']['output'];
  overhead?: Maybe<Scalars['Float']['output']>;
  siv: Siv;
};

export type SivSubcontractorInvoice = {
  __typename?: 'SIVSubcontractorInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  totalInvoice: Scalars['Float']['output'];
};

export type SivSubcontractorUnion = SivSubcontractor | SivSubcontractorFromOfferValue;

export type SapTransmissionProject = {
  __typename?: 'SapTransmissionProject';
  additionalName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  hsProjectNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSynced: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  profitCenter?: Maybe<ProfitCenter>;
  projectNumber: Scalars['ID']['output'];
  sivKeyData: SapTransmissionSivKeyData;
};

export enum SapTransmissionProjectType {
  CostCenterProject = 'COST_CENTER_PROJECT',
  MainProject = 'MAIN_PROJECT',
  PartProject = 'PART_PROJECT',
  SubProject = 'SUB_PROJECT'
}

export type SapTransmissionProjects = {
  __typename?: 'SapTransmissionProjects';
  pagination: Pagination;
  projects: Array<SapTransmissionProject>;
  selectedProfitCenters: Array<ProfitCenter>;
  selectedProjectColors: Array<ProjectsColorFilterMeta>;
  selectedProjectTypes: Array<SapTransmissionProjectsTypeFilterMeta>;
  selectedStatuses: Array<ProjectsStatusFilterMeta>;
};

export type SapTransmissionProjectsSorting = {
  direction: SortingDirection;
  field: SapTransmissionProjectsSortingField;
};

export enum SapTransmissionProjectsSortingField {
  HsProjectNumber = 'HS_PROJECT_NUMBER',
  ProjectProfitCenter = 'PROJECT_PROFIT_CENTER',
  ProjectStatus = 'PROJECT_STATUS'
}

export type SapTransmissionProjectsTypeFilterMeta = {
  __typename?: 'SapTransmissionProjectsTypeFilterMeta';
  count: Scalars['Int']['output'];
  type: SapTransmissionProjectType;
};

export type SapTransmissionSivKeyData = {
  __typename?: 'SapTransmissionSIVKeyData';
  planningTotalHour: Scalars['Float']['output'];
  recordingTotalCostByMeasurement: Scalars['Float']['output'];
  totalHourForecast: Scalars['Float']['output'];
};

export type SaveAnnotationsInput = {
  documentId: Scalars['ID']['input'];
};

export type SearchHit = {
  highlights: Array<ProjectSearchHighlight>;
  project: Project;
};

export type SearchHsProjectsResult = {
  __typename?: 'SearchHsProjectsResult';
  continuationToken?: Maybe<Scalars['String']['output']>;
  projects: Array<HsProject>;
};

export type SendAcceptanceReportEmailInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SendAcceptanceReportExternalLinkEmailInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SendConstructionNoteEmailInput = {
  /** Carbon copies of the mail */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content of the email. */
  content: Scalars['String']['input'];
  /** Id of the construction note. */
  id: Scalars['ID']['input'];
  /** Recipients of the email. */
  recipients: Array<Scalars['String']['input']>;
  /** Subject of the email. */
  subject: Scalars['String']['input'];
};

export type SendOfferEmailInput = {
  /** Carbon copies of the mail */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content of the email. */
  content: Scalars['String']['input'];
  /** Id of the offer. */
  id: Scalars['ID']['input'];
  /** Recipients of the email. */
  recipients: Array<Scalars['String']['input']>;
  /** Subject of the email. */
  subject: Scalars['String']['input'];
};

export type SendOvertimeEmailInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SendOvertimeExternalLinkEmailInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SendRiskAssessmentEmailInput = {
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SetViewerExpandedProfitCentersInput = {
  profitCenterIds: Array<Scalars['ID']['input']>;
};

export type SignatureInterface = {
  createdAt: Scalars['Date']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imagePath: Scalars['String']['output'];
};

export enum SignatureType {
  Customer = 'CUSTOMER',
  HeinrichSchmid = 'HEINRICH_SCHMID'
}

export type Sortable = {
  lastChangedDate: Scalars['Date']['output'];
  lastUsedDate?: Maybe<Scalars['Date']['output']>;
};

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecialPrecaution = PrecautionInterface & {
  __typename?: 'SpecialPrecaution';
  id: Scalars['ID']['output'];
  precautionCategory: PrecautionCategory;
  riskAssessment: RiskAssessment;
  title: Scalars['String']['output'];
};

export type SyncProjectInput = {
  id: Scalars['ID']['input'];
};

export type TimeTrackingAdditionalRowAddInput = {
  recordId: Scalars['ID']['input'];
};

export type TimeTrackingApprove = {
  __typename?: 'TimeTrackingApprove';
  approveType: TimeTrackingApproveType;
  approvedBy: User;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  weekYearProject: TimeTrackingWeekYearProject;
};

export enum TimeTrackingApproveType {
  CommercialApprove = 'COMMERCIAL_APPROVE',
  TechnicalApprove = 'TECHNICAL_APPROVE'
}

export type TimeTrackingBatchDeleteOperationInput = {
  entryId: Scalars['ID']['input'];
  lastUpdatedAt: Scalars['Date']['input'];
  /** This id can be anything. It's not related with SIV or something. It will be returned back in the response to match corresponding operation/action on client side. */
  operationId: Scalars['ID']['input'];
};

export type TimeTrackingBatchEmployeeInput = {
  employeeType: TimeTrackingBatchEmployeeType;
  /** It must be provided if the type is NOT_FROM_SAP and TEMPORARY_WORKER */
  name?: InputMaybe<Scalars['String']['input']>;
  /** It must be provided if the type is SAP */
  sapId?: InputMaybe<Scalars['String']['input']>;
};

export enum TimeTrackingBatchEmployeeType {
  NotFromSap = 'NOT_FROM_SAP',
  Sap = 'SAP',
  TemporaryWorker = 'TEMPORARY_WORKER'
}

export type TimeTrackingBatchInsertOperationInput = {
  break?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['Date']['input'];
  employee: TimeTrackingBatchEmployeeInput;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  indicator?: InputMaybe<TimeTrackingIndicator>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** This id can be anything. It's not related with SIV or something. It will be returned back in the response to match corresponding operation/action on client side. */
  operationId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeTrackingBatchOperationDeleteSuccessResponse = TimeTrackingBatchOperationResponse & {
  __typename?: 'TimeTrackingBatchOperationDeleteSuccessResponse';
  entryId: Scalars['ID']['output'];
  operationId: Scalars['ID']['output'];
};

export type TimeTrackingBatchOperationError = TimeTrackingBatchOperationForbiddenError | TimeTrackingBatchOperationOverlapError | TimeTrackingBatchOperationUnExpectedError | TimeTrackingBatchOperationValidationError;

export type TimeTrackingBatchOperationErrorResponse = TimeTrackingBatchOperationResponse & {
  __typename?: 'TimeTrackingBatchOperationErrorResponse';
  errors: Array<TimeTrackingBatchOperationError>;
  operationId: Scalars['ID']['output'];
};

export type TimeTrackingBatchOperationForbiddenError = {
  __typename?: 'TimeTrackingBatchOperationForbiddenError';
  /** It can be such as already approved error, stale last updated at error, no project access error etc. */
  reason: Scalars['String']['output'];
};

export type TimeTrackingBatchOperationInput = {
  deletes?: InputMaybe<Array<TimeTrackingBatchDeleteOperationInput>>;
  inserts?: InputMaybe<Array<TimeTrackingBatchInsertOperationInput>>;
  updates?: InputMaybe<Array<TimeTrackingBatchUpdateOperationInput>>;
};

export type TimeTrackingBatchOperationInsertSuccessResponse = TimeTrackingBatchOperationResponse & {
  __typename?: 'TimeTrackingBatchOperationInsertSuccessResponse';
  entry: TimeTrackingEntry;
  operationId: Scalars['ID']['output'];
};

export type TimeTrackingBatchOperationOverlapError = {
  __typename?: 'TimeTrackingBatchOperationOverlapError';
  overlaps: Array<TimeTrackingEntry>;
};

export type TimeTrackingBatchOperationResponse = {
  operationId: Scalars['ID']['output'];
};

export enum TimeTrackingBatchOperationType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

export type TimeTrackingBatchOperationUnExpectedError = {
  __typename?: 'TimeTrackingBatchOperationUnExpectedError';
  message: Scalars['String']['output'];
};

export type TimeTrackingBatchOperationUpdateSuccessResponse = TimeTrackingBatchOperationResponse & {
  __typename?: 'TimeTrackingBatchOperationUpdateSuccessResponse';
  entry: TimeTrackingEntry;
  operationId: Scalars['ID']['output'];
};

export type TimeTrackingBatchOperationValidationError = {
  __typename?: 'TimeTrackingBatchOperationValidationError';
  field: TimeTrackingEntryField;
  message: Scalars['String']['output'];
};

export type TimeTrackingBatchUpdateOperationInput = {
  break?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  entryId: Scalars['ID']['input'];
  indicator?: InputMaybe<TimeTrackingIndicator>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** This id can be anything. It's not related with SIV or something. It will be returned back in the response to match corresponding operation/action on client side. */
  operationId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeTrackingCount = {
  __typename?: 'TimeTrackingCount';
  count: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
};

export type TimeTrackingEmployee = {
  name: Scalars['String']['output'];
};

export type TimeTrackingEmployeeAndEntry = {
  __typename?: 'TimeTrackingEmployeeAndEntry';
  employee: TimeTrackingEmployee;
  entry: TimeTrackingEntry;
  /** This id doesn't exist in reality. It will just identify the employee with random id */
  virtualEmployeeId: Scalars['ID']['output'];
};

export type TimeTrackingEntry = {
  __typename?: 'TimeTrackingEntry';
  /** Break in minutes */
  break?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  /** The day of the entry */
  date: Scalars['Date']['output'];
  /** The employee of the entry */
  employee: TimeTrackingEmployee;
  /** The end time of the entry in minutes. As example, the 00:00 is 0, 09:00 is 540, 13:30 is 810 and so on. */
  endTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Indicator of the entry */
  indicator?: Maybe<TimeTrackingIndicator>;
  /** Last SAP Transmission of this entry */
  lastSAPTransmission?: Maybe<TimeTrackingSapTransmission>;
  /** The latest revision list that have been made for this entry */
  latestRevisions: Array<TimeTrackingRevision>;
  /** The note of the entry */
  note?: Maybe<TimeTrackingNote>;
  /** The project of the entry */
  project: Project;
  /** The row that this entry belongs to */
  row: TimeTrackingRow;
  /** The starting time of the entry in minutes. As example, the 00:00 is 0, 09:00 is 540, 13:30 is 810 and so on. */
  startTime?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  viewerCanRemoveValues: Scalars['Boolean']['output'];
  viewerCanTransmitToSAP: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export enum TimeTrackingEntryField {
  Break = 'BREAK',
  EndTime = 'END_TIME',
  Indicator = 'INDICATOR',
  Note = 'NOTE',
  StartTime = 'START_TIME'
}

export type TimeTrackingEntryIndicatorSaveInput = {
  date: Scalars['Date']['input'];
  /** Send as null to remove an existing indicator */
  indicator?: InputMaybe<TimeTrackingIndicator>;
  rowId: Scalars['ID']['input'];
};

export type TimeTrackingEntryMultiRemoveInput = {
  entryIds: Array<Scalars['ID']['input']>;
};

export type TimeTrackingEntryNoteSaveInput = {
  /** Send as null to remove an existing note */
  content?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  rowId: Scalars['ID']['input'];
};

export enum TimeTrackingEntryTimeField {
  Break = 'BREAK',
  EndTime = 'END_TIME',
  StartTime = 'START_TIME'
}

export type TimeTrackingEntryTimeMultiRemoveInput = {
  entryIds: Array<Scalars['ID']['input']>;
  field: TimeTrackingEntryTimeField;
};

export type TimeTrackingEntryTimeRemoveInput = {
  entryId: Scalars['ID']['input'];
  field: TimeTrackingEntryTimeField;
};

export type TimeTrackingEntryTimeSaveInput = {
  date: Scalars['Date']['input'];
  field: TimeTrackingEntryTimeField;
  rowId: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
};

export type TimeTrackingEntryTimeSaveResult = {
  __typename?: 'TimeTrackingEntryTimeSaveResult';
  entries: Array<TimeTrackingEntry>;
  overlapped: Scalars['Boolean']['output'];
};

export enum TimeTrackingIndicator {
  A = 'A',
  A0 = 'A0',
  A1 = 'A1',
  A2 = 'A2',
  B = 'B',
  E = 'E',
  E5 = 'E5',
  E6 = 'E6',
  F = 'F',
  K = 'K',
  K2 = 'K2',
  K6 = 'K6',
  K9 = 'K9',
  O = 'O',
  O1 = 'O1',
  O3 = 'O3',
  O4 = 'O4',
  O5 = 'O5',
  O6 = 'O6',
  O7 = 'O7',
  P = 'P',
  Ra = 'RA',
  Rb = 'RB',
  Rc = 'RC',
  Rd = 'RD',
  Re = 'RE',
  Rf = 'RF',
  Rg = 'RG',
  Rk = 'RK',
  Rl = 'RL',
  Rm = 'RM',
  Rn = 'RN',
  Ro = 'RO',
  Rp = 'RP',
  S = 'S',
  S1 = 'S1',
  S2 = 'S2',
  T = 'T',
  T8 = 'T8',
  T9 = 'T9',
  U = 'U',
  U1 = 'U1',
  U2 = 'U2',
  U3 = 'U3',
  U6 = 'U6',
  U7 = 'U7',
  V = 'V',
  V5 = 'V5',
  V9 = 'V9',
  W = 'W'
}

export type TimeTrackingIndicatorWithDescription = {
  __typename?: 'TimeTrackingIndicatorWithDescription';
  description: Scalars['String']['output'];
  indicator: TimeTrackingIndicator;
};

export type TimeTrackingNote = {
  __typename?: 'TimeTrackingNote';
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type TimeTrackingProjectMultiApproveInput = {
  approveType: TimeTrackingApproveType;
  projectIds: Array<Scalars['ID']['input']>;
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TimeTrackingRemoveWeekYearProjectInput = {
  projectId: Scalars['ID']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TimeTrackingResponsibleToggleInput = {
  weekRecordId: Scalars['ID']['input'];
};

export type TimeTrackingRevision = {
  __typename?: 'TimeTrackingRevision';
  createdAt: Scalars['Date']['output'];
  entry: TimeTrackingEntry;
  field: TimeTrackingEntryField;
  id: Scalars['ID']['output'];
  user: User;
};

export type TimeTrackingRow = {
  __typename?: 'TimeTrackingRow';
  entries: Array<TimeTrackingEntry>;
  id: Scalars['ID']['output'];
  record: TimeTrackingWeekRecord;
  viewerCanAddEntry: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
};

export type TimeTrackingRowRemoveInput = {
  rowId: Scalars['ID']['input'];
};

export type TimeTrackingSapEmployee = TimeTrackingEmployee & {
  __typename?: 'TimeTrackingSAPEmployee';
  avatar?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profitCenter?: Maybe<ProfitCenter>;
  role: Scalars['String']['output'];
  sapId: Scalars['String']['output'];
};

export type TimeTrackingSapEmployeeWeekRecordAddInput = {
  projectId: Scalars['ID']['input'];
  sapEmployeeId: Scalars['ID']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TimeTrackingSapTransmission = {
  __typename?: 'TimeTrackingSAPTransmission';
  createdAt: Scalars['Date']['output'];
  entry: TimeTrackingEntry;
  id: Scalars['ID']['output'];
  user: User;
};

export type TimeTrackingSapTransmitErrorResponse = {
  __typename?: 'TimeTrackingSAPTransmitErrorResponse';
  message: Scalars['String']['output'];
};

export type TimeTrackingSapTransmitInput = {
  entryIds: Array<Scalars['ID']['input']>;
  sapPassword: Scalars['String']['input'];
  sapUsername: Scalars['String']['input'];
};

export type TimeTrackingSapTransmitInvalidCredentials = {
  __typename?: 'TimeTrackingSAPTransmitInvalidCredentials';
  reason: Scalars['String']['output'];
};

export type TimeTrackingSapTransmitPayload = TimeTrackingSapTransmitErrorResponse | TimeTrackingSapTransmitInvalidCredentials | TimeTrackingSapTransmitResult;

export type TimeTrackingSapTransmitResult = {
  __typename?: 'TimeTrackingSAPTransmitResult';
  failed: Array<TimeTrackingEntry>;
  succeed: Array<TimeTrackingEntry>;
};

export enum TimeTrackingSortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TimeTrackingSwitchMultiSapEmployeeInput = {
  currentEmployeeId: Scalars['ID']['input'];
  newEmployeeId: Scalars['ID']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TimeTrackingSwitchProjectInput = {
  currentProjectId: Scalars['ID']['input'];
  newProjectId: Scalars['ID']['input'];
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TimeTrackingSwitchSapEmployeeInput = {
  recordId: Scalars['ID']['input'];
  sapEmployeeId: Scalars['ID']['input'];
};

export type TimeTrackingUnknownEmployee = TimeTrackingEmployee & {
  __typename?: 'TimeTrackingUnknownEmployee';
  name: Scalars['String']['output'];
  type: TimeTrackingUnknownEmployeeType;
};

export enum TimeTrackingUnknownEmployeeType {
  NotFromSap = 'NOT_FROM_SAP',
  TemporaryWorker = 'TEMPORARY_WORKER'
}

export type TimeTrackingUnknownEmployeeUpdateInput = {
  name: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
};

export type TimeTrackingUnknownEmployeeWeekRecordAddInput = {
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  type: TimeTrackingUnknownEmployeeType;
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TimeTrackingWeekRangeInput = {
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TimeTrackingWeekRecord = {
  __typename?: 'TimeTrackingWeekRecord';
  employee: TimeTrackingEmployee;
  id: Scalars['ID']['output'];
  project: Project;
  responsible: Scalars['Boolean']['output'];
  rows: Array<TimeTrackingRow>;
  viewerCanAddRow: Scalars['Boolean']['output'];
  viewerCanRemoveRow: Scalars['Boolean']['output'];
  viewerCanSwitchProject: Scalars['Boolean']['output'];
  viewerCanToggleResponsible: Scalars['Boolean']['output'];
  viewerCanUpdateEmployee: Scalars['Boolean']['output'];
  week: Scalars['Int']['output'];
  weekYearProject: TimeTrackingWeekYearProject;
  weekYearSAPEmployee?: Maybe<TimeTrackingWeekYearSapEmployee>;
  year: Scalars['Int']['output'];
};

export type TimeTrackingWeekRecordSwitchProjectInput = {
  newProjectId: Scalars['ID']['input'];
  weekRecordId: Scalars['ID']['input'];
};

export type TimeTrackingWeekYearProject = {
  __typename?: 'TimeTrackingWeekYearProject';
  approvals: Array<TimeTrackingApprove>;
  digitalSalaryHistory: Array<DigitalSalaryHistoryItem>;
  employeeEntries: Array<TimeTrackingEmployeeAndEntry>;
  id: Scalars['ID']['output'];
  project: Project;
  records: Array<TimeTrackingWeekRecord>;
  viewerCanAccessProject: Scalars['Boolean']['output'];
  viewerCanAddEntry: Scalars['Boolean']['output'];
  viewerCanAddWeekRecord: Scalars['Boolean']['output'];
  viewerCanMakeCommercialApprove: Scalars['Boolean']['output'];
  viewerCanMakeTechnicalApprove: Scalars['Boolean']['output'];
  viewerCanRemove: Scalars['Boolean']['output'];
  viewerCanSwitchProject: Scalars['Boolean']['output'];
  week: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type TimeTrackingWeekYearSapEmployee = {
  __typename?: 'TimeTrackingWeekYearSAPEmployee';
  employee: TimeTrackingSapEmployee;
  id: Scalars['ID']['output'];
  projectApprovals: Array<TimeTrackingApprove>;
  records: Array<TimeTrackingWeekRecord>;
  viewerCanAddWeekRecord: Scalars['Boolean']['output'];
  viewerCanRemoveWeekRecord: Scalars['Boolean']['output'];
  viewerCanSwitchEmployee: Scalars['Boolean']['output'];
  week: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type TimesheetGeneratePdfByEmployeesInRange = {
  employeeIds: Array<Scalars['ID']['input']>;
  endDate: Scalars['Date']['input'];
  profitCenterId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

export type TimesheetGeneratePdfByEmployeesInRangeResult = {
  __typename?: 'TimesheetGeneratePdfByEmployeesInRangeResult';
  url: Scalars['String']['output'];
};

export type TimesheetGeneratePdfByProjectsInRange = {
  endDate: Scalars['Date']['input'];
  profitCenterId: Scalars['ID']['input'];
  projectIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};

export type TimesheetGeneratePdfByProjectsInRangeResult = {
  __typename?: 'TimesheetGeneratePdfByProjectsInRangeResult';
  url: Scalars['String']['output'];
};

export type TimesheetProject = {
  __typename?: 'TimesheetProject';
  entries: Array<TimeTrackingEntry>;
  project: Project;
};


export type TimesheetProjectEntriesArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type TimesheetProjectSorting = {
  direction: TimeTrackingSortingDirection;
  type: TimesheetProjectSortingType;
};

export enum TimesheetProjectSortingType {
  HsProjectNumber = 'HS_PROJECT_NUMBER',
  Name = 'NAME'
}

export type TimesheetSapEmployee = {
  __typename?: 'TimesheetSAPEmployee';
  employee: Employee;
  entries: Array<TimeTrackingEntry>;
};


export type TimesheetSapEmployeeEntriesArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type TimesheetSelectionSapEmployeesSorting = {
  direction: TimeTrackingSortingDirection;
  type: TimesheetSelectionSapEmployeesSortingType;
};

export enum TimesheetSelectionSapEmployeesSortingType {
  Name = 'NAME',
  ProfitCenterId = 'PROFIT_CENTER_ID',
  SapId = 'SAP_ID'
}

export type ToggleShowSubProjectHoursInput = {
  id: Scalars['ID']['input'];
};

export type UnknownProjectImportError = {
  __typename?: 'UnknownProjectImportError';
  id: Scalars['ID']['output'];
  reason: UnknownProjectImportErrorReason;
};

export enum UnknownProjectImportErrorReason {
  FetchFailed = 'FETCH_FAILED',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  NotFound = 'NOT_FOUND'
}

export type UpdateCatalogueInput = {
  /** ID of the catalogue. */
  catalogue: Scalars['String']['input'];
  /** Catalogue name. */
  name: Scalars['String']['input'];
};

export type UpdateFolderForFrameworkInput = {
  /** Is this folder's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Category of the offer. */
  category: Scalars['ID']['input'];
  /** Id of the offer. */
  folder: Scalars['ID']['input'];
  /** Measurements of folder */
  measurements: Array<UpdateMeasurementInput>;
  /** Name of the folder. */
  name: Scalars['String']['input'];
  /** Note for the folder */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<OperationUnit>;
};

export type UpdateFolderForFreeFormInput = {
  /** Is this folder's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the offer. */
  folder: Scalars['ID']['input'];
  /** Measurements of folder */
  measurements: Array<UpdateMeasurementInput>;
  /** Name of the folder. */
  name: Scalars['String']['input'];
  /** Note for the folder */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<OperationUnit>;
};

export type UpdateFolderOperationInput = {
  /** Is this operation's calculations are approximate? */
  approximate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the operation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Measurements of operation */
  measurements: Array<UpdateMeasurementInput>;
  /** Name of the operation. */
  name: Scalars['String']['input'];
  /** Note for the operation */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Id of the operation. */
  operation: Scalars['ID']['input'];
  /** Is this operation optional */
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alias for the part no */
  partNoAlias?: InputMaybe<Scalars['String']['input']>;
  /** Operation payment input. Please send totalPrice flat is true, otherwise please send discount/surcharge value and type. If you do not have any price adjustment please do not send this input at all. */
  payment?: InputMaybe<OperationPaymentInput>;
  /** Price for the operation. */
  price: Scalars['Float']['input'];
  unit: OperationUnit;
};

export type UpdateMeasurementInput = {
  /** ID of the measurement. */
  id?: InputMaybe<Scalars['String']['input']>;
  meta: Array<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  /** Offer name. */
  name: Scalars['String']['input'];
  /** Is subtraction enabled */
  subtraction: Scalars['Boolean']['input'];
  /** Total measurement */
  total: Scalars['Float']['input'];
  /** Total measurement meta for the operation. */
  totalMeta: Scalars['String']['input'];
};

export type UpdateOfferCalculationInput = {
  /** Extra prices of the offer. */
  extraPrices: Array<ExtraPriceInput>;
  /** ID of the offer. */
  offer: Scalars['ID']['input'];
  /** Tax rate of the offer. */
  taxRate: Scalars['Float']['input'];
};

export type UpdateOfferSortingForFrameworkInput = {
  /** Id of the item needs to be updated */
  id: Scalars['String']['input'];
  /** Sort of the item */
  sort: Scalars['Int']['input'];
  /** Type of the sorted items. */
  type: OfferSortableType;
};

export type UpdateOfferSortingForFreeFormInput = {
  /** Drop destination of item */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** Id of the item needs to be updated */
  id: Scalars['String']['input'];
  /** Sort of the item */
  sort: Scalars['Int']['input'];
  /** Type of the sorted item. */
  type: OfferSortableType;
};

export type UpdateOperationInput = {
  /** Description of the operation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the operation. */
  name: Scalars['String']['input'];
  /** Id of the operation. */
  operation: Scalars['ID']['input'];
  /** Price for the operation. */
  price: Scalars['Float']['input'];
  unit: OperationUnit;
};

export type UpdateProjectStatusInput = {
  project: Scalars['ID']['input'];
  status: ProjectStatus;
};

/** Response for a update sorting action. */
export type UpdateSortingResult = {
  __typename?: 'UpdateSortingResult';
  /** Status of the action. */
  status: Scalars['Boolean']['output'];
};

export type UpdateTaxRateInput = {
  /** ID of the offer. */
  offer: Scalars['String']['input'];
  /** TaxRate for the offer. */
  taxRate: Scalars['Float']['input'];
};

export type UploadAcceptanceReportSignatureInput = {
  acceptanceReport: Scalars['ID']['input'];
  fullName: Scalars['String']['input'];
  type: AcceptanceReportSignatureType;
};

export type UploadManualPdfToAcceptanceReportInput = {
  acceptanceReport: Scalars['ID']['input'];
};

export type UploadManualPdfToOvertimeInput = {
  overtime: Scalars['ID']['input'];
};

export type UploadOvertimeSignatureInput = {
  fullName: Scalars['String']['input'];
  overtime: Scalars['ID']['input'];
  type: SignatureType;
};

export type UploadRiskAssessmentSignatureInput = {
  fullName: Scalars['String']['input'];
  riskAssessment: Scalars['ID']['input'];
  type: RiskAssessmentSignatureType;
};

export type User = {
  __typename?: 'User';
  /** First name of the user */
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Last name of the user */
  lastName: Scalars['String']['output'];
};

export type Viewer = {
  __typename?: 'Viewer';
  accessToken: Scalars['String']['output'];
  bulkJobs: Array<DriveBulkJob>;
  digitalSalaryRole?: Maybe<DigitalSalaryRole>;
  displayName: Scalars['String']['output'];
  draftProject: Project;
  /** Returns global drive preferences of user */
  drivePreferences: ViewerDrivePreferences;
  /** Returns drive preferences of user within a project */
  driveProjectPreference?: Maybe<ViewerProjectDrivePreferences>;
  email: Scalars['String']['output'];
  faxNumber?: Maybe<Scalars['String']['output']>;
  featureFlagContext: Scalars['LaunchDarklyUserContext']['output'];
  firstName: Scalars['String']['output'];
  hsId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** The last 5 projects viewed by the user, ordered by most recent first */
  lastViewedProjects: Array<Project>;
  mainProfitCenter?: Maybe<ProfitCenter>;
  mobile?: Maybe<Scalars['String']['output']>;
  overtimePreferences: ViewerOvertimePreferences;
  phone?: Maybe<Scalars['String']['output']>;
  preferredLanguageCode: LanguageCode;
  profitCenters: Array<ProfitCenter>;
  projectCountsByStatus: Array<ProjectsStatusFilterMeta>;
  projectSearchPreferences: ViewerProjectSearchPreferences;
  /** This field returns hs person id of the viewer. This field is just placeholder field. It does not give you the real SAP id */
  sapId?: Maybe<Scalars['String']['output']>;
  scopes: ViewerUserScopes;
  signature?: Maybe<Scalars['String']['output']>;
  signatureEmail?: Maybe<Scalars['String']['output']>;
  subscribedToManualEmails: Scalars['Boolean']['output'];
  timeTrackingProjects: Array<TimeTrackingWeekYearProject>;
  watchedEvents: Array<Event>;
};


export type ViewerDriveProjectPreferenceArgs = {
  projectId: Scalars['ID']['input'];
};


export type ViewerProfitCentersArgs = {
  sorted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ViewerTimeTrackingProjectsArgs = {
  profitCenterId?: InputMaybe<Scalars['ID']['input']>;
  week: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type ViewerDrivePreferences = {
  __typename?: 'ViewerDrivePreferences';
  id: Scalars['ID']['output'];
  viewPreferences: DriveViewPreferences;
};

export type ViewerDrivePreferencesInput = {
  viewPreferences: DriveViewPreferencesInput;
};

export type ViewerLanguageUpdateInput = {
  code: LanguageCode;
};

export type ViewerLanguageUpdateResult = {
  __typename?: 'ViewerLanguageUpdateResult';
  languages: Array<Language>;
  viewer: Viewer;
};

export type ViewerOvertimePreferences = {
  __typename?: 'ViewerOvertimePreferences';
  employeeAutomaticRoleSelection: Scalars['Boolean']['output'];
};

export type ViewerProjectDrivePreferenceInput = {
  entrySorting?: InputMaybe<DriveEntrySortingInput>;
  folderSorting?: InputMaybe<DriveFolderSortingInput>;
  projectId: Scalars['ID']['input'];
  selectedFolderId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerProjectDrivePreferences = {
  __typename?: 'ViewerProjectDrivePreferences';
  entrySorting: DriveEntrySorting;
  folderSorting: DriveFolderSorting;
  id: Scalars['ID']['output'];
  selectedFolder?: Maybe<DriveFolder>;
};

export type ViewerProjectSearchFilterPreferences = {
  __typename?: 'ViewerProjectSearchFilterPreferences';
  profitCenter?: Maybe<Array<Scalars['ID']['output']>>;
  projectColor?: Maybe<Array<ProjectColor>>;
  projectStatus?: Maybe<Array<ProjectStatus>>;
  projectType?: Maybe<Array<ProjectType>>;
};

export enum ViewerProjectSearchFilterPreferencesAction {
  Insert = 'INSERT',
  Remove = 'REMOVE'
}

export enum ViewerProjectSearchGroupByPreference {
  ProfitCenter = 'PROFIT_CENTER',
  ProjectDependency = 'PROJECT_DEPENDENCY'
}

export type ViewerProjectSearchGroupingPreferences = {
  __typename?: 'ViewerProjectSearchGroupingPreferences';
  groupedBy: ViewerProjectSearchGroupByPreference;
  ids: Array<Scalars['ID']['output']>;
};

export type ViewerProjectSearchPreferences = {
  __typename?: 'ViewerProjectSearchPreferences';
  /** This field is used for displaying the profit center list shown to clients for the project list filter. */
  expandedProfitCenters: Array<ProfitCenter>;
  filter: ViewerProjectSearchFilterPreferences;
  /** This field is used for store the latest grouping preference of the user */
  grouping?: Maybe<ViewerProjectSearchGroupingPreferences>;
  projectColumns: Array<ProjectSearchColumn>;
  sorting: ViewerProjectSearchSortingPreferences;
  /** This field is used for store the latest tab preference of the user */
  tab: ViewerProjectSearchTabPreference;
};

export type ViewerProjectSearchSortingPreferences = {
  __typename?: 'ViewerProjectSearchSortingPreferences';
  direction: SortingDirection;
  field: ProjectSearchSortingField;
};

export enum ViewerProjectSearchTabPreference {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE',
  Subscribed = 'SUBSCRIBED'
}

export type ViewerScope = {
  __typename?: 'ViewerScope';
  isPermitted: Scalars['Boolean']['output'];
  missingScopeNames: Array<Scalars['String']['output']>;
};

export type ViewerSetProjectViewedInput = {
  projectId: Scalars['ID']['input'];
};

export type ViewerUserScopes = {
  __typename?: 'ViewerUserScopes';
  accessDobnerBonusCalculation: ViewerScope;
  accessHoltkampBonusCalculation: ViewerScope;
  accessProjectCalendar: ViewerScope;
  accessSIVEmployeePlanning: ViewerScope;
  accessSIVEmployeeRecording: ViewerScope;
  accessSIVMaterialPlanning: ViewerScope;
  accessSIVMaterialRecording: ViewerScope;
  accessSIVPerformancePlanning: ViewerScope;
  accessSIVPerformanceRecording: ViewerScope;
  accessSIVSubcontractorPlanning: ViewerScope;
  accessSIVSubcontractorRecording: ViewerScope;
  accessTLK: ViewerScope;
  addOfferOperationFromTLK: ViewerScope;
  addSIVOperationFromTLK: ViewerScope;
  approveCommercial: ViewerScope;
  approveTechnical: ViewerScope;
  createAcceptanceReportDocument: ViewerScope;
  createAndEditProjectCalendarActivity: ViewerScope;
  createConcernDocument: ViewerScope;
  createConstructionDiary: ViewerScope;
  createConstructionNoteDocument: ViewerScope;
  createCustomFileDocument: ViewerScope;
  createCustomFolder: ViewerScope;
  createObstructionDocument: ViewerScope;
  createOfferDocument: ViewerScope;
  createOvertimeDocument: ViewerScope;
  createQsstDocument: ViewerScope;
  createRiskAssessmentDocument: ViewerScope;
  createSIVAdditionalOperation: ViewerScope;
  createSIVBillingAttachmentDocument: ViewerScope;
  downloadAcceptanceReportDocument: ViewerScope;
  downloadConcernDocument: ViewerScope;
  downloadConstructionDiary: ViewerScope;
  downloadConstructionNoteDocument: ViewerScope;
  downloadCustomFileDocument: ViewerScope;
  downloadObstructionDocument: ViewerScope;
  downloadOfferDocument: ViewerScope;
  downloadOvertimeDocument: ViewerScope;
  downloadQsstDocument: ViewerScope;
  downloadRiskAssessmentDocument: ViewerScope;
  downloadSIVBillingAttachmentDocument: ViewerScope;
  editConstructionDiary: ViewerScope;
  editProjectColors: ViewerScope;
  importProject: ViewerScope;
  importSIV: ViewerScope;
  moveCustomFileDocument: ViewerScope;
  removeDocumentsAdvanced: ViewerScope;
  removeDocumentsSimple: ViewerScope;
  sendAcceptanceReportDocumentAttachment: ViewerScope;
  sendAcceptanceReportDocumentSignatureMail: ViewerScope;
  sendConcernDocumentAttachment: ViewerScope;
  sendConstructionDiaryAttachment: ViewerScope;
  sendConstructionDiarySignature: ViewerScope;
  sendConstructionNoteDocumentAttachment: ViewerScope;
  sendCustomFileDocumentAttachment: ViewerScope;
  sendObstructionDocumentAttachment: ViewerScope;
  sendOfferDocumentAttachment: ViewerScope;
  sendOvertimeDocumentAttachment: ViewerScope;
  sendOvertimeDocumentSignatureMail: ViewerScope;
  sendQsstDocumentAttachment: ViewerScope;
  sendQsstDocumentSignatureMail: ViewerScope;
  sendRiskAssessmentDocumentAttachment: ViewerScope;
  sendSIVBillingAttachmentDocumentAttachment: ViewerScope;
  setUpProjectCalendar: ViewerScope;
  signAcceptanceReportDocument: ViewerScope;
  signConcernDocument: ViewerScope;
  signConstructionDiary: ViewerScope;
  signObstructionDocument: ViewerScope;
  signOvertimeDocument: ViewerScope;
  signRiskAssessmentDocument: ViewerScope;
  transmitKeyDataToSap: ViewerScope;
  transmitToSAP: ViewerScope;
  updateAcceptanceReportDocument: ViewerScope;
  updateConcernDocument: ViewerScope;
  updateConstructionNoteDocument: ViewerScope;
  updateCustomFileDocument: ViewerScope;
  updateObstructionDocument: ViewerScope;
  updateOfferDocument: ViewerScope;
  updateOvertimeDocument: ViewerScope;
  updateProject: ViewerScope;
  updateProjectStatus: ViewerScope;
  updateQsstDocument: ViewerScope;
  updateRiskAssessmentDocument: ViewerScope;
  updateSIVDiscount: ViewerScope;
  updateSIVPartProjects: ViewerScope;
  updateSIVPerformancePlanning: ViewerScope;
  updateSIVPerformanceRecording: ViewerScope;
  viewAcceptanceReportDocument: ViewerScope;
  viewConcernDocument: ViewerScope;
  viewConstructionDiary: ViewerScope;
  viewConstructionNoteDocument: ViewerScope;
  viewConstructionSiteDocumentationFolder: ViewerScope;
  viewCustomFileDocument: ViewerScope;
  viewDigitalSalaryOverview: ViewerScope;
  viewObstructionDocument: ViewerScope;
  viewOfferDocument: ViewerScope;
  viewOvertimeDocument: ViewerScope;
  viewQsstDocument: ViewerScope;
  viewRiskAssessmentDocument: ViewerScope;
  viewSIVBillingAttachmentDocument: ViewerScope;
  viewSIVCostBar: ViewerScope;
  viewSIVCostOverhead: ViewerScope;
  viewSIVDiagram: ViewerScope;
  viewSIVDiscount: ViewerScope;
  viewSIVOverview: ViewerScope;
  viewSIVPartProjects: ViewerScope;
  viewSIVPerformanceStatusBar: ViewerScope;
  viewSIVPrices: ViewerScope;
  viewSIVRevenueBar: ViewerScope;
  viewTimeTrackingOverview: ViewerScope;
};

export type WatchEventsInput = {
  events: Array<Event>;
};

export enum WeatherType {
  ClearSunny = 'CLEAR_SUNNY',
  Cloudy = 'CLOUDY',
  Fog = 'FOG',
  PartlyClouded = 'PARTLY_CLOUDED',
  Rain = 'RAIN',
  SevereWeatherWarning = 'SEVERE_WEATHER_WARNING',
  Sleet = 'SLEET',
  Snow = 'SNOW',
  Stormy = 'STORMY',
  Thunderstorm = 'THUNDERSTORM'
}

export enum WorkerRole {
  Fa = 'FA',
  Helper = 'HELPER',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  Master = 'MASTER',
  Va = 'VA'
}
